/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AutheticateClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    login(authModel: AuthModel , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/auth/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @return OK
     */
    logout(  cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/auth/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }
}

export class FacetsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    index(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<IFacetGroup> {
        let url_ = this.baseUrl + "/admin/api/repositories/facets/{repository}/{item}-facets";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<IFacetGroup> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IFacetGroup.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IFacetGroup>(<any>null);
    }

    /**
     * @return No Content
     */
    index2(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/api/repositories/facets/{repository}/{item}-facets";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex2(_response);
        });
    }

    protected processIndex2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No Content
     */
    index3(repository: string, item: string, facets: IFacetGroup , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/api/repositories/facets/{repository}/{item}-facets";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(facets);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex3(_response);
        });
    }

    protected processIndex3(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No Content
     */
    index4(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/api/repositories/facets/{repository}/{item}-facets";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex4(_response);
        });
    }

    protected processIndex4(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class IndexClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    status(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_status/{repository}/{item}-index";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @return OK
     */
    instanceTypes(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<any[]> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_instance_types/{repository}/{item}-index";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInstanceTypes(_response);
        });
    }

    protected processInstanceTypes(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(<any>null);
    }

    /**
     * @return OK
     */
    buildTypes(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<any[]> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_build_types/{repository}/{item}-index";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuildTypes(_response);
        });
    }

    protected processBuildTypes(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(<any>null);
    }

    /**
     * @return OK
     */
    buildActions(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<{ [key: string]: string[]; }> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_build_actions/{repository}/{item}-index";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuildActions(_response);
        });
    }

    protected processBuildActions(response: AxiosResponse): Promise<{ [key: string]: string[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key] !== undefined ? resultData200[key] : [];
                }
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string[]; }>(<any>null);
    }

    /**
     * @return OK
     */
    fieldTypes(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<any[]> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_field_types/{repository}/{item}-index";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFieldTypes(_response);
        });
    }

    protected processFieldTypes(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(<any>null);
    }

    /**
     * @return OK
     */
    extensionTypes(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<any[]> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_extension_types/{repository}/{item}-index";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExtensionTypes(_response);
        });
    }

    protected processExtensionTypes(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(<any>null);
    }

    /**
     * @return No Content
     */
    buildIndex(repository: string, item: string, instance: string, build: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/api/repositories/build/{repository}/{item}-index/{instance}/{build}";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        if (instance === undefined || instance === null)
            throw new Error("The parameter 'instance' must be defined.");
        url_ = url_.replace("{instance}", encodeURIComponent("" + instance));
        if (build === undefined || build === null)
            throw new Error("The parameter 'build' must be defined.");
        url_ = url_.replace("{build}", encodeURIComponent("" + build));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuildIndex(_response);
        });
    }

    protected processBuildIndex(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No Content
     */
    resumeBuildIndex(repository: string, item: string, instance: string, meta: { [key: string]: string; } , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/api/repositories/resume/{repository}/{item}-index/{instance}";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        if (instance === undefined || instance === null)
            throw new Error("The parameter 'instance' must be defined.");
        url_ = url_.replace("{instance}", encodeURIComponent("" + instance));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(meta);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResumeBuildIndex(_response);
        });
    }

    protected processResumeBuildIndex(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return OK
     */
    index(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<IIndex> {
        let url_ = this.baseUrl + "/admin/api/repositories/index/{repository}/{item}-index";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<IIndex> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IIndex.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IIndex>(<any>null);
    }

    /**
     * @return No Content
     */
    index2(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/api/repositories/index/{repository}/{item}-index";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex2(_response);
        });
    }

    protected processIndex2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No Content
     */
    index3(repository: string, item: string, index: IIndex , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/api/repositories/index/{repository}/{item}-index";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(index);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex3(_response);
        });
    }

    protected processIndex3(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No Content
     */
    index4(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/api/repositories/index/{repository}/{item}-index";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex4(_response);
        });
    }

    protected processIndex4(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return OK
     */
    fieldSources(builderType: string, settings: { [key: string]: string; } , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_field_sources/{builderType}";
        if (builderType === undefined || builderType === null)
            throw new Error("The parameter 'builderType' must be defined.");
        url_ = url_.replace("{builderType}", encodeURIComponent("" + builderType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFieldSources(_response);
        });
    }

    protected processFieldSources(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class MailZipClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return No Content
     */
    sendMail(obj: SendMailDto , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/mailzip/SendMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(obj);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMail(_response);
        });
    }

    protected processSendMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class OrderingListRequstProductClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return No Content
     */
    execute(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/orderinglist/sendpendingemails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecute(_response);
        });
    }

    protected processExecute(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    getIsOutlet(product: ProductQuery , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/product/GetIsOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsOutlet(_response);
        });
    }

    protected processGetIsOutlet(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ProductFeedClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    test(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/productfeed/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return OK
     */
    startTask(  cancelToken?: CancelToken | undefined): Promise<ProductFeedStatusEventArgs> {
        let url_ = this.baseUrl + "/api/productfeed/task/start";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartTask(_response);
        });
    }

    protected processStartTask(response: AxiosResponse): Promise<ProductFeedStatusEventArgs> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductFeedStatusEventArgs.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductFeedStatusEventArgs>(<any>null);
    }

    /**
     * @return OK
     */
    taskStatus(  cancelToken?: CancelToken | undefined): Promise<ProductFeedStatusEventArgs> {
        let url_ = this.baseUrl + "/api/productfeed/task/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTaskStatus(_response);
        });
    }

    protected processTaskStatus(response: AxiosResponse): Promise<ProductFeedStatusEventArgs> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductFeedStatusEventArgs.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductFeedStatusEventArgs>(<any>null);
    }
}

export class QueryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    execute(repository: string, item: string, parameters: { [key: string]: any; } , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/admin/api/repositories/execute/{repository}/{item}-query";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecute(_response);
        });
    }

    protected processExecute(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @return OK
     */
    index(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<IQuery> {
        let url_ = this.baseUrl + "/admin/api/repositories/query/{repository}/{item}-query";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<IQuery> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IQuery.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IQuery>(<any>null);
    }

    /**
     * @return No Content
     */
    index2(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/api/repositories/query/{repository}/{item}-query";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex2(_response);
        });
    }

    protected processIndex2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No Content
     */
    index3(repository: string, item: string, query: IQuery , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/api/repositories/query/{repository}/{item}-query";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex3(_response);
        });
    }

    protected processIndex3(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No Content
     */
    index4(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/api/repositories/query/{repository}/{item}-query";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex4(_response);
        });
    }

    protected processIndex4(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class RecommendationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param type (optional) 
     * @param user (optional) 
     * @param product (optional) 
     * @return OK
     */
    recommend(moduleId: number, type: Type | null | undefined, user: string | null | undefined, product: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<Recommendations> {
        let url_ = this.baseUrl + "/api/Recommendation/{moduleId}?";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (user !== undefined && user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (product !== undefined && product !== null)
            product && product.forEach(item => { url_ += "product=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecommend(_response);
        });
    }

    protected processRecommend(response: AxiosResponse): Promise<Recommendations> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Recommendations.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Recommendations>(<any>null);
    }
}

export class RepositoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    dataSources(  cancelToken?: CancelToken | undefined): Promise<DataSource[]> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_datasources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDataSources(_response);
        });
    }

    protected processDataSources(response: AxiosResponse): Promise<DataSource[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataSource.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataSource[]>(<any>null);
    }

    /**
     * @return OK
     */
    deleteRepository(repository: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_delete_repository/{repository}";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRepository(_response);
        });
    }

    protected processDeleteRepository(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return OK
     */
    dataModel(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<DataModel> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_model/{repository}/{item}";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDataModel(_response);
        });
    }

    protected processDataModel(response: AxiosResponse): Promise<DataModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataModel>(<any>null);
    }

    /**
     * @return OK
     */
    dataParameters(repository: string, item: string , cancelToken?: CancelToken | undefined): Promise<DataParameter[]> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_params/{repository}/{item}";
        if (repository === undefined || repository === null)
            throw new Error("The parameter 'repository' must be defined.");
        url_ = url_.replace("{repository}", encodeURIComponent("" + repository));
        if (item === undefined || item === null)
            throw new Error("The parameter 'item' must be defined.");
        url_ = url_.replace("{item}", encodeURIComponent("" + item));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDataParameters(_response);
        });
    }

    protected processDataParameters(response: AxiosResponse): Promise<DataParameter[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataParameter.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataParameter[]>(<any>null);
    }

    /**
     * @return OK
     */
    getSupportedActions(  cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/admin/api/repositories/_sys_supported_actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSupportedActions(_response);
        });
    }

    protected processGetSupportedActions(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(<any>null);
    }
}

export class SharedModelClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    actionStatusModel(model: ActionStatusViewModel , cancelToken?: CancelToken | undefined): Promise<ActionStatusViewModel> {
        let url_ = this.baseUrl + "/api/sharedModel/actionStatusModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActionStatusModel(_response);
        });
    }

    protected processActionStatusModel(response: AxiosResponse): Promise<ActionStatusViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActionStatusViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActionStatusViewModel>(<any>null);
    }
}

export class UserClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    test(  cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/user/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(<any>null);
    }

    /**
     * @return OK
     */
    getCurrentUser(extendedKey: string , cancelToken?: CancelToken | undefined): Promise<DWUserViewModel> {
        let url_ = this.baseUrl + "/api/user/GetCurrentUser?";
        if (extendedKey === undefined || extendedKey === null)
            throw new Error("The parameter 'extendedKey' must be defined and cannot be null.");
        else
            url_ += "extendedKey=" + encodeURIComponent("" + extendedKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: AxiosResponse): Promise<DWUserViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DWUserViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DWUserViewModel>(<any>null);
    }

    /**
     * @return No Content
     */
    deleteUser(username: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/user/DeleteUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(username);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return No Content
     */
    setSelectedList(selectedListId: string, selectedCustomerNumber: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/user/SetSelectedListId?";
        if (selectedCustomerNumber === undefined || selectedCustomerNumber === null)
            throw new Error("The parameter 'selectedCustomerNumber' must be defined and cannot be null.");
        else
            url_ += "selectedCustomerNumber=" + encodeURIComponent("" + selectedCustomerNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectedListId);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSelectedList(_response);
        });
    }

    protected processSetSelectedList(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return OK
     */
    updateCustomer(model: EditCustomerViewModel , cancelToken?: CancelToken | undefined): Promise<ActionStatusViewModel> {
        let url_ = this.baseUrl + "/api/user/updateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomer(_response);
        });
    }

    protected processUpdateCustomer(response: AxiosResponse): Promise<ActionStatusViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActionStatusViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActionStatusViewModel>(<any>null);
    }
}

export class AuthModel implements IAuthModel {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["Username"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): AuthModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Username"] = this.username;
        data["Password"] = this.password;
        return data; 
    }
}

export interface IAuthModel {
    username?: string | undefined;
    password?: string | undefined;
}

export class IFacetGroup implements IIFacetGroup {
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    source?: FacetSource | undefined;
    items?: Facet[] | undefined;
    fieldsTermsCount?: { [key: string]: number; } | undefined;

    constructor(data?: IIFacetGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["FileName"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.subType = _data["SubType"];
            this.description = _data["Description"];
            if (_data["Meta"]) {
                this.meta = {} as any;
                for (let key in _data["Meta"]) {
                    if (_data["Meta"].hasOwnProperty(key))
                        this.meta![key] = _data["Meta"][key];
                }
            }
            if (_data["Settings"]) {
                this.settings = {} as any;
                for (let key in _data["Settings"]) {
                    if (_data["Settings"].hasOwnProperty(key))
                        this.settings![key] = _data["Settings"][key];
                }
            }
            this.source = _data["Source"] ? FacetSource.fromJS(_data["Source"]) : <any>undefined;
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(Facet.fromJS(item));
            }
            if (_data["FieldsTermsCount"]) {
                this.fieldsTermsCount = {} as any;
                for (let key in _data["FieldsTermsCount"]) {
                    if (_data["FieldsTermsCount"].hasOwnProperty(key))
                        this.fieldsTermsCount![key] = _data["FieldsTermsCount"][key];
                }
            }
        }
    }

    static fromJS(data: any): IFacetGroup {
        data = typeof data === 'object' ? data : {};
        let result = new IFacetGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileName"] = this.fileName;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["SubType"] = this.subType;
        data["Description"] = this.description;
        if (this.meta) {
            data["Meta"] = {};
            for (let key in this.meta) {
                if (this.meta.hasOwnProperty(key))
                    data["Meta"][key] = this.meta[key];
            }
        }
        if (this.settings) {
            data["Settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    data["Settings"][key] = this.settings[key];
            }
        }
        data["Source"] = this.source ? this.source.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        if (this.fieldsTermsCount) {
            data["FieldsTermsCount"] = {};
            for (let key in this.fieldsTermsCount) {
                if (this.fieldsTermsCount.hasOwnProperty(key))
                    data["FieldsTermsCount"][key] = this.fieldsTermsCount[key];
            }
        }
        return data; 
    }
}

export interface IIFacetGroup {
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    source?: FacetSource | undefined;
    items?: Facet[] | undefined;
    fieldsTermsCount?: { [key: string]: number; } | undefined;
}

export class FacetSource implements IFacetSource {
    repository?: string | undefined;
    item?: string | undefined;

    constructor(data?: IFacetSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repository = _data["Repository"];
            this.item = _data["Item"];
        }
    }

    static fromJS(data: any): FacetSource {
        data = typeof data === 'object' ? data : {};
        let result = new FacetSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Repository"] = this.repository;
        data["Item"] = this.item;
        return data; 
    }
}

export interface IFacetSource {
    repository?: string | undefined;
    item?: string | undefined;
}

export class Facet implements IFacet {
    name?: string | undefined;
    type?: string | undefined;
    queryParameter?: string | undefined;
    field?: string | undefined;
    options?: FacetOption[] | undefined;

    constructor(data?: IFacet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.queryParameter = _data["QueryParameter"];
            this.field = _data["Field"];
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(FacetOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Facet {
        data = typeof data === 'object' ? data : {};
        let result = new Facet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["QueryParameter"] = this.queryParameter;
        data["Field"] = this.field;
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFacet {
    name?: string | undefined;
    type?: string | undefined;
    queryParameter?: string | undefined;
    field?: string | undefined;
    options?: FacetOption[] | undefined;
}

export class FacetOption implements IFacetOption {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IFacetOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): FacetOption {
        data = typeof data === 'object' ? data : {};
        let result = new FacetOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Value"] = this.value;
        return data; 
    }
}

export interface IFacetOption {
    name?: string | undefined;
    value?: string | undefined;
}

export class IIndex implements IIIndex {
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    balancer?: IIndexBalancer | undefined;
    instances?: { [key: string]: IIndexProvider; } | undefined;
    builds?: { [key: string]: IIndexBuilder; } | undefined;
    schema?: SchemaDefinition | undefined;

    constructor(data?: IIIndex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["FileName"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.subType = _data["SubType"];
            this.description = _data["Description"];
            if (_data["Meta"]) {
                this.meta = {} as any;
                for (let key in _data["Meta"]) {
                    if (_data["Meta"].hasOwnProperty(key))
                        this.meta![key] = _data["Meta"][key];
                }
            }
            if (_data["Settings"]) {
                this.settings = {} as any;
                for (let key in _data["Settings"]) {
                    if (_data["Settings"].hasOwnProperty(key))
                        this.settings![key] = _data["Settings"][key];
                }
            }
            this.balancer = _data["Balancer"] ? IIndexBalancer.fromJS(_data["Balancer"]) : <any>undefined;
            if (_data["Instances"]) {
                this.instances = {} as any;
                for (let key in _data["Instances"]) {
                    if (_data["Instances"].hasOwnProperty(key))
                        this.instances![key] = _data["Instances"][key] ? IIndexProvider.fromJS(_data["Instances"][key]) : new IIndexProvider();
                }
            }
            if (_data["Builds"]) {
                this.builds = {} as any;
                for (let key in _data["Builds"]) {
                    if (_data["Builds"].hasOwnProperty(key))
                        this.builds![key] = _data["Builds"][key] ? IIndexBuilder.fromJS(_data["Builds"][key]) : new IIndexBuilder();
                }
            }
            this.schema = _data["Schema"] ? SchemaDefinition.fromJS(_data["Schema"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IIndex {
        data = typeof data === 'object' ? data : {};
        let result = new IIndex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileName"] = this.fileName;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["SubType"] = this.subType;
        data["Description"] = this.description;
        if (this.meta) {
            data["Meta"] = {};
            for (let key in this.meta) {
                if (this.meta.hasOwnProperty(key))
                    data["Meta"][key] = this.meta[key];
            }
        }
        if (this.settings) {
            data["Settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    data["Settings"][key] = this.settings[key];
            }
        }
        data["Balancer"] = this.balancer ? this.balancer.toJSON() : <any>undefined;
        if (this.instances) {
            data["Instances"] = {};
            for (let key in this.instances) {
                if (this.instances.hasOwnProperty(key))
                    data["Instances"][key] = this.instances[key] ? this.instances[key].toJSON() : <any>undefined;
            }
        }
        if (this.builds) {
            data["Builds"] = {};
            for (let key in this.builds) {
                if (this.builds.hasOwnProperty(key))
                    data["Builds"][key] = this.builds[key] ? this.builds[key].toJSON() : <any>undefined;
            }
        }
        data["Schema"] = this.schema ? this.schema.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIIndex {
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    balancer?: IIndexBalancer | undefined;
    instances?: { [key: string]: IIndexProvider; } | undefined;
    builds?: { [key: string]: IIndexBuilder; } | undefined;
    schema?: SchemaDefinition | undefined;
}

export class IIndexBalancer implements IIIndexBalancer {
    index?: IIndex | undefined;

    constructor(data?: IIIndexBalancer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["Index"] ? IIndex.fromJS(_data["Index"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IIndexBalancer {
        data = typeof data === 'object' ? data : {};
        let result = new IIndexBalancer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Index"] = this.index ? this.index.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIIndexBalancer {
    index?: IIndex | undefined;
}

export class IIndexProvider implements IIIndexProvider {
    name?: string | undefined;
    type?: string | undefined;
    settings?: { [key: string]: string; } | undefined;
    readonly isAvailable?: boolean | undefined;

    constructor(data?: IIIndexProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            if (_data["Settings"]) {
                this.settings = {} as any;
                for (let key in _data["Settings"]) {
                    if (_data["Settings"].hasOwnProperty(key))
                        this.settings![key] = _data["Settings"][key];
                }
            }
            (<any>this).isAvailable = _data["IsAvailable"];
        }
    }

    static fromJS(data: any): IIndexProvider {
        data = typeof data === 'object' ? data : {};
        let result = new IIndexProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        if (this.settings) {
            data["Settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    data["Settings"][key] = this.settings[key];
            }
        }
        data["IsAvailable"] = this.isAvailable;
        return data; 
    }
}

export interface IIIndexProvider {
    name?: string | undefined;
    type?: string | undefined;
    settings?: { [key: string]: string; } | undefined;
    isAvailable?: boolean | undefined;
}

export class IIndexBuilder implements IIIndexBuilder {
    name?: string | undefined;
    type?: string | undefined;
    action?: string | undefined;
    settings?: { [key: string]: string; } | undefined;
    meta?: { [key: string]: string; } | undefined;
    schema?: SchemaDefinition | undefined;
    readonly supportedActions?: string[] | undefined;
    extenders?: IIndexBuilderExtenderOfIIndexBuilder[] | undefined;

    constructor(data?: IIIndexBuilder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.action = _data["Action"];
            if (_data["Settings"]) {
                this.settings = {} as any;
                for (let key in _data["Settings"]) {
                    if (_data["Settings"].hasOwnProperty(key))
                        this.settings![key] = _data["Settings"][key];
                }
            }
            if (_data["Meta"]) {
                this.meta = {} as any;
                for (let key in _data["Meta"]) {
                    if (_data["Meta"].hasOwnProperty(key))
                        this.meta![key] = _data["Meta"][key];
                }
            }
            this.schema = _data["Schema"] ? SchemaDefinition.fromJS(_data["Schema"]) : <any>undefined;
            if (Array.isArray(_data["SupportedActions"])) {
                (<any>this).supportedActions = [] as any;
                for (let item of _data["SupportedActions"])
                    (<any>this).supportedActions!.push(item);
            }
            if (Array.isArray(_data["Extenders"])) {
                this.extenders = [] as any;
                for (let item of _data["Extenders"])
                    this.extenders!.push(IIndexBuilderExtenderOfIIndexBuilder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IIndexBuilder {
        data = typeof data === 'object' ? data : {};
        let result = new IIndexBuilder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["Action"] = this.action;
        if (this.settings) {
            data["Settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    data["Settings"][key] = this.settings[key];
            }
        }
        if (this.meta) {
            data["Meta"] = {};
            for (let key in this.meta) {
                if (this.meta.hasOwnProperty(key))
                    data["Meta"][key] = this.meta[key];
            }
        }
        data["Schema"] = this.schema ? this.schema.toJSON() : <any>undefined;
        if (Array.isArray(this.supportedActions)) {
            data["SupportedActions"] = [];
            for (let item of this.supportedActions)
                data["SupportedActions"].push(item);
        }
        if (Array.isArray(this.extenders)) {
            data["Extenders"] = [];
            for (let item of this.extenders)
                data["Extenders"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIIndexBuilder {
    name?: string | undefined;
    type?: string | undefined;
    action?: string | undefined;
    settings?: { [key: string]: string; } | undefined;
    meta?: { [key: string]: string; } | undefined;
    schema?: SchemaDefinition | undefined;
    supportedActions?: string[] | undefined;
    extenders?: IIndexBuilderExtenderOfIIndexBuilder[] | undefined;
}

export class SchemaDefinition implements ISchemaDefinition {
    fieldTypes?: FieldTypeDefinition[] | undefined;
    fields?: FieldDefinitionBase[] | undefined;
    fieldsFromIndexDefinition?: FieldDefinitionBase[] | undefined;

    constructor(data?: ISchemaDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["FieldTypes"])) {
                this.fieldTypes = [] as any;
                for (let item of _data["FieldTypes"])
                    this.fieldTypes!.push(FieldTypeDefinition.fromJS(item));
            }
            if (Array.isArray(_data["Fields"])) {
                this.fields = [] as any;
                for (let item of _data["Fields"])
                    this.fields!.push(FieldDefinitionBase.fromJS(item));
            }
            if (Array.isArray(_data["FieldsFromIndexDefinition"])) {
                this.fieldsFromIndexDefinition = [] as any;
                for (let item of _data["FieldsFromIndexDefinition"])
                    this.fieldsFromIndexDefinition!.push(FieldDefinitionBase.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchemaDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldTypes)) {
            data["FieldTypes"] = [];
            for (let item of this.fieldTypes)
                data["FieldTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.fields)) {
            data["Fields"] = [];
            for (let item of this.fields)
                data["Fields"].push(item.toJSON());
        }
        if (Array.isArray(this.fieldsFromIndexDefinition)) {
            data["FieldsFromIndexDefinition"] = [];
            for (let item of this.fieldsFromIndexDefinition)
                data["FieldsFromIndexDefinition"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISchemaDefinition {
    fieldTypes?: FieldTypeDefinition[] | undefined;
    fields?: FieldDefinitionBase[] | undefined;
    fieldsFromIndexDefinition?: FieldDefinitionBase[] | undefined;
}

export class IIndexBuilderExtenderOfIIndexBuilder implements IIIndexBuilderExtenderOfIIndexBuilder {

    constructor(data?: IIIndexBuilderExtenderOfIIndexBuilder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IIndexBuilderExtenderOfIIndexBuilder {
        data = typeof data === 'object' ? data : {};
        let result = new IIndexBuilderExtenderOfIIndexBuilder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IIIndexBuilderExtenderOfIIndexBuilder {
}

export class FieldTypeDefinition implements IFieldTypeDefinition {
    name?: string | undefined;
    type?: string | undefined;
    analyzers?: { [key: string]: string; } | undefined;
    boost?: string | undefined;

    constructor(data?: IFieldTypeDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            if (_data["Analyzers"]) {
                this.analyzers = {} as any;
                for (let key in _data["Analyzers"]) {
                    if (_data["Analyzers"].hasOwnProperty(key))
                        this.analyzers![key] = _data["Analyzers"][key];
                }
            }
            this.boost = _data["Boost"];
        }
    }

    static fromJS(data: any): FieldTypeDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new FieldTypeDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        if (this.analyzers) {
            data["Analyzers"] = {};
            for (let key in this.analyzers) {
                if (this.analyzers.hasOwnProperty(key))
                    data["Analyzers"][key] = this.analyzers[key];
            }
        }
        data["Boost"] = this.boost;
        return data; 
    }
}

export interface IFieldTypeDefinition {
    name?: string | undefined;
    type?: string | undefined;
    analyzers?: { [key: string]: string; } | undefined;
    boost?: string | undefined;
}

export class FieldDefinitionBase implements IFieldDefinitionBase {
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;
    analyzer?: string | undefined;
    boost?: string | undefined;
    stored?: boolean | undefined;
    indexed?: boolean | undefined;
    analyzed?: boolean | undefined;
    readonly isNumeric?: boolean | undefined;

    constructor(data?: IFieldDefinitionBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.systemName = _data["SystemName"];
            this.type = _data["Type"];
            this.analyzer = _data["Analyzer"];
            this.boost = _data["Boost"];
            this.stored = _data["Stored"];
            this.indexed = _data["Indexed"];
            this.analyzed = _data["Analyzed"];
            (<any>this).isNumeric = _data["IsNumeric"];
        }
    }

    static fromJS(data: any): FieldDefinitionBase {
        data = typeof data === 'object' ? data : {};
        let result = new FieldDefinitionBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["SystemName"] = this.systemName;
        data["Type"] = this.type;
        data["Analyzer"] = this.analyzer;
        data["Boost"] = this.boost;
        data["Stored"] = this.stored;
        data["Indexed"] = this.indexed;
        data["Analyzed"] = this.analyzed;
        data["IsNumeric"] = this.isNumeric;
        return data; 
    }
}

export interface IFieldDefinitionBase {
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;
    analyzer?: string | undefined;
    boost?: string | undefined;
    stored?: boolean | undefined;
    indexed?: boolean | undefined;
    analyzed?: boolean | undefined;
    isNumeric?: boolean | undefined;
}

export class SendMailDto implements ISendMailDto {
    zipBytes?: string | undefined;
    receiverEmail?: string | undefined;

    constructor(data?: ISendMailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zipBytes = _data["ZipBytes"];
            this.receiverEmail = _data["ReceiverEmail"];
        }
    }

    static fromJS(data: any): SendMailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendMailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ZipBytes"] = this.zipBytes;
        data["ReceiverEmail"] = this.receiverEmail;
        return data; 
    }
}

export interface ISendMailDto {
    zipBytes?: string | undefined;
    receiverEmail?: string | undefined;
}

export class ProductQuery implements IProductQuery {
    productId?: string | undefined;
    variantId?: string | undefined;

    constructor(data?: IProductQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["ProductId"];
            this.variantId = _data["VariantId"];
        }
    }

    static fromJS(data: any): ProductQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProductQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductId"] = this.productId;
        data["VariantId"] = this.variantId;
        return data; 
    }
}

export interface IProductQuery {
    productId?: string | undefined;
    variantId?: string | undefined;
}

export class CancellationToken implements ICancellationToken {
    readonly isCancellationRequested?: boolean | undefined;
    readonly canBeCanceled?: boolean | undefined;
    readonly waitHandle?: WaitHandle | undefined;

    constructor(data?: ICancellationToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isCancellationRequested = _data["IsCancellationRequested"];
            (<any>this).canBeCanceled = _data["CanBeCanceled"];
            (<any>this).waitHandle = _data["WaitHandle"] ? WaitHandle.fromJS(_data["WaitHandle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CancellationToken {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsCancellationRequested"] = this.isCancellationRequested;
        data["CanBeCanceled"] = this.canBeCanceled;
        data["WaitHandle"] = this.waitHandle ? this.waitHandle.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICancellationToken {
    isCancellationRequested?: boolean | undefined;
    canBeCanceled?: boolean | undefined;
    waitHandle?: WaitHandle | undefined;
}

export class WaitHandle implements IWaitHandle {
    handle?: any | undefined;
    safeWaitHandle?: SafeWaitHandle | undefined;

    constructor(data?: IWaitHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handle = _data["Handle"];
            this.safeWaitHandle = _data["SafeWaitHandle"] ? SafeWaitHandle.fromJS(_data["SafeWaitHandle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WaitHandle {
        data = typeof data === 'object' ? data : {};
        let result = new WaitHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Handle"] = this.handle;
        data["SafeWaitHandle"] = this.safeWaitHandle ? this.safeWaitHandle.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IWaitHandle {
    handle?: any | undefined;
    safeWaitHandle?: SafeWaitHandle | undefined;
}

export class SafeWaitHandle implements ISafeWaitHandle {
    readonly isInvalid?: boolean | undefined;
    readonly isClosed?: boolean | undefined;

    constructor(data?: ISafeWaitHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isInvalid = _data["IsInvalid"];
            (<any>this).isClosed = _data["IsClosed"];
        }
    }

    static fromJS(data: any): SafeWaitHandle {
        data = typeof data === 'object' ? data : {};
        let result = new SafeWaitHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsInvalid"] = this.isInvalid;
        data["IsClosed"] = this.isClosed;
        return data; 
    }
}

export interface ISafeWaitHandle {
    isInvalid?: boolean | undefined;
    isClosed?: boolean | undefined;
}

export class ProductFeedStatusEventArgs implements IProductFeedStatusEventArgs {
    taskId?: string | undefined;
    isReady?: boolean | undefined;
    completedFeedGenerator?: string | undefined;
    downloaded?: string | undefined;
    transformed?: string | undefined;
    started?: string | undefined;
    completed?: string | undefined;
    progressText?: string | undefined;
    hasErrors?: boolean | undefined;
    errorMsg?: string | undefined;

    constructor(data?: IProductFeedStatusEventArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["TaskId"];
            this.isReady = _data["IsReady"];
            this.completedFeedGenerator = _data["CompletedFeedGenerator"];
            this.downloaded = _data["Downloaded"];
            this.transformed = _data["Transformed"];
            this.started = _data["Started"];
            this.completed = _data["Completed"];
            this.progressText = _data["ProgressText"];
            this.hasErrors = _data["HasErrors"];
            this.errorMsg = _data["ErrorMsg"];
        }
    }

    static fromJS(data: any): ProductFeedStatusEventArgs {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFeedStatusEventArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TaskId"] = this.taskId;
        data["IsReady"] = this.isReady;
        data["CompletedFeedGenerator"] = this.completedFeedGenerator;
        data["Downloaded"] = this.downloaded;
        data["Transformed"] = this.transformed;
        data["Started"] = this.started;
        data["Completed"] = this.completed;
        data["ProgressText"] = this.progressText;
        data["HasErrors"] = this.hasErrors;
        data["ErrorMsg"] = this.errorMsg;
        return data; 
    }
}

export interface IProductFeedStatusEventArgs {
    taskId?: string | undefined;
    isReady?: boolean | undefined;
    completedFeedGenerator?: string | undefined;
    downloaded?: string | undefined;
    transformed?: string | undefined;
    started?: string | undefined;
    completed?: string | undefined;
    progressText?: string | undefined;
    hasErrors?: boolean | undefined;
    errorMsg?: string | undefined;
}

export class IQuery implements IIQuery {
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    sortOrder?: SortInfo[] | undefined;
    parameters?: QueryParameter[] | undefined;
    imports?: QueryImport[] | undefined;
    references?: QueryReference[] | undefined;
    source?: QuerySource | undefined;
    expression?: Expression | undefined;

    constructor(data?: IIQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["FileName"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.subType = _data["SubType"];
            this.description = _data["Description"];
            if (_data["Meta"]) {
                this.meta = {} as any;
                for (let key in _data["Meta"]) {
                    if (_data["Meta"].hasOwnProperty(key))
                        this.meta![key] = _data["Meta"][key];
                }
            }
            if (_data["Settings"]) {
                this.settings = {} as any;
                for (let key in _data["Settings"]) {
                    if (_data["Settings"].hasOwnProperty(key))
                        this.settings![key] = _data["Settings"][key];
                }
            }
            if (Array.isArray(_data["SortOrder"])) {
                this.sortOrder = [] as any;
                for (let item of _data["SortOrder"])
                    this.sortOrder!.push(SortInfo.fromJS(item));
            }
            if (Array.isArray(_data["Parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["Parameters"])
                    this.parameters!.push(QueryParameter.fromJS(item));
            }
            if (Array.isArray(_data["Imports"])) {
                this.imports = [] as any;
                for (let item of _data["Imports"])
                    this.imports!.push(QueryImport.fromJS(item));
            }
            if (Array.isArray(_data["References"])) {
                this.references = [] as any;
                for (let item of _data["References"])
                    this.references!.push(QueryReference.fromJS(item));
            }
            this.source = _data["Source"] ? QuerySource.fromJS(_data["Source"]) : <any>undefined;
            this.expression = _data["Expression"] ? Expression.fromJS(_data["Expression"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IQuery {
        data = typeof data === 'object' ? data : {};
        let result = new IQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FileName"] = this.fileName;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["SubType"] = this.subType;
        data["Description"] = this.description;
        if (this.meta) {
            data["Meta"] = {};
            for (let key in this.meta) {
                if (this.meta.hasOwnProperty(key))
                    data["Meta"][key] = this.meta[key];
            }
        }
        if (this.settings) {
            data["Settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    data["Settings"][key] = this.settings[key];
            }
        }
        if (Array.isArray(this.sortOrder)) {
            data["SortOrder"] = [];
            for (let item of this.sortOrder)
                data["SortOrder"].push(item.toJSON());
        }
        if (Array.isArray(this.parameters)) {
            data["Parameters"] = [];
            for (let item of this.parameters)
                data["Parameters"].push(item.toJSON());
        }
        if (Array.isArray(this.imports)) {
            data["Imports"] = [];
            for (let item of this.imports)
                data["Imports"].push(item.toJSON());
        }
        if (Array.isArray(this.references)) {
            data["References"] = [];
            for (let item of this.references)
                data["References"].push(item.toJSON());
        }
        data["Source"] = this.source ? this.source.toJSON() : <any>undefined;
        data["Expression"] = this.expression ? this.expression.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIQuery {
    fileName?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    subType?: string | undefined;
    description?: string | undefined;
    meta?: { [key: string]: string; } | undefined;
    settings?: { [key: string]: string; } | undefined;
    sortOrder?: SortInfo[] | undefined;
    parameters?: QueryParameter[] | undefined;
    imports?: QueryImport[] | undefined;
    references?: QueryReference[] | undefined;
    source?: QuerySource | undefined;
    expression?: Expression | undefined;
}

export class SortInfo implements ISortInfo {
    field?: string | undefined;
    sortDirection?: SortInfoSortDirection | undefined;

    constructor(data?: ISortInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["Field"];
            this.sortDirection = _data["SortDirection"];
        }
    }

    static fromJS(data: any): SortInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SortInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Field"] = this.field;
        data["SortDirection"] = this.sortDirection;
        return data; 
    }
}

export interface ISortInfo {
    field?: string | undefined;
    sortDirection?: SortInfoSortDirection | undefined;
}

export class QueryParameter implements IQueryParameter {
    name?: string | undefined;
    type?: string | undefined;
    defaultValue?: string | undefined;

    constructor(data?: IQueryParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.defaultValue = _data["DefaultValue"];
        }
    }

    static fromJS(data: any): QueryParameter {
        data = typeof data === 'object' ? data : {};
        let result = new QueryParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["DefaultValue"] = this.defaultValue;
        return data; 
    }
}

export interface IQueryParameter {
    name?: string | undefined;
    type?: string | undefined;
    defaultValue?: string | undefined;
}

export class QueryImport implements IQueryImport {
    name?: string | undefined;

    constructor(data?: IQueryImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): QueryImport {
        data = typeof data === 'object' ? data : {};
        let result = new QueryImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        return data; 
    }
}

export interface IQueryImport {
    name?: string | undefined;
}

export class QueryReference implements IQueryReference {
    name?: string | undefined;
    type?: string | undefined;

    constructor(data?: IQueryReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): QueryReference {
        data = typeof data === 'object' ? data : {};
        let result = new QueryReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        return data; 
    }
}

export interface IQueryReference {
    name?: string | undefined;
    type?: string | undefined;
}

export class QuerySource implements IQuerySource {
    repository?: string | undefined;
    item?: string | undefined;
    provider?: IQueryProvider | undefined;

    constructor(data?: IQuerySource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repository = _data["Repository"];
            this.item = _data["Item"];
            this.provider = _data["Provider"] ? IQueryProvider.fromJS(_data["Provider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuerySource {
        data = typeof data === 'object' ? data : {};
        let result = new QuerySource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Repository"] = this.repository;
        data["Item"] = this.item;
        data["Provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IQuerySource {
    repository?: string | undefined;
    item?: string | undefined;
    provider?: IQueryProvider | undefined;
}

export class Expression implements IExpression {
    class?: string | undefined;

    constructor(data?: IExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.class = _data["class"];
        }
    }

    static fromJS(data: any): Expression {
        data = typeof data === 'object' ? data : {};
        let result = new Expression();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["class"] = this.class;
        return data; 
    }
}

export interface IExpression {
    class?: string | undefined;
}

export class IQueryProvider implements IIQueryProvider {

    constructor(data?: IIQueryProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IQueryProvider {
        data = typeof data === 'object' ? data : {};
        let result = new IQueryProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IIQueryProvider {
}

export class Recommendations implements IRecommendations {
    products?: Product[] | undefined;
    settings?: { [key: string]: any; } | undefined;
    content?: string | undefined;

    constructor(data?: IRecommendations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(Product.fromJS(item));
            }
            if (_data["Settings"]) {
                this.settings = {} as any;
                for (let key in _data["Settings"]) {
                    if (_data["Settings"].hasOwnProperty(key))
                        this.settings![key] = _data["Settings"][key];
                }
            }
            this.content = _data["Content"];
        }
    }

    static fromJS(data: any): Recommendations {
        data = typeof data === 'object' ? data : {};
        let result = new Recommendations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item.toJSON());
        }
        if (this.settings) {
            data["Settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    data["Settings"][key] = this.settings[key];
            }
        }
        data["Content"] = this.content;
        return data; 
    }
}

export interface IRecommendations {
    products?: Product[] | undefined;
    settings?: { [key: string]: any; } | undefined;
    content?: string | undefined;
}

export class Product implements IProduct {
    _ID?: string | undefined;
    _AutoId?: number | undefined;
    _LanguageID?: string | undefined;
    _DefaultShopID?: string | undefined;
    _Number?: string | undefined;
    _Name?: string | undefined;
    _ShortDescription?: string | undefined;
    _LongDescription?: string | undefined;
    _Stock?: number | undefined;
    _StockGroupID?: string | undefined;
    _Weight?: number | undefined;
    _Volume?: number | undefined;
    _VatGroupID?: string | undefined;
    _ManufacturerID?: string | undefined;
    _Active?: boolean | undefined;
    _PeriodID?: string | undefined;
    _Created?: Date | undefined;
    _Updated?: Date | undefined;
    _CustomFieldsXml?: string | undefined;
    _Type?: Product_Type | undefined;
    _PriceType?: Product_PriceType | undefined;
    _VariantCnt?: number | undefined;
    _VariantProductCnt?: number | undefined;
    _VariantGroupCnt?: number | undefined;
    _PriceCnt?: number | undefined;
    _RelatedCnt?: number | undefined;
    _UnitCnt?: number | undefined;
    _VariantID?: string | undefined;
    _VirtualVariantID?: string | undefined;
    _ImageSmall?: string | undefined;
    _ImageMedium?: string | undefined;
    _ImageLarge?: string | undefined;
    _Link1?: string | undefined;
    _Link2?: string | undefined;
    _Price?: number | undefined;
    _Cost?: number | undefined;
    _Rating?: number | undefined;
    _Solditems?: number | undefined;
    _Commentcount?: number | undefined;
    _DefaultUnitID?: string | undefined;
    _DefaultVariantComboID?: string | undefined;
    _IsVariantMaster?: boolean | undefined;
    _VariantGroups?: VariantGroup[] | undefined;
    _RelatedGroups?: ProductRelatedGroup[] | undefined;
    _RelatedProducts?: ProductRelated[] | undefined;
    _RelatedSearches?: RelatedSmartSearch[] | undefined;
    _Groups?: Group[] | undefined;
    _Items?: ProductItem[] | undefined;
    _VariantCombinations?: VariantCombination[] | undefined;
    _VariantCombinationsWithStockCheck?: VariantCombination[] | undefined;
    _PropertyRelations?: PropertyProductRelation[] | undefined;
    _PropertyProductValues?: PropertyProductValue[] | undefined;
    _Details?: Detail[] | undefined;
    _Prices?: Price[] | undefined;
    _Units?: StockUnit[] | undefined;
    _UnitsUnique?: StockUnit[] | undefined;
    _UnitList?: VariantOption[] | undefined;
    _Periods?: Period[] | undefined;
    _Shop?: Shop | undefined;
    _StockGroup?: StockGroup | undefined;
    _Manufacturer?: Manufacturer | undefined;
    _Period?: Period | undefined;
    _PeriodOfProduct?: Period | undefined;
    _VatGroup?: VatGroup | undefined;
    _VatGroups?: ProductVatGroup[] | undefined;
    _PriceMatrixUnit?: number | undefined;
    _PriceMatrixVariant?: number | undefined;
    _PriceMatrixPeriod?: number | undefined;
    _PriceMatrixMultiplePrices?: number | undefined;
    _PriceMatrixQuantitySpecification?: string | undefined;
    _ProductFieldValues?: ProductFieldValue[] | undefined;
    _AllowSave?: boolean | undefined;
    cachedDiscounts?: Discount[] | undefined;
    cachedPrice?: PriceInfo | undefined;
    cachedPriceVariantID?: string | undefined;
    cachedPriceUnitID?: string | undefined;
    cachedInformativePrice?: PriceInfo | undefined;
    cachedInformativePriceVariantID?: string | undefined;
    cachedInformativePriceUnitID?: string | undefined;
    cachedOrderLineFields?: OrderLineField[] | undefined;
    _RelationSorting?: number | undefined;
    _meta?: MetaData | undefined;
    _optimizedFor?: string | undefined;
    _categoryFieldValues?: { [key: string]: { [key: string]: any; }; } | undefined;
    _taxCollection?: Tax[] | undefined;
    _defaultPoints?: number | undefined;
    _PrimaryGroupID?: string | undefined;
    _defaultGroup?: Group | undefined;
    _IndexingOptions?: ProductIndexingOptions | undefined;
    _ExcludeFromIndex?: boolean | undefined;
    _ExcludeFromCustomizedUrls?: boolean | undefined;
    _ExcludeFromAllProducts?: boolean | undefined;
    _ProductPriceString?: string | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._AutoId = _data["_AutoId"];
            this._LanguageID = _data["_LanguageID"];
            this._DefaultShopID = _data["_DefaultShopID"];
            this._Number = _data["_Number"];
            this._Name = _data["_Name"];
            this._ShortDescription = _data["_ShortDescription"];
            this._LongDescription = _data["_LongDescription"];
            this._Stock = _data["_Stock"];
            this._StockGroupID = _data["_StockGroupID"];
            this._Weight = _data["_Weight"];
            this._Volume = _data["_Volume"];
            this._VatGroupID = _data["_VatGroupID"];
            this._ManufacturerID = _data["_ManufacturerID"];
            this._Active = _data["_Active"];
            this._PeriodID = _data["_PeriodID"];
            this._Created = _data["_Created"] ? new Date(_data["_Created"].toString()) : <any>undefined;
            this._Updated = _data["_Updated"] ? new Date(_data["_Updated"].toString()) : <any>undefined;
            this._CustomFieldsXml = _data["_CustomFieldsXml"];
            this._Type = _data["_Type"];
            this._PriceType = _data["_PriceType"];
            this._VariantCnt = _data["_VariantCnt"];
            this._VariantProductCnt = _data["_VariantProductCnt"];
            this._VariantGroupCnt = _data["_VariantGroupCnt"];
            this._PriceCnt = _data["_PriceCnt"];
            this._RelatedCnt = _data["_RelatedCnt"];
            this._UnitCnt = _data["_UnitCnt"];
            this._VariantID = _data["_VariantID"];
            this._VirtualVariantID = _data["_VirtualVariantID"];
            this._ImageSmall = _data["_ImageSmall"];
            this._ImageMedium = _data["_ImageMedium"];
            this._ImageLarge = _data["_ImageLarge"];
            this._Link1 = _data["_Link1"];
            this._Link2 = _data["_Link2"];
            this._Price = _data["_Price"];
            this._Cost = _data["_Cost"];
            this._Rating = _data["_Rating"];
            this._Solditems = _data["_Solditems"];
            this._Commentcount = _data["_Commentcount"];
            this._DefaultUnitID = _data["_DefaultUnitID"];
            this._DefaultVariantComboID = _data["_DefaultVariantComboID"];
            this._IsVariantMaster = _data["_IsVariantMaster"];
            if (Array.isArray(_data["_VariantGroups"])) {
                this._VariantGroups = [] as any;
                for (let item of _data["_VariantGroups"])
                    this._VariantGroups!.push(VariantGroup.fromJS(item));
            }
            if (Array.isArray(_data["_RelatedGroups"])) {
                this._RelatedGroups = [] as any;
                for (let item of _data["_RelatedGroups"])
                    this._RelatedGroups!.push(ProductRelatedGroup.fromJS(item));
            }
            if (Array.isArray(_data["_RelatedProducts"])) {
                this._RelatedProducts = [] as any;
                for (let item of _data["_RelatedProducts"])
                    this._RelatedProducts!.push(ProductRelated.fromJS(item));
            }
            if (Array.isArray(_data["_RelatedSearches"])) {
                this._RelatedSearches = [] as any;
                for (let item of _data["_RelatedSearches"])
                    this._RelatedSearches!.push(RelatedSmartSearch.fromJS(item));
            }
            if (Array.isArray(_data["_Groups"])) {
                this._Groups = [] as any;
                for (let item of _data["_Groups"])
                    this._Groups!.push(Group.fromJS(item));
            }
            if (Array.isArray(_data["_Items"])) {
                this._Items = [] as any;
                for (let item of _data["_Items"])
                    this._Items!.push(ProductItem.fromJS(item));
            }
            if (Array.isArray(_data["_VariantCombinations"])) {
                this._VariantCombinations = [] as any;
                for (let item of _data["_VariantCombinations"])
                    this._VariantCombinations!.push(VariantCombination.fromJS(item));
            }
            if (Array.isArray(_data["_VariantCombinationsWithStockCheck"])) {
                this._VariantCombinationsWithStockCheck = [] as any;
                for (let item of _data["_VariantCombinationsWithStockCheck"])
                    this._VariantCombinationsWithStockCheck!.push(VariantCombination.fromJS(item));
            }
            if (Array.isArray(_data["_PropertyRelations"])) {
                this._PropertyRelations = [] as any;
                for (let item of _data["_PropertyRelations"])
                    this._PropertyRelations!.push(PropertyProductRelation.fromJS(item));
            }
            if (Array.isArray(_data["_PropertyProductValues"])) {
                this._PropertyProductValues = [] as any;
                for (let item of _data["_PropertyProductValues"])
                    this._PropertyProductValues!.push(PropertyProductValue.fromJS(item));
            }
            if (Array.isArray(_data["_Details"])) {
                this._Details = [] as any;
                for (let item of _data["_Details"])
                    this._Details!.push(Detail.fromJS(item));
            }
            if (Array.isArray(_data["_Prices"])) {
                this._Prices = [] as any;
                for (let item of _data["_Prices"])
                    this._Prices!.push(Price.fromJS(item));
            }
            if (Array.isArray(_data["_Units"])) {
                this._Units = [] as any;
                for (let item of _data["_Units"])
                    this._Units!.push(StockUnit.fromJS(item));
            }
            if (Array.isArray(_data["_UnitsUnique"])) {
                this._UnitsUnique = [] as any;
                for (let item of _data["_UnitsUnique"])
                    this._UnitsUnique!.push(StockUnit.fromJS(item));
            }
            if (Array.isArray(_data["_UnitList"])) {
                this._UnitList = [] as any;
                for (let item of _data["_UnitList"])
                    this._UnitList!.push(VariantOption.fromJS(item));
            }
            if (Array.isArray(_data["_Periods"])) {
                this._Periods = [] as any;
                for (let item of _data["_Periods"])
                    this._Periods!.push(Period.fromJS(item));
            }
            this._Shop = _data["_Shop"] ? Shop.fromJS(_data["_Shop"]) : <any>undefined;
            this._StockGroup = _data["_StockGroup"] ? StockGroup.fromJS(_data["_StockGroup"]) : <any>undefined;
            this._Manufacturer = _data["_Manufacturer"] ? Manufacturer.fromJS(_data["_Manufacturer"]) : <any>undefined;
            this._Period = _data["_Period"] ? Period.fromJS(_data["_Period"]) : <any>undefined;
            this._PeriodOfProduct = _data["_PeriodOfProduct"] ? Period.fromJS(_data["_PeriodOfProduct"]) : <any>undefined;
            this._VatGroup = _data["_VatGroup"] ? VatGroup.fromJS(_data["_VatGroup"]) : <any>undefined;
            if (Array.isArray(_data["_VatGroups"])) {
                this._VatGroups = [] as any;
                for (let item of _data["_VatGroups"])
                    this._VatGroups!.push(ProductVatGroup.fromJS(item));
            }
            this._PriceMatrixUnit = _data["_PriceMatrixUnit"];
            this._PriceMatrixVariant = _data["_PriceMatrixVariant"];
            this._PriceMatrixPeriod = _data["_PriceMatrixPeriod"];
            this._PriceMatrixMultiplePrices = _data["_PriceMatrixMultiplePrices"];
            this._PriceMatrixQuantitySpecification = _data["_PriceMatrixQuantitySpecification"];
            if (Array.isArray(_data["_ProductFieldValues"])) {
                this._ProductFieldValues = [] as any;
                for (let item of _data["_ProductFieldValues"])
                    this._ProductFieldValues!.push(ProductFieldValue.fromJS(item));
            }
            this._AllowSave = _data["_AllowSave"];
            if (Array.isArray(_data["CachedDiscounts"])) {
                this.cachedDiscounts = [] as any;
                for (let item of _data["CachedDiscounts"])
                    this.cachedDiscounts!.push(Discount.fromJS(item));
            }
            this.cachedPrice = _data["CachedPrice"] ? PriceInfo.fromJS(_data["CachedPrice"]) : <any>undefined;
            this.cachedPriceVariantID = _data["CachedPriceVariantID"];
            this.cachedPriceUnitID = _data["CachedPriceUnitID"];
            this.cachedInformativePrice = _data["CachedInformativePrice"] ? PriceInfo.fromJS(_data["CachedInformativePrice"]) : <any>undefined;
            this.cachedInformativePriceVariantID = _data["CachedInformativePriceVariantID"];
            this.cachedInformativePriceUnitID = _data["CachedInformativePriceUnitID"];
            if (Array.isArray(_data["CachedOrderLineFields"])) {
                this.cachedOrderLineFields = [] as any;
                for (let item of _data["CachedOrderLineFields"])
                    this.cachedOrderLineFields!.push(OrderLineField.fromJS(item));
            }
            this._RelationSorting = _data["_RelationSorting"];
            this._meta = _data["_meta"] ? MetaData.fromJS(_data["_meta"]) : <any>undefined;
            this._optimizedFor = _data["_optimizedFor"];
            if (_data["_categoryFieldValues"]) {
                this._categoryFieldValues = {} as any;
                for (let key in _data["_categoryFieldValues"]) {
                    if (_data["_categoryFieldValues"].hasOwnProperty(key))
                        this._categoryFieldValues![key] = _data["_categoryFieldValues"][key] !== undefined ? _data["_categoryFieldValues"][key] : {};
                }
            }
            if (Array.isArray(_data["_taxCollection"])) {
                this._taxCollection = [] as any;
                for (let item of _data["_taxCollection"])
                    this._taxCollection!.push(Tax.fromJS(item));
            }
            this._defaultPoints = _data["_defaultPoints"];
            this._PrimaryGroupID = _data["_PrimaryGroupID"];
            this._defaultGroup = _data["_defaultGroup"] ? Group.fromJS(_data["_defaultGroup"]) : <any>undefined;
            this._IndexingOptions = _data["_IndexingOptions"] ? ProductIndexingOptions.fromJS(_data["_IndexingOptions"]) : <any>undefined;
            this._ExcludeFromIndex = _data["_ExcludeFromIndex"];
            this._ExcludeFromCustomizedUrls = _data["_ExcludeFromCustomizedUrls"];
            this._ExcludeFromAllProducts = _data["_ExcludeFromAllProducts"];
            this._ProductPriceString = _data["_ProductPriceString"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_AutoId"] = this._AutoId;
        data["_LanguageID"] = this._LanguageID;
        data["_DefaultShopID"] = this._DefaultShopID;
        data["_Number"] = this._Number;
        data["_Name"] = this._Name;
        data["_ShortDescription"] = this._ShortDescription;
        data["_LongDescription"] = this._LongDescription;
        data["_Stock"] = this._Stock;
        data["_StockGroupID"] = this._StockGroupID;
        data["_Weight"] = this._Weight;
        data["_Volume"] = this._Volume;
        data["_VatGroupID"] = this._VatGroupID;
        data["_ManufacturerID"] = this._ManufacturerID;
        data["_Active"] = this._Active;
        data["_PeriodID"] = this._PeriodID;
        data["_Created"] = this._Created ? this._Created.toISOString() : <any>undefined;
        data["_Updated"] = this._Updated ? this._Updated.toISOString() : <any>undefined;
        data["_CustomFieldsXml"] = this._CustomFieldsXml;
        data["_Type"] = this._Type;
        data["_PriceType"] = this._PriceType;
        data["_VariantCnt"] = this._VariantCnt;
        data["_VariantProductCnt"] = this._VariantProductCnt;
        data["_VariantGroupCnt"] = this._VariantGroupCnt;
        data["_PriceCnt"] = this._PriceCnt;
        data["_RelatedCnt"] = this._RelatedCnt;
        data["_UnitCnt"] = this._UnitCnt;
        data["_VariantID"] = this._VariantID;
        data["_VirtualVariantID"] = this._VirtualVariantID;
        data["_ImageSmall"] = this._ImageSmall;
        data["_ImageMedium"] = this._ImageMedium;
        data["_ImageLarge"] = this._ImageLarge;
        data["_Link1"] = this._Link1;
        data["_Link2"] = this._Link2;
        data["_Price"] = this._Price;
        data["_Cost"] = this._Cost;
        data["_Rating"] = this._Rating;
        data["_Solditems"] = this._Solditems;
        data["_Commentcount"] = this._Commentcount;
        data["_DefaultUnitID"] = this._DefaultUnitID;
        data["_DefaultVariantComboID"] = this._DefaultVariantComboID;
        data["_IsVariantMaster"] = this._IsVariantMaster;
        if (Array.isArray(this._VariantGroups)) {
            data["_VariantGroups"] = [];
            for (let item of this._VariantGroups)
                data["_VariantGroups"].push(item.toJSON());
        }
        if (Array.isArray(this._RelatedGroups)) {
            data["_RelatedGroups"] = [];
            for (let item of this._RelatedGroups)
                data["_RelatedGroups"].push(item.toJSON());
        }
        if (Array.isArray(this._RelatedProducts)) {
            data["_RelatedProducts"] = [];
            for (let item of this._RelatedProducts)
                data["_RelatedProducts"].push(item.toJSON());
        }
        if (Array.isArray(this._RelatedSearches)) {
            data["_RelatedSearches"] = [];
            for (let item of this._RelatedSearches)
                data["_RelatedSearches"].push(item.toJSON());
        }
        if (Array.isArray(this._Groups)) {
            data["_Groups"] = [];
            for (let item of this._Groups)
                data["_Groups"].push(item.toJSON());
        }
        if (Array.isArray(this._Items)) {
            data["_Items"] = [];
            for (let item of this._Items)
                data["_Items"].push(item.toJSON());
        }
        if (Array.isArray(this._VariantCombinations)) {
            data["_VariantCombinations"] = [];
            for (let item of this._VariantCombinations)
                data["_VariantCombinations"].push(item.toJSON());
        }
        if (Array.isArray(this._VariantCombinationsWithStockCheck)) {
            data["_VariantCombinationsWithStockCheck"] = [];
            for (let item of this._VariantCombinationsWithStockCheck)
                data["_VariantCombinationsWithStockCheck"].push(item.toJSON());
        }
        if (Array.isArray(this._PropertyRelations)) {
            data["_PropertyRelations"] = [];
            for (let item of this._PropertyRelations)
                data["_PropertyRelations"].push(item.toJSON());
        }
        if (Array.isArray(this._PropertyProductValues)) {
            data["_PropertyProductValues"] = [];
            for (let item of this._PropertyProductValues)
                data["_PropertyProductValues"].push(item.toJSON());
        }
        if (Array.isArray(this._Details)) {
            data["_Details"] = [];
            for (let item of this._Details)
                data["_Details"].push(item.toJSON());
        }
        if (Array.isArray(this._Prices)) {
            data["_Prices"] = [];
            for (let item of this._Prices)
                data["_Prices"].push(item.toJSON());
        }
        if (Array.isArray(this._Units)) {
            data["_Units"] = [];
            for (let item of this._Units)
                data["_Units"].push(item.toJSON());
        }
        if (Array.isArray(this._UnitsUnique)) {
            data["_UnitsUnique"] = [];
            for (let item of this._UnitsUnique)
                data["_UnitsUnique"].push(item.toJSON());
        }
        if (Array.isArray(this._UnitList)) {
            data["_UnitList"] = [];
            for (let item of this._UnitList)
                data["_UnitList"].push(item.toJSON());
        }
        if (Array.isArray(this._Periods)) {
            data["_Periods"] = [];
            for (let item of this._Periods)
                data["_Periods"].push(item.toJSON());
        }
        data["_Shop"] = this._Shop ? this._Shop.toJSON() : <any>undefined;
        data["_StockGroup"] = this._StockGroup ? this._StockGroup.toJSON() : <any>undefined;
        data["_Manufacturer"] = this._Manufacturer ? this._Manufacturer.toJSON() : <any>undefined;
        data["_Period"] = this._Period ? this._Period.toJSON() : <any>undefined;
        data["_PeriodOfProduct"] = this._PeriodOfProduct ? this._PeriodOfProduct.toJSON() : <any>undefined;
        data["_VatGroup"] = this._VatGroup ? this._VatGroup.toJSON() : <any>undefined;
        if (Array.isArray(this._VatGroups)) {
            data["_VatGroups"] = [];
            for (let item of this._VatGroups)
                data["_VatGroups"].push(item.toJSON());
        }
        data["_PriceMatrixUnit"] = this._PriceMatrixUnit;
        data["_PriceMatrixVariant"] = this._PriceMatrixVariant;
        data["_PriceMatrixPeriod"] = this._PriceMatrixPeriod;
        data["_PriceMatrixMultiplePrices"] = this._PriceMatrixMultiplePrices;
        data["_PriceMatrixQuantitySpecification"] = this._PriceMatrixQuantitySpecification;
        if (Array.isArray(this._ProductFieldValues)) {
            data["_ProductFieldValues"] = [];
            for (let item of this._ProductFieldValues)
                data["_ProductFieldValues"].push(item.toJSON());
        }
        data["_AllowSave"] = this._AllowSave;
        if (Array.isArray(this.cachedDiscounts)) {
            data["CachedDiscounts"] = [];
            for (let item of this.cachedDiscounts)
                data["CachedDiscounts"].push(item.toJSON());
        }
        data["CachedPrice"] = this.cachedPrice ? this.cachedPrice.toJSON() : <any>undefined;
        data["CachedPriceVariantID"] = this.cachedPriceVariantID;
        data["CachedPriceUnitID"] = this.cachedPriceUnitID;
        data["CachedInformativePrice"] = this.cachedInformativePrice ? this.cachedInformativePrice.toJSON() : <any>undefined;
        data["CachedInformativePriceVariantID"] = this.cachedInformativePriceVariantID;
        data["CachedInformativePriceUnitID"] = this.cachedInformativePriceUnitID;
        if (Array.isArray(this.cachedOrderLineFields)) {
            data["CachedOrderLineFields"] = [];
            for (let item of this.cachedOrderLineFields)
                data["CachedOrderLineFields"].push(item.toJSON());
        }
        data["_RelationSorting"] = this._RelationSorting;
        data["_meta"] = this._meta ? this._meta.toJSON() : <any>undefined;
        data["_optimizedFor"] = this._optimizedFor;
        if (this._categoryFieldValues) {
            data["_categoryFieldValues"] = {};
            for (let key in this._categoryFieldValues) {
                if (this._categoryFieldValues.hasOwnProperty(key))
                    data["_categoryFieldValues"][key] = this._categoryFieldValues[key];
            }
        }
        if (Array.isArray(this._taxCollection)) {
            data["_taxCollection"] = [];
            for (let item of this._taxCollection)
                data["_taxCollection"].push(item.toJSON());
        }
        data["_defaultPoints"] = this._defaultPoints;
        data["_PrimaryGroupID"] = this._PrimaryGroupID;
        data["_defaultGroup"] = this._defaultGroup ? this._defaultGroup.toJSON() : <any>undefined;
        data["_IndexingOptions"] = this._IndexingOptions ? this._IndexingOptions.toJSON() : <any>undefined;
        data["_ExcludeFromIndex"] = this._ExcludeFromIndex;
        data["_ExcludeFromCustomizedUrls"] = this._ExcludeFromCustomizedUrls;
        data["_ExcludeFromAllProducts"] = this._ExcludeFromAllProducts;
        data["_ProductPriceString"] = this._ProductPriceString;
        return data; 
    }
}

export interface IProduct {
    _ID?: string | undefined;
    _AutoId?: number | undefined;
    _LanguageID?: string | undefined;
    _DefaultShopID?: string | undefined;
    _Number?: string | undefined;
    _Name?: string | undefined;
    _ShortDescription?: string | undefined;
    _LongDescription?: string | undefined;
    _Stock?: number | undefined;
    _StockGroupID?: string | undefined;
    _Weight?: number | undefined;
    _Volume?: number | undefined;
    _VatGroupID?: string | undefined;
    _ManufacturerID?: string | undefined;
    _Active?: boolean | undefined;
    _PeriodID?: string | undefined;
    _Created?: Date | undefined;
    _Updated?: Date | undefined;
    _CustomFieldsXml?: string | undefined;
    _Type?: Product_Type | undefined;
    _PriceType?: Product_PriceType | undefined;
    _VariantCnt?: number | undefined;
    _VariantProductCnt?: number | undefined;
    _VariantGroupCnt?: number | undefined;
    _PriceCnt?: number | undefined;
    _RelatedCnt?: number | undefined;
    _UnitCnt?: number | undefined;
    _VariantID?: string | undefined;
    _VirtualVariantID?: string | undefined;
    _ImageSmall?: string | undefined;
    _ImageMedium?: string | undefined;
    _ImageLarge?: string | undefined;
    _Link1?: string | undefined;
    _Link2?: string | undefined;
    _Price?: number | undefined;
    _Cost?: number | undefined;
    _Rating?: number | undefined;
    _Solditems?: number | undefined;
    _Commentcount?: number | undefined;
    _DefaultUnitID?: string | undefined;
    _DefaultVariantComboID?: string | undefined;
    _IsVariantMaster?: boolean | undefined;
    _VariantGroups?: VariantGroup[] | undefined;
    _RelatedGroups?: ProductRelatedGroup[] | undefined;
    _RelatedProducts?: ProductRelated[] | undefined;
    _RelatedSearches?: RelatedSmartSearch[] | undefined;
    _Groups?: Group[] | undefined;
    _Items?: ProductItem[] | undefined;
    _VariantCombinations?: VariantCombination[] | undefined;
    _VariantCombinationsWithStockCheck?: VariantCombination[] | undefined;
    _PropertyRelations?: PropertyProductRelation[] | undefined;
    _PropertyProductValues?: PropertyProductValue[] | undefined;
    _Details?: Detail[] | undefined;
    _Prices?: Price[] | undefined;
    _Units?: StockUnit[] | undefined;
    _UnitsUnique?: StockUnit[] | undefined;
    _UnitList?: VariantOption[] | undefined;
    _Periods?: Period[] | undefined;
    _Shop?: Shop | undefined;
    _StockGroup?: StockGroup | undefined;
    _Manufacturer?: Manufacturer | undefined;
    _Period?: Period | undefined;
    _PeriodOfProduct?: Period | undefined;
    _VatGroup?: VatGroup | undefined;
    _VatGroups?: ProductVatGroup[] | undefined;
    _PriceMatrixUnit?: number | undefined;
    _PriceMatrixVariant?: number | undefined;
    _PriceMatrixPeriod?: number | undefined;
    _PriceMatrixMultiplePrices?: number | undefined;
    _PriceMatrixQuantitySpecification?: string | undefined;
    _ProductFieldValues?: ProductFieldValue[] | undefined;
    _AllowSave?: boolean | undefined;
    cachedDiscounts?: Discount[] | undefined;
    cachedPrice?: PriceInfo | undefined;
    cachedPriceVariantID?: string | undefined;
    cachedPriceUnitID?: string | undefined;
    cachedInformativePrice?: PriceInfo | undefined;
    cachedInformativePriceVariantID?: string | undefined;
    cachedInformativePriceUnitID?: string | undefined;
    cachedOrderLineFields?: OrderLineField[] | undefined;
    _RelationSorting?: number | undefined;
    _meta?: MetaData | undefined;
    _optimizedFor?: string | undefined;
    _categoryFieldValues?: { [key: string]: { [key: string]: any; }; } | undefined;
    _taxCollection?: Tax[] | undefined;
    _defaultPoints?: number | undefined;
    _PrimaryGroupID?: string | undefined;
    _defaultGroup?: Group | undefined;
    _IndexingOptions?: ProductIndexingOptions | undefined;
    _ExcludeFromIndex?: boolean | undefined;
    _ExcludeFromCustomizedUrls?: boolean | undefined;
    _ExcludeFromAllProducts?: boolean | undefined;
    _ProductPriceString?: string | undefined;
}

export class VariantGroup implements IVariantGroup {
    _VariantOptions?: VariantOption[] | undefined;
    _Products?: Product[] | undefined;
    _VariantProdRels?: VariantGroupProductRelation[] | undefined;
    _properties?: VariantGroupProperty[] | undefined;
    _Label?: string | undefined;
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _Name?: string | undefined;
    _Unit?: boolean | undefined;
    _PriceDif?: boolean | undefined;

    constructor(data?: IVariantGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["_VariantOptions"])) {
                this._VariantOptions = [] as any;
                for (let item of _data["_VariantOptions"])
                    this._VariantOptions!.push(VariantOption.fromJS(item));
            }
            if (Array.isArray(_data["_Products"])) {
                this._Products = [] as any;
                for (let item of _data["_Products"])
                    this._Products!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["_VariantProdRels"])) {
                this._VariantProdRels = [] as any;
                for (let item of _data["_VariantProdRels"])
                    this._VariantProdRels!.push(VariantGroupProductRelation.fromJS(item));
            }
            if (Array.isArray(_data["_properties"])) {
                this._properties = [] as any;
                for (let item of _data["_properties"])
                    this._properties!.push(VariantGroupProperty.fromJS(item));
            }
            this._Label = _data["_Label"];
            this._ID = _data["_ID"];
            this._LanguageID = _data["_LanguageID"];
            this._Name = _data["_Name"];
            this._Unit = _data["_Unit"];
            this._PriceDif = _data["_PriceDif"];
        }
    }

    static fromJS(data: any): VariantGroup {
        data = typeof data === 'object' ? data : {};
        let result = new VariantGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this._VariantOptions)) {
            data["_VariantOptions"] = [];
            for (let item of this._VariantOptions)
                data["_VariantOptions"].push(item.toJSON());
        }
        if (Array.isArray(this._Products)) {
            data["_Products"] = [];
            for (let item of this._Products)
                data["_Products"].push(item.toJSON());
        }
        if (Array.isArray(this._VariantProdRels)) {
            data["_VariantProdRels"] = [];
            for (let item of this._VariantProdRels)
                data["_VariantProdRels"].push(item.toJSON());
        }
        if (Array.isArray(this._properties)) {
            data["_properties"] = [];
            for (let item of this._properties)
                data["_properties"].push(item.toJSON());
        }
        data["_Label"] = this._Label;
        data["_ID"] = this._ID;
        data["_LanguageID"] = this._LanguageID;
        data["_Name"] = this._Name;
        data["_Unit"] = this._Unit;
        data["_PriceDif"] = this._PriceDif;
        return data; 
    }
}

export interface IVariantGroup {
    _VariantOptions?: VariantOption[] | undefined;
    _Products?: Product[] | undefined;
    _VariantProdRels?: VariantGroupProductRelation[] | undefined;
    _properties?: VariantGroupProperty[] | undefined;
    _Label?: string | undefined;
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _Name?: string | undefined;
    _Unit?: boolean | undefined;
    _PriceDif?: boolean | undefined;
}

export class ProductRelatedGroup implements IProductRelatedGroup {
    _GroupID?: string | undefined;
    _Name?: string | undefined;
    _LanguageID?: string | undefined;
    _SortOrder?: number | undefined;
    _Products?: Product[] | undefined;
    _IsReadOnly?: boolean | undefined;

    constructor(data?: IProductRelatedGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._GroupID = _data["_GroupID"];
            this._Name = _data["_Name"];
            this._LanguageID = _data["_LanguageID"];
            this._SortOrder = _data["_SortOrder"];
            if (Array.isArray(_data["_Products"])) {
                this._Products = [] as any;
                for (let item of _data["_Products"])
                    this._Products!.push(Product.fromJS(item));
            }
            this._IsReadOnly = _data["_IsReadOnly"];
        }
    }

    static fromJS(data: any): ProductRelatedGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ProductRelatedGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_GroupID"] = this._GroupID;
        data["_Name"] = this._Name;
        data["_LanguageID"] = this._LanguageID;
        data["_SortOrder"] = this._SortOrder;
        if (Array.isArray(this._Products)) {
            data["_Products"] = [];
            for (let item of this._Products)
                data["_Products"].push(item.toJSON());
        }
        data["_IsReadOnly"] = this._IsReadOnly;
        return data; 
    }
}

export interface IProductRelatedGroup {
    _GroupID?: string | undefined;
    _Name?: string | undefined;
    _LanguageID?: string | undefined;
    _SortOrder?: number | undefined;
    _Products?: Product[] | undefined;
    _IsReadOnly?: boolean | undefined;
}

export class ProductRelated implements IProductRelated {
    _ProdID?: string | undefined;
    _ProdRelID?: string | undefined;
    _ProdRelVariantID?: string | undefined;
    _RelGroupID?: string | undefined;
    _SortOrder?: number | undefined;
    _Product?: Product | undefined;
    _LanguagesStr?: string | undefined;
    _CountriesStr?: string | undefined;
    _ShopsStr?: string | undefined;
    _Languages?: string[] | undefined;
    _Countries?: string[] | undefined;
    _Shops?: string[] | undefined;
    _VariantOptions?: string[] | undefined;

    constructor(data?: IProductRelated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ProdID = _data["_ProdID"];
            this._ProdRelID = _data["_ProdRelID"];
            this._ProdRelVariantID = _data["_ProdRelVariantID"];
            this._RelGroupID = _data["_RelGroupID"];
            this._SortOrder = _data["_SortOrder"];
            this._Product = _data["_Product"] ? Product.fromJS(_data["_Product"]) : <any>undefined;
            this._LanguagesStr = _data["_LanguagesStr"];
            this._CountriesStr = _data["_CountriesStr"];
            this._ShopsStr = _data["_ShopsStr"];
            if (Array.isArray(_data["_Languages"])) {
                this._Languages = [] as any;
                for (let item of _data["_Languages"])
                    this._Languages!.push(item);
            }
            if (Array.isArray(_data["_Countries"])) {
                this._Countries = [] as any;
                for (let item of _data["_Countries"])
                    this._Countries!.push(item);
            }
            if (Array.isArray(_data["_Shops"])) {
                this._Shops = [] as any;
                for (let item of _data["_Shops"])
                    this._Shops!.push(item);
            }
            if (Array.isArray(_data["_VariantOptions"])) {
                this._VariantOptions = [] as any;
                for (let item of _data["_VariantOptions"])
                    this._VariantOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductRelated {
        data = typeof data === 'object' ? data : {};
        let result = new ProductRelated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ProdID"] = this._ProdID;
        data["_ProdRelID"] = this._ProdRelID;
        data["_ProdRelVariantID"] = this._ProdRelVariantID;
        data["_RelGroupID"] = this._RelGroupID;
        data["_SortOrder"] = this._SortOrder;
        data["_Product"] = this._Product ? this._Product.toJSON() : <any>undefined;
        data["_LanguagesStr"] = this._LanguagesStr;
        data["_CountriesStr"] = this._CountriesStr;
        data["_ShopsStr"] = this._ShopsStr;
        if (Array.isArray(this._Languages)) {
            data["_Languages"] = [];
            for (let item of this._Languages)
                data["_Languages"].push(item);
        }
        if (Array.isArray(this._Countries)) {
            data["_Countries"] = [];
            for (let item of this._Countries)
                data["_Countries"].push(item);
        }
        if (Array.isArray(this._Shops)) {
            data["_Shops"] = [];
            for (let item of this._Shops)
                data["_Shops"].push(item);
        }
        if (Array.isArray(this._VariantOptions)) {
            data["_VariantOptions"] = [];
            for (let item of this._VariantOptions)
                data["_VariantOptions"].push(item);
        }
        return data; 
    }
}

export interface IProductRelated {
    _ProdID?: string | undefined;
    _ProdRelID?: string | undefined;
    _ProdRelVariantID?: string | undefined;
    _RelGroupID?: string | undefined;
    _SortOrder?: number | undefined;
    _Product?: Product | undefined;
    _LanguagesStr?: string | undefined;
    _CountriesStr?: string | undefined;
    _ShopsStr?: string | undefined;
    _Languages?: string[] | undefined;
    _Countries?: string[] | undefined;
    _Shops?: string[] | undefined;
    _VariantOptions?: string[] | undefined;
}

export class RelatedSmartSearch implements IRelatedSmartSearch {
    _GroupID?: string | undefined;
    _ProductID?: string | undefined;
    _LanguageID?: string | undefined;
    _SmartSearchID?: string | undefined;

    constructor(data?: IRelatedSmartSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._GroupID = _data["_GroupID"];
            this._ProductID = _data["_ProductID"];
            this._LanguageID = _data["_LanguageID"];
            this._SmartSearchID = _data["_SmartSearchID"];
        }
    }

    static fromJS(data: any): RelatedSmartSearch {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedSmartSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_GroupID"] = this._GroupID;
        data["_ProductID"] = this._ProductID;
        data["_LanguageID"] = this._LanguageID;
        data["_SmartSearchID"] = this._SmartSearchID;
        return data; 
    }
}

export interface IRelatedSmartSearch {
    _GroupID?: string | undefined;
    _ProductID?: string | undefined;
    _LanguageID?: string | undefined;
    _SmartSearchID?: string | undefined;
}

export class Group implements IGroup {
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _Name?: string | undefined;
    _Number?: string | undefined;
    _PageIDRel?: number | undefined;
    _LargeImage?: string | undefined;
    _SmallImage?: string | undefined;
    _Description?: string | undefined;
    _Assortment?: boolean | undefined;
    _Icon?: string | undefined;
    _meta?: MetaData2 | undefined;
    _Products?: Product[] | undefined;
    _ProductsWithOutVariants?: Product[] | undefined;
    _RelatedSearches?: RelatedSmartSearch[] | undefined;
    _ParentGroups?: Group[] | undefined;
    _ProductGroupFieldValues?: ProductGroupFieldValue[] | undefined;
    _InheritOrderLineFields?: boolean | undefined;
    _NavigationShowInMenu?: boolean | undefined;
    _NavigationShowInSiteMap?: boolean | undefined;
    _NavigationClickable?: boolean | undefined;
    _userPermissions?: UserPermission | undefined;
    _IsChecked?: boolean | undefined;
    _ProductGroups?: Group[] | undefined;
    _relatedGroupIds?: string | undefined;
    _relatedProductIds?: string | undefined;
    _manufacturerID?: string | undefined;
    _vatGroupID?: string | undefined;
    _stockGroupID?: string | undefined;
    _productType?: number | undefined;
    _ShopID?: string | undefined;
    _category?: Category | undefined;
    _FilterExecution?: GroupFilterExecutionSettings | undefined;
    _categoryFieldValues?: { [key: string]: { [key: string]: any; }; } | undefined;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._LanguageID = _data["_LanguageID"];
            this._Name = _data["_Name"];
            this._Number = _data["_Number"];
            this._PageIDRel = _data["_PageIDRel"];
            this._LargeImage = _data["_LargeImage"];
            this._SmallImage = _data["_SmallImage"];
            this._Description = _data["_Description"];
            this._Assortment = _data["_Assortment"];
            this._Icon = _data["_Icon"];
            this._meta = _data["_meta"] ? MetaData2.fromJS(_data["_meta"]) : <any>undefined;
            if (Array.isArray(_data["_Products"])) {
                this._Products = [] as any;
                for (let item of _data["_Products"])
                    this._Products!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["_ProductsWithOutVariants"])) {
                this._ProductsWithOutVariants = [] as any;
                for (let item of _data["_ProductsWithOutVariants"])
                    this._ProductsWithOutVariants!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["_RelatedSearches"])) {
                this._RelatedSearches = [] as any;
                for (let item of _data["_RelatedSearches"])
                    this._RelatedSearches!.push(RelatedSmartSearch.fromJS(item));
            }
            if (Array.isArray(_data["_ParentGroups"])) {
                this._ParentGroups = [] as any;
                for (let item of _data["_ParentGroups"])
                    this._ParentGroups!.push(Group.fromJS(item));
            }
            if (Array.isArray(_data["_ProductGroupFieldValues"])) {
                this._ProductGroupFieldValues = [] as any;
                for (let item of _data["_ProductGroupFieldValues"])
                    this._ProductGroupFieldValues!.push(ProductGroupFieldValue.fromJS(item));
            }
            this._InheritOrderLineFields = _data["_InheritOrderLineFields"];
            this._NavigationShowInMenu = _data["_NavigationShowInMenu"];
            this._NavigationShowInSiteMap = _data["_NavigationShowInSiteMap"];
            this._NavigationClickable = _data["_NavigationClickable"];
            this._userPermissions = _data["_userPermissions"] ? UserPermission.fromJS(_data["_userPermissions"]) : <any>undefined;
            this._IsChecked = _data["_IsChecked"];
            if (Array.isArray(_data["_ProductGroups"])) {
                this._ProductGroups = [] as any;
                for (let item of _data["_ProductGroups"])
                    this._ProductGroups!.push(Group.fromJS(item));
            }
            this._relatedGroupIds = _data["_relatedGroupIds"];
            this._relatedProductIds = _data["_relatedProductIds"];
            this._manufacturerID = _data["_manufacturerID"];
            this._vatGroupID = _data["_vatGroupID"];
            this._stockGroupID = _data["_stockGroupID"];
            this._productType = _data["_productType"];
            this._ShopID = _data["_ShopID"];
            this._category = _data["_category"] ? Category.fromJS(_data["_category"]) : <any>undefined;
            this._FilterExecution = _data["_FilterExecution"] ? GroupFilterExecutionSettings.fromJS(_data["_FilterExecution"]) : <any>undefined;
            if (_data["_categoryFieldValues"]) {
                this._categoryFieldValues = {} as any;
                for (let key in _data["_categoryFieldValues"]) {
                    if (_data["_categoryFieldValues"].hasOwnProperty(key))
                        this._categoryFieldValues![key] = _data["_categoryFieldValues"][key] !== undefined ? _data["_categoryFieldValues"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_LanguageID"] = this._LanguageID;
        data["_Name"] = this._Name;
        data["_Number"] = this._Number;
        data["_PageIDRel"] = this._PageIDRel;
        data["_LargeImage"] = this._LargeImage;
        data["_SmallImage"] = this._SmallImage;
        data["_Description"] = this._Description;
        data["_Assortment"] = this._Assortment;
        data["_Icon"] = this._Icon;
        data["_meta"] = this._meta ? this._meta.toJSON() : <any>undefined;
        if (Array.isArray(this._Products)) {
            data["_Products"] = [];
            for (let item of this._Products)
                data["_Products"].push(item.toJSON());
        }
        if (Array.isArray(this._ProductsWithOutVariants)) {
            data["_ProductsWithOutVariants"] = [];
            for (let item of this._ProductsWithOutVariants)
                data["_ProductsWithOutVariants"].push(item.toJSON());
        }
        if (Array.isArray(this._RelatedSearches)) {
            data["_RelatedSearches"] = [];
            for (let item of this._RelatedSearches)
                data["_RelatedSearches"].push(item.toJSON());
        }
        if (Array.isArray(this._ParentGroups)) {
            data["_ParentGroups"] = [];
            for (let item of this._ParentGroups)
                data["_ParentGroups"].push(item.toJSON());
        }
        if (Array.isArray(this._ProductGroupFieldValues)) {
            data["_ProductGroupFieldValues"] = [];
            for (let item of this._ProductGroupFieldValues)
                data["_ProductGroupFieldValues"].push(item.toJSON());
        }
        data["_InheritOrderLineFields"] = this._InheritOrderLineFields;
        data["_NavigationShowInMenu"] = this._NavigationShowInMenu;
        data["_NavigationShowInSiteMap"] = this._NavigationShowInSiteMap;
        data["_NavigationClickable"] = this._NavigationClickable;
        data["_userPermissions"] = this._userPermissions ? this._userPermissions.toJSON() : <any>undefined;
        data["_IsChecked"] = this._IsChecked;
        if (Array.isArray(this._ProductGroups)) {
            data["_ProductGroups"] = [];
            for (let item of this._ProductGroups)
                data["_ProductGroups"].push(item.toJSON());
        }
        data["_relatedGroupIds"] = this._relatedGroupIds;
        data["_relatedProductIds"] = this._relatedProductIds;
        data["_manufacturerID"] = this._manufacturerID;
        data["_vatGroupID"] = this._vatGroupID;
        data["_stockGroupID"] = this._stockGroupID;
        data["_productType"] = this._productType;
        data["_ShopID"] = this._ShopID;
        data["_category"] = this._category ? this._category.toJSON() : <any>undefined;
        data["_FilterExecution"] = this._FilterExecution ? this._FilterExecution.toJSON() : <any>undefined;
        if (this._categoryFieldValues) {
            data["_categoryFieldValues"] = {};
            for (let key in this._categoryFieldValues) {
                if (this._categoryFieldValues.hasOwnProperty(key))
                    data["_categoryFieldValues"][key] = this._categoryFieldValues[key];
            }
        }
        return data; 
    }
}

export interface IGroup {
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _Name?: string | undefined;
    _Number?: string | undefined;
    _PageIDRel?: number | undefined;
    _LargeImage?: string | undefined;
    _SmallImage?: string | undefined;
    _Description?: string | undefined;
    _Assortment?: boolean | undefined;
    _Icon?: string | undefined;
    _meta?: MetaData2 | undefined;
    _Products?: Product[] | undefined;
    _ProductsWithOutVariants?: Product[] | undefined;
    _RelatedSearches?: RelatedSmartSearch[] | undefined;
    _ParentGroups?: Group[] | undefined;
    _ProductGroupFieldValues?: ProductGroupFieldValue[] | undefined;
    _InheritOrderLineFields?: boolean | undefined;
    _NavigationShowInMenu?: boolean | undefined;
    _NavigationShowInSiteMap?: boolean | undefined;
    _NavigationClickable?: boolean | undefined;
    _userPermissions?: UserPermission | undefined;
    _IsChecked?: boolean | undefined;
    _ProductGroups?: Group[] | undefined;
    _relatedGroupIds?: string | undefined;
    _relatedProductIds?: string | undefined;
    _manufacturerID?: string | undefined;
    _vatGroupID?: string | undefined;
    _stockGroupID?: string | undefined;
    _productType?: number | undefined;
    _ShopID?: string | undefined;
    _category?: Category | undefined;
    _FilterExecution?: GroupFilterExecutionSettings | undefined;
    _categoryFieldValues?: { [key: string]: { [key: string]: any; }; } | undefined;
}

export class ProductItem implements IProductItem {
    _ID?: string | undefined;
    _ProductID?: string | undefined;
    _Name?: string | undefined;
    _Required?: boolean | undefined;
    _BomProductID?: string | undefined;
    _BomGroupID?: string | undefined;
    _BomNoProductText?: string | undefined;
    _Quantity?: number | undefined;
    _DefaultProductID?: string | undefined;
    _SortOrder?: number | undefined;
    _Products?: Product[] | undefined;
    _BomVariantID?: string | undefined;

    constructor(data?: IProductItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._ProductID = _data["_ProductID"];
            this._Name = _data["_Name"];
            this._Required = _data["_Required"];
            this._BomProductID = _data["_BomProductID"];
            this._BomGroupID = _data["_BomGroupID"];
            this._BomNoProductText = _data["_BomNoProductText"];
            this._Quantity = _data["_Quantity"];
            this._DefaultProductID = _data["_DefaultProductID"];
            this._SortOrder = _data["_SortOrder"];
            if (Array.isArray(_data["_Products"])) {
                this._Products = [] as any;
                for (let item of _data["_Products"])
                    this._Products!.push(Product.fromJS(item));
            }
            this._BomVariantID = _data["_BomVariantID"];
        }
    }

    static fromJS(data: any): ProductItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProductItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_ProductID"] = this._ProductID;
        data["_Name"] = this._Name;
        data["_Required"] = this._Required;
        data["_BomProductID"] = this._BomProductID;
        data["_BomGroupID"] = this._BomGroupID;
        data["_BomNoProductText"] = this._BomNoProductText;
        data["_Quantity"] = this._Quantity;
        data["_DefaultProductID"] = this._DefaultProductID;
        data["_SortOrder"] = this._SortOrder;
        if (Array.isArray(this._Products)) {
            data["_Products"] = [];
            for (let item of this._Products)
                data["_Products"].push(item.toJSON());
        }
        data["_BomVariantID"] = this._BomVariantID;
        return data; 
    }
}

export interface IProductItem {
    _ID?: string | undefined;
    _ProductID?: string | undefined;
    _Name?: string | undefined;
    _Required?: boolean | undefined;
    _BomProductID?: string | undefined;
    _BomGroupID?: string | undefined;
    _BomNoProductText?: string | undefined;
    _Quantity?: number | undefined;
    _DefaultProductID?: string | undefined;
    _SortOrder?: number | undefined;
    _Products?: Product[] | undefined;
    _BomVariantID?: string | undefined;
}

export class VariantCombination implements IVariantCombination {
    _VariantOptions?: VariantOption[] | undefined;
    _Product?: Product | undefined;
    _ProductID?: string | undefined;
    _VariantText?: string | undefined;
    _VariantID?: string | undefined;
    _SimpleVariant?: boolean | undefined;
    _ProductStock?: number | undefined;

    constructor(data?: IVariantCombination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["_VariantOptions"])) {
                this._VariantOptions = [] as any;
                for (let item of _data["_VariantOptions"])
                    this._VariantOptions!.push(VariantOption.fromJS(item));
            }
            this._Product = _data["_Product"] ? Product.fromJS(_data["_Product"]) : <any>undefined;
            this._ProductID = _data["_ProductID"];
            this._VariantText = _data["_VariantText"];
            this._VariantID = _data["_VariantID"];
            this._SimpleVariant = _data["_SimpleVariant"];
            this._ProductStock = _data["_ProductStock"];
        }
    }

    static fromJS(data: any): VariantCombination {
        data = typeof data === 'object' ? data : {};
        let result = new VariantCombination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this._VariantOptions)) {
            data["_VariantOptions"] = [];
            for (let item of this._VariantOptions)
                data["_VariantOptions"].push(item.toJSON());
        }
        data["_Product"] = this._Product ? this._Product.toJSON() : <any>undefined;
        data["_ProductID"] = this._ProductID;
        data["_VariantText"] = this._VariantText;
        data["_VariantID"] = this._VariantID;
        data["_SimpleVariant"] = this._SimpleVariant;
        data["_ProductStock"] = this._ProductStock;
        return data; 
    }
}

export interface IVariantCombination {
    _VariantOptions?: VariantOption[] | undefined;
    _Product?: Product | undefined;
    _ProductID?: string | undefined;
    _VariantText?: string | undefined;
    _VariantID?: string | undefined;
    _SimpleVariant?: boolean | undefined;
    _ProductStock?: number | undefined;
}

export class PropertyProductRelation implements IPropertyProductRelation {
    _ProductID?: string | undefined;
    _TypeID?: string | undefined;
    _TypeName?: string | undefined;
    _PropertyGroups?: PropertyGroup[] | undefined;

    constructor(data?: IPropertyProductRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ProductID = _data["_ProductID"];
            this._TypeID = _data["_TypeID"];
            this._TypeName = _data["_TypeName"];
            if (Array.isArray(_data["_PropertyGroups"])) {
                this._PropertyGroups = [] as any;
                for (let item of _data["_PropertyGroups"])
                    this._PropertyGroups!.push(PropertyGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyProductRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyProductRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ProductID"] = this._ProductID;
        data["_TypeID"] = this._TypeID;
        data["_TypeName"] = this._TypeName;
        if (Array.isArray(this._PropertyGroups)) {
            data["_PropertyGroups"] = [];
            for (let item of this._PropertyGroups)
                data["_PropertyGroups"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPropertyProductRelation {
    _ProductID?: string | undefined;
    _TypeID?: string | undefined;
    _TypeName?: string | undefined;
    _PropertyGroups?: PropertyGroup[] | undefined;
}

export class PropertyProductValue implements IPropertyProductValue {
    _ProductID?: string | undefined;
    _VariantID?: string | undefined;
    _LanguageID?: string | undefined;
    _GroupID?: string | undefined;
    _FieldID?: string | undefined;
    _TypeID?: string | undefined;
    _Value?: string | undefined;

    constructor(data?: IPropertyProductValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ProductID = _data["_ProductID"];
            this._VariantID = _data["_VariantID"];
            this._LanguageID = _data["_LanguageID"];
            this._GroupID = _data["_GroupID"];
            this._FieldID = _data["_FieldID"];
            this._TypeID = _data["_TypeID"];
            this._Value = _data["_Value"];
        }
    }

    static fromJS(data: any): PropertyProductValue {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyProductValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ProductID"] = this._ProductID;
        data["_VariantID"] = this._VariantID;
        data["_LanguageID"] = this._LanguageID;
        data["_GroupID"] = this._GroupID;
        data["_FieldID"] = this._FieldID;
        data["_TypeID"] = this._TypeID;
        data["_Value"] = this._Value;
        return data; 
    }
}

export interface IPropertyProductValue {
    _ProductID?: string | undefined;
    _VariantID?: string | undefined;
    _LanguageID?: string | undefined;
    _GroupID?: string | undefined;
    _FieldID?: string | undefined;
    _TypeID?: string | undefined;
    _Value?: string | undefined;
}

export class Detail implements IDetail {
    _ID?: string | undefined;
    _ProductID?: string | undefined;
    _VariantID?: string | undefined;
    _LanguageID?: string | undefined;
    _Type?: number | undefined;
    _Value?: string | undefined;
    _SortOrder?: number | undefined;

    constructor(data?: IDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._ProductID = _data["_ProductID"];
            this._VariantID = _data["_VariantID"];
            this._LanguageID = _data["_LanguageID"];
            this._Type = _data["_Type"];
            this._Value = _data["_Value"];
            this._SortOrder = _data["_SortOrder"];
        }
    }

    static fromJS(data: any): Detail {
        data = typeof data === 'object' ? data : {};
        let result = new Detail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_ProductID"] = this._ProductID;
        data["_VariantID"] = this._VariantID;
        data["_LanguageID"] = this._LanguageID;
        data["_Type"] = this._Type;
        data["_Value"] = this._Value;
        data["_SortOrder"] = this._SortOrder;
        return data; 
    }
}

export interface IDetail {
    _ID?: string | undefined;
    _ProductID?: string | undefined;
    _VariantID?: string | undefined;
    _LanguageID?: string | undefined;
    _Type?: number | undefined;
    _Value?: string | undefined;
    _SortOrder?: number | undefined;
}

export class Price implements IPrice {
    _ID?: string | undefined;
    _ProductID?: string | undefined;
    _VariantID?: string | undefined;
    _LanguageID?: string | undefined;
    _UnitID?: string | undefined;
    _CurrencyCode?: string | undefined;
    _Quantity?: number | undefined;
    _Amount?: number | undefined;
    _PeriodID?: string | undefined;
    _CustomerGroupID?: string | undefined;
    _Priority?: number | undefined;
    _IsInformative?: boolean | undefined;
    _Units?: VariantOption[] | undefined;
    _Currency?: Currency | undefined;
    _VariantOptions?: VariantOption[] | undefined;
    _Periods?: Period[] | undefined;
    _CurrencyPrices?: Price[] | undefined;
    _User?: User | undefined;
    _Country?: Country | undefined;
    _Shop?: Shop | undefined;
    _UserGroup?: Group2 | undefined;
    _AmountString?: string | undefined;
    _CountryCode?: string | undefined;
    _ShopID?: string | undefined;
    _ValidFrom?: Date | undefined;
    _ValidTo?: Date | undefined;
    _UserID?: string | undefined;
    _UserGroupID?: string | undefined;
    _UserCustomerNumber?: string | undefined;
    _StockLocationID?: number | undefined;

    constructor(data?: IPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._ProductID = _data["_ProductID"];
            this._VariantID = _data["_VariantID"];
            this._LanguageID = _data["_LanguageID"];
            this._UnitID = _data["_UnitID"];
            this._CurrencyCode = _data["_CurrencyCode"];
            this._Quantity = _data["_Quantity"];
            this._Amount = _data["_Amount"];
            this._PeriodID = _data["_PeriodID"];
            this._CustomerGroupID = _data["_CustomerGroupID"];
            this._Priority = _data["_Priority"];
            this._IsInformative = _data["_IsInformative"];
            if (Array.isArray(_data["_Units"])) {
                this._Units = [] as any;
                for (let item of _data["_Units"])
                    this._Units!.push(VariantOption.fromJS(item));
            }
            this._Currency = _data["_Currency"] ? Currency.fromJS(_data["_Currency"]) : <any>undefined;
            if (Array.isArray(_data["_VariantOptions"])) {
                this._VariantOptions = [] as any;
                for (let item of _data["_VariantOptions"])
                    this._VariantOptions!.push(VariantOption.fromJS(item));
            }
            if (Array.isArray(_data["_Periods"])) {
                this._Periods = [] as any;
                for (let item of _data["_Periods"])
                    this._Periods!.push(Period.fromJS(item));
            }
            if (Array.isArray(_data["_CurrencyPrices"])) {
                this._CurrencyPrices = [] as any;
                for (let item of _data["_CurrencyPrices"])
                    this._CurrencyPrices!.push(Price.fromJS(item));
            }
            this._User = _data["_User"] ? User.fromJS(_data["_User"]) : <any>undefined;
            this._Country = _data["_Country"] ? Country.fromJS(_data["_Country"]) : <any>undefined;
            this._Shop = _data["_Shop"] ? Shop.fromJS(_data["_Shop"]) : <any>undefined;
            this._UserGroup = _data["_UserGroup"] ? Group2.fromJS(_data["_UserGroup"]) : <any>undefined;
            this._AmountString = _data["_AmountString"];
            this._CountryCode = _data["_CountryCode"];
            this._ShopID = _data["_ShopID"];
            this._ValidFrom = _data["_ValidFrom"] ? new Date(_data["_ValidFrom"].toString()) : <any>undefined;
            this._ValidTo = _data["_ValidTo"] ? new Date(_data["_ValidTo"].toString()) : <any>undefined;
            this._UserID = _data["_UserID"];
            this._UserGroupID = _data["_UserGroupID"];
            this._UserCustomerNumber = _data["_UserCustomerNumber"];
            this._StockLocationID = _data["_StockLocationID"];
        }
    }

    static fromJS(data: any): Price {
        data = typeof data === 'object' ? data : {};
        let result = new Price();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_ProductID"] = this._ProductID;
        data["_VariantID"] = this._VariantID;
        data["_LanguageID"] = this._LanguageID;
        data["_UnitID"] = this._UnitID;
        data["_CurrencyCode"] = this._CurrencyCode;
        data["_Quantity"] = this._Quantity;
        data["_Amount"] = this._Amount;
        data["_PeriodID"] = this._PeriodID;
        data["_CustomerGroupID"] = this._CustomerGroupID;
        data["_Priority"] = this._Priority;
        data["_IsInformative"] = this._IsInformative;
        if (Array.isArray(this._Units)) {
            data["_Units"] = [];
            for (let item of this._Units)
                data["_Units"].push(item.toJSON());
        }
        data["_Currency"] = this._Currency ? this._Currency.toJSON() : <any>undefined;
        if (Array.isArray(this._VariantOptions)) {
            data["_VariantOptions"] = [];
            for (let item of this._VariantOptions)
                data["_VariantOptions"].push(item.toJSON());
        }
        if (Array.isArray(this._Periods)) {
            data["_Periods"] = [];
            for (let item of this._Periods)
                data["_Periods"].push(item.toJSON());
        }
        if (Array.isArray(this._CurrencyPrices)) {
            data["_CurrencyPrices"] = [];
            for (let item of this._CurrencyPrices)
                data["_CurrencyPrices"].push(item.toJSON());
        }
        data["_User"] = this._User ? this._User.toJSON() : <any>undefined;
        data["_Country"] = this._Country ? this._Country.toJSON() : <any>undefined;
        data["_Shop"] = this._Shop ? this._Shop.toJSON() : <any>undefined;
        data["_UserGroup"] = this._UserGroup ? this._UserGroup.toJSON() : <any>undefined;
        data["_AmountString"] = this._AmountString;
        data["_CountryCode"] = this._CountryCode;
        data["_ShopID"] = this._ShopID;
        data["_ValidFrom"] = this._ValidFrom ? this._ValidFrom.toISOString() : <any>undefined;
        data["_ValidTo"] = this._ValidTo ? this._ValidTo.toISOString() : <any>undefined;
        data["_UserID"] = this._UserID;
        data["_UserGroupID"] = this._UserGroupID;
        data["_UserCustomerNumber"] = this._UserCustomerNumber;
        data["_StockLocationID"] = this._StockLocationID;
        return data; 
    }
}

export interface IPrice {
    _ID?: string | undefined;
    _ProductID?: string | undefined;
    _VariantID?: string | undefined;
    _LanguageID?: string | undefined;
    _UnitID?: string | undefined;
    _CurrencyCode?: string | undefined;
    _Quantity?: number | undefined;
    _Amount?: number | undefined;
    _PeriodID?: string | undefined;
    _CustomerGroupID?: string | undefined;
    _Priority?: number | undefined;
    _IsInformative?: boolean | undefined;
    _Units?: VariantOption[] | undefined;
    _Currency?: Currency | undefined;
    _VariantOptions?: VariantOption[] | undefined;
    _Periods?: Period[] | undefined;
    _CurrencyPrices?: Price[] | undefined;
    _User?: User | undefined;
    _Country?: Country | undefined;
    _Shop?: Shop | undefined;
    _UserGroup?: Group2 | undefined;
    _AmountString?: string | undefined;
    _CountryCode?: string | undefined;
    _ShopID?: string | undefined;
    _ValidFrom?: Date | undefined;
    _ValidTo?: Date | undefined;
    _UserID?: string | undefined;
    _UserGroupID?: string | undefined;
    _UserCustomerNumber?: string | undefined;
    _StockLocationID?: number | undefined;
}

export class StockUnit implements IStockUnit {
    _ProductID?: string | undefined;
    _VariantID?: string | undefined;
    _UnitID?: string | undefined;
    _StockQuantity?: number | undefined;
    _Weight?: number | undefined;
    _Volume?: number | undefined;
    _StockLocationID?: number | undefined;
    _RowID?: number | undefined;

    constructor(data?: IStockUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ProductID = _data["_ProductID"];
            this._VariantID = _data["_VariantID"];
            this._UnitID = _data["_UnitID"];
            this._StockQuantity = _data["_StockQuantity"];
            this._Weight = _data["_Weight"];
            this._Volume = _data["_Volume"];
            this._StockLocationID = _data["_StockLocationID"];
            this._RowID = _data["_RowID"];
        }
    }

    static fromJS(data: any): StockUnit {
        data = typeof data === 'object' ? data : {};
        let result = new StockUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ProductID"] = this._ProductID;
        data["_VariantID"] = this._VariantID;
        data["_UnitID"] = this._UnitID;
        data["_StockQuantity"] = this._StockQuantity;
        data["_Weight"] = this._Weight;
        data["_Volume"] = this._Volume;
        data["_StockLocationID"] = this._StockLocationID;
        data["_RowID"] = this._RowID;
        return data; 
    }
}

export interface IStockUnit {
    _ProductID?: string | undefined;
    _VariantID?: string | undefined;
    _UnitID?: string | undefined;
    _StockQuantity?: number | undefined;
    _Weight?: number | undefined;
    _Volume?: number | undefined;
    _StockLocationID?: number | undefined;
    _RowID?: number | undefined;
}

export class VariantOption implements IVariantOption {
    _ID?: string | undefined;
    _GroupID?: string | undefined;
    _LanguageID?: string | undefined;
    _Name?: string | undefined;
    _SortOrder?: number | undefined;
    _ImgSmall?: string | undefined;
    _ImgMedium?: string | undefined;
    _ImgLarge?: string | undefined;

    constructor(data?: IVariantOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._GroupID = _data["_GroupID"];
            this._LanguageID = _data["_LanguageID"];
            this._Name = _data["_Name"];
            this._SortOrder = _data["_SortOrder"];
            this._ImgSmall = _data["_ImgSmall"];
            this._ImgMedium = _data["_ImgMedium"];
            this._ImgLarge = _data["_ImgLarge"];
        }
    }

    static fromJS(data: any): VariantOption {
        data = typeof data === 'object' ? data : {};
        let result = new VariantOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_GroupID"] = this._GroupID;
        data["_LanguageID"] = this._LanguageID;
        data["_Name"] = this._Name;
        data["_SortOrder"] = this._SortOrder;
        data["_ImgSmall"] = this._ImgSmall;
        data["_ImgMedium"] = this._ImgMedium;
        data["_ImgLarge"] = this._ImgLarge;
        return data; 
    }
}

export interface IVariantOption {
    _ID?: string | undefined;
    _GroupID?: string | undefined;
    _LanguageID?: string | undefined;
    _Name?: string | undefined;
    _SortOrder?: number | undefined;
    _ImgSmall?: string | undefined;
    _ImgMedium?: string | undefined;
    _ImgLarge?: string | undefined;
}

export class Period implements IPeriod {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _StartDate?: Date | undefined;
    _EndDate?: Date | undefined;
    _Always?: boolean | undefined;
    _Active?: boolean | undefined;
    _CreatedDate?: Date | undefined;
    _IsReadOnly?: boolean | undefined;
    _ShowProductsAfterExpiration?: boolean | undefined;
    _Hidden?: boolean | undefined;

    constructor(data?: IPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._Name = _data["_Name"];
            this._StartDate = _data["_StartDate"] ? new Date(_data["_StartDate"].toString()) : <any>undefined;
            this._EndDate = _data["_EndDate"] ? new Date(_data["_EndDate"].toString()) : <any>undefined;
            this._Always = _data["_Always"];
            this._Active = _data["_Active"];
            this._CreatedDate = _data["_CreatedDate"] ? new Date(_data["_CreatedDate"].toString()) : <any>undefined;
            this._IsReadOnly = _data["_IsReadOnly"];
            this._ShowProductsAfterExpiration = _data["_ShowProductsAfterExpiration"];
            this._Hidden = _data["_Hidden"];
        }
    }

    static fromJS(data: any): Period {
        data = typeof data === 'object' ? data : {};
        let result = new Period();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_Name"] = this._Name;
        data["_StartDate"] = this._StartDate ? this._StartDate.toISOString() : <any>undefined;
        data["_EndDate"] = this._EndDate ? this._EndDate.toISOString() : <any>undefined;
        data["_Always"] = this._Always;
        data["_Active"] = this._Active;
        data["_CreatedDate"] = this._CreatedDate ? this._CreatedDate.toISOString() : <any>undefined;
        data["_IsReadOnly"] = this._IsReadOnly;
        data["_ShowProductsAfterExpiration"] = this._ShowProductsAfterExpiration;
        data["_Hidden"] = this._Hidden;
        return data; 
    }
}

export interface IPeriod {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _StartDate?: Date | undefined;
    _EndDate?: Date | undefined;
    _Always?: boolean | undefined;
    _Active?: boolean | undefined;
    _CreatedDate?: Date | undefined;
    _IsReadOnly?: boolean | undefined;
    _ShowProductsAfterExpiration?: boolean | undefined;
    _Hidden?: boolean | undefined;
}

export class Shop implements IShop {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _Created?: Date | undefined;
    _IsDefault?: boolean | undefined;
    _IsReadOnly?: boolean | undefined;
    _Icon?: string | undefined;
    _orderFlowId?: number | undefined;
    _userPermission?: UserPermission | undefined;
    _stockStateId?: string | undefined;
    _orderContextId?: string | undefined;
    _langs?: Language[] | undefined;
    _defLangId?: string | undefined;
    _StockLocationID?: number | undefined;

    constructor(data?: IShop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._Name = _data["_Name"];
            this._Created = _data["_Created"] ? new Date(_data["_Created"].toString()) : <any>undefined;
            this._IsDefault = _data["_IsDefault"];
            this._IsReadOnly = _data["_IsReadOnly"];
            this._Icon = _data["_Icon"];
            this._orderFlowId = _data["_orderFlowId"];
            this._userPermission = _data["_userPermission"] ? UserPermission.fromJS(_data["_userPermission"]) : <any>undefined;
            this._stockStateId = _data["_stockStateId"];
            this._orderContextId = _data["_orderContextId"];
            if (Array.isArray(_data["_langs"])) {
                this._langs = [] as any;
                for (let item of _data["_langs"])
                    this._langs!.push(Language.fromJS(item));
            }
            this._defLangId = _data["_defLangId"];
            this._StockLocationID = _data["_StockLocationID"];
        }
    }

    static fromJS(data: any): Shop {
        data = typeof data === 'object' ? data : {};
        let result = new Shop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_Name"] = this._Name;
        data["_Created"] = this._Created ? this._Created.toISOString() : <any>undefined;
        data["_IsDefault"] = this._IsDefault;
        data["_IsReadOnly"] = this._IsReadOnly;
        data["_Icon"] = this._Icon;
        data["_orderFlowId"] = this._orderFlowId;
        data["_userPermission"] = this._userPermission ? this._userPermission.toJSON() : <any>undefined;
        data["_stockStateId"] = this._stockStateId;
        data["_orderContextId"] = this._orderContextId;
        if (Array.isArray(this._langs)) {
            data["_langs"] = [];
            for (let item of this._langs)
                data["_langs"].push(item.toJSON());
        }
        data["_defLangId"] = this._defLangId;
        data["_StockLocationID"] = this._StockLocationID;
        return data; 
    }
}

export interface IShop {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _Created?: Date | undefined;
    _IsDefault?: boolean | undefined;
    _IsReadOnly?: boolean | undefined;
    _Icon?: string | undefined;
    _orderFlowId?: number | undefined;
    _userPermission?: UserPermission | undefined;
    _stockStateId?: string | undefined;
    _orderContextId?: string | undefined;
    _langs?: Language[] | undefined;
    _defLangId?: string | undefined;
    _StockLocationID?: number | undefined;
}

export class StockGroup implements IStockGroup {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _StockStatuses?: StockStatus[] | undefined;
    _IsReadOnly?: boolean | undefined;

    constructor(data?: IStockGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._Name = _data["_Name"];
            if (Array.isArray(_data["_StockStatuses"])) {
                this._StockStatuses = [] as any;
                for (let item of _data["_StockStatuses"])
                    this._StockStatuses!.push(StockStatus.fromJS(item));
            }
            this._IsReadOnly = _data["_IsReadOnly"];
        }
    }

    static fromJS(data: any): StockGroup {
        data = typeof data === 'object' ? data : {};
        let result = new StockGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_Name"] = this._Name;
        if (Array.isArray(this._StockStatuses)) {
            data["_StockStatuses"] = [];
            for (let item of this._StockStatuses)
                data["_StockStatuses"].push(item.toJSON());
        }
        data["_IsReadOnly"] = this._IsReadOnly;
        return data; 
    }
}

export interface IStockGroup {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _StockStatuses?: StockStatus[] | undefined;
    _IsReadOnly?: boolean | undefined;
}

export class Manufacturer implements IManufacturer {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _Address?: string | undefined;
    _ZipCode?: string | undefined;
    _City?: string | undefined;
    _Country?: string | undefined;
    _Phone?: string | undefined;
    _Fax?: string | undefined;
    _Email?: string | undefined;
    _Web?: string | undefined;
    _Logo?: string | undefined;
    _Description?: string | undefined;

    constructor(data?: IManufacturer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._Name = _data["_Name"];
            this._Address = _data["_Address"];
            this._ZipCode = _data["_ZipCode"];
            this._City = _data["_City"];
            this._Country = _data["_Country"];
            this._Phone = _data["_Phone"];
            this._Fax = _data["_Fax"];
            this._Email = _data["_Email"];
            this._Web = _data["_Web"];
            this._Logo = _data["_Logo"];
            this._Description = _data["_Description"];
        }
    }

    static fromJS(data: any): Manufacturer {
        data = typeof data === 'object' ? data : {};
        let result = new Manufacturer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_Name"] = this._Name;
        data["_Address"] = this._Address;
        data["_ZipCode"] = this._ZipCode;
        data["_City"] = this._City;
        data["_Country"] = this._Country;
        data["_Phone"] = this._Phone;
        data["_Fax"] = this._Fax;
        data["_Email"] = this._Email;
        data["_Web"] = this._Web;
        data["_Logo"] = this._Logo;
        data["_Description"] = this._Description;
        return data; 
    }
}

export interface IManufacturer {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _Address?: string | undefined;
    _ZipCode?: string | undefined;
    _City?: string | undefined;
    _Country?: string | undefined;
    _Phone?: string | undefined;
    _Fax?: string | undefined;
    _Email?: string | undefined;
    _Web?: string | undefined;
    _Logo?: string | undefined;
    _Description?: string | undefined;
}

export class VatGroup implements IVatGroup {
    _ID?: string | undefined;
    _GroupName?: string | undefined;
    _LanguageID?: string | undefined;
    _ValueName?: string | undefined;
    _configurableVatProviderSettings?: string | undefined;
    _VatGroupCountryRelation?: VatGroupCountryRelation | undefined;
    _IsReadOnly?: boolean | undefined;

    constructor(data?: IVatGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._GroupName = _data["_GroupName"];
            this._LanguageID = _data["_LanguageID"];
            this._ValueName = _data["_ValueName"];
            this._configurableVatProviderSettings = _data["_configurableVatProviderSettings"];
            this._VatGroupCountryRelation = _data["_VatGroupCountryRelation"] ? VatGroupCountryRelation.fromJS(_data["_VatGroupCountryRelation"]) : <any>undefined;
            this._IsReadOnly = _data["_IsReadOnly"];
        }
    }

    static fromJS(data: any): VatGroup {
        data = typeof data === 'object' ? data : {};
        let result = new VatGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_GroupName"] = this._GroupName;
        data["_LanguageID"] = this._LanguageID;
        data["_ValueName"] = this._ValueName;
        data["_configurableVatProviderSettings"] = this._configurableVatProviderSettings;
        data["_VatGroupCountryRelation"] = this._VatGroupCountryRelation ? this._VatGroupCountryRelation.toJSON() : <any>undefined;
        data["_IsReadOnly"] = this._IsReadOnly;
        return data; 
    }
}

export interface IVatGroup {
    _ID?: string | undefined;
    _GroupName?: string | undefined;
    _LanguageID?: string | undefined;
    _ValueName?: string | undefined;
    _configurableVatProviderSettings?: string | undefined;
    _VatGroupCountryRelation?: VatGroupCountryRelation | undefined;
    _IsReadOnly?: boolean | undefined;
}

export class ProductVatGroup implements IProductVatGroup {
    _ProductID?: string | undefined;
    _ProductVariantID?: string | undefined;
    _VatGroupID?: string | undefined;
    _CountryID?: string | undefined;
    _id?: number | undefined;
    _tableName?: string | undefined;
    _keyField?: string | undefined;
    _db?: string | undefined;
    connection?: IDbConnection | undefined;
    transaction?: IDbTransaction | undefined;
    recordCommitEvent?: any | undefined;
    recordDeleteEvent?: any | undefined;

    constructor(data?: IProductVatGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ProductID = _data["_ProductID"];
            this._ProductVariantID = _data["_ProductVariantID"];
            this._VatGroupID = _data["_VatGroupID"];
            this._CountryID = _data["_CountryID"];
            this._id = _data["_id"];
            this._tableName = _data["_tableName"];
            this._keyField = _data["_keyField"];
            this._db = _data["_db"];
            this.connection = _data["Connection"] ? IDbConnection.fromJS(_data["Connection"]) : <any>undefined;
            this.transaction = _data["Transaction"] ? IDbTransaction.fromJS(_data["Transaction"]) : <any>undefined;
            this.recordCommitEvent = _data["RecordCommitEvent"];
            this.recordDeleteEvent = _data["RecordDeleteEvent"];
        }
    }

    static fromJS(data: any): ProductVatGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ProductVatGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ProductID"] = this._ProductID;
        data["_ProductVariantID"] = this._ProductVariantID;
        data["_VatGroupID"] = this._VatGroupID;
        data["_CountryID"] = this._CountryID;
        data["_id"] = this._id;
        data["_tableName"] = this._tableName;
        data["_keyField"] = this._keyField;
        data["_db"] = this._db;
        data["Connection"] = this.connection ? this.connection.toJSON() : <any>undefined;
        data["Transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        data["RecordCommitEvent"] = this.recordCommitEvent;
        data["RecordDeleteEvent"] = this.recordDeleteEvent;
        return data; 
    }
}

export interface IProductVatGroup {
    _ProductID?: string | undefined;
    _ProductVariantID?: string | undefined;
    _VatGroupID?: string | undefined;
    _CountryID?: string | undefined;
    _id?: number | undefined;
    _tableName?: string | undefined;
    _keyField?: string | undefined;
    _db?: string | undefined;
    connection?: IDbConnection | undefined;
    transaction?: IDbTransaction | undefined;
    recordCommitEvent?: any | undefined;
    recordDeleteEvent?: any | undefined;
}

export class ProductFieldValue implements IProductFieldValue {
    _ProductField?: ProductField | undefined;
    _Value?: any | undefined;
    _hasValue?: boolean | undefined;
    _languageID?: string | undefined;

    constructor(data?: IProductFieldValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ProductField = _data["_ProductField"] ? ProductField.fromJS(_data["_ProductField"]) : <any>undefined;
            this._Value = _data["_Value"];
            this._hasValue = _data["_hasValue"];
            this._languageID = _data["_languageID"];
        }
    }

    static fromJS(data: any): ProductFieldValue {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFieldValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ProductField"] = this._ProductField ? this._ProductField.toJSON() : <any>undefined;
        data["_Value"] = this._Value;
        data["_hasValue"] = this._hasValue;
        data["_languageID"] = this._languageID;
        return data; 
    }
}

export interface IProductFieldValue {
    _ProductField?: ProductField | undefined;
    _Value?: any | undefined;
    _hasValue?: boolean | undefined;
    _languageID?: string | undefined;
}

export class Discount implements IDiscount {
    _Value?: number[] | undefined;
    _Amount?: number[] | undefined;
    _Currency?: Currency | undefined;
    _Product?: Product | undefined;
    _Type?: Discount_Type | undefined;
    _Name?: string | undefined;
    _Description?: string | undefined;
    _CachedPrice?: PriceInfo | undefined;
    _CachedDiscountAmount?: PriceInfo | undefined;
    _ID?: string | undefined;

    constructor(data?: IDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["_Value"])) {
                this._Value = [] as any;
                for (let item of _data["_Value"])
                    this._Value!.push(item);
            }
            if (Array.isArray(_data["_Amount"])) {
                this._Amount = [] as any;
                for (let item of _data["_Amount"])
                    this._Amount!.push(item);
            }
            this._Currency = _data["_Currency"] ? Currency.fromJS(_data["_Currency"]) : <any>undefined;
            this._Product = _data["_Product"] ? Product.fromJS(_data["_Product"]) : <any>undefined;
            this._Type = _data["_Type"];
            this._Name = _data["_Name"];
            this._Description = _data["_Description"];
            this._CachedPrice = _data["_CachedPrice"] ? PriceInfo.fromJS(_data["_CachedPrice"]) : <any>undefined;
            this._CachedDiscountAmount = _data["_CachedDiscountAmount"] ? PriceInfo.fromJS(_data["_CachedDiscountAmount"]) : <any>undefined;
            this._ID = _data["_ID"];
        }
    }

    static fromJS(data: any): Discount {
        data = typeof data === 'object' ? data : {};
        let result = new Discount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this._Value)) {
            data["_Value"] = [];
            for (let item of this._Value)
                data["_Value"].push(item);
        }
        if (Array.isArray(this._Amount)) {
            data["_Amount"] = [];
            for (let item of this._Amount)
                data["_Amount"].push(item);
        }
        data["_Currency"] = this._Currency ? this._Currency.toJSON() : <any>undefined;
        data["_Product"] = this._Product ? this._Product.toJSON() : <any>undefined;
        data["_Type"] = this._Type;
        data["_Name"] = this._Name;
        data["_Description"] = this._Description;
        data["_CachedPrice"] = this._CachedPrice ? this._CachedPrice.toJSON() : <any>undefined;
        data["_CachedDiscountAmount"] = this._CachedDiscountAmount ? this._CachedDiscountAmount.toJSON() : <any>undefined;
        data["_ID"] = this._ID;
        return data; 
    }
}

export interface IDiscount {
    _Value?: number[] | undefined;
    _Amount?: number[] | undefined;
    _Currency?: Currency | undefined;
    _Product?: Product | undefined;
    _Type?: Discount_Type | undefined;
    _Name?: string | undefined;
    _Description?: string | undefined;
    _CachedPrice?: PriceInfo | undefined;
    _CachedDiscountAmount?: PriceInfo | undefined;
    _ID?: string | undefined;
}

export class PriceInfo implements IPriceInfo {
    _VAT?: number | undefined;
    _VATPercent?: number | undefined;
    _PriceWithVAT?: number | undefined;
    _PriceWithoutVAT?: number | undefined;
    _Currency?: Currency | undefined;
    showPricesWithVAT?: boolean | undefined;
    _PricePIP?: number | undefined;
    _PriceReference?: string | undefined;
    _IsInformative?: boolean | undefined;
    _ReverseChargeForVat?: boolean | undefined;

    constructor(data?: IPriceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._VAT = _data["_VAT"];
            this._VATPercent = _data["_VATPercent"];
            this._PriceWithVAT = _data["_PriceWithVAT"];
            this._PriceWithoutVAT = _data["_PriceWithoutVAT"];
            this._Currency = _data["_Currency"] ? Currency.fromJS(_data["_Currency"]) : <any>undefined;
            this.showPricesWithVAT = _data["ShowPricesWithVAT"];
            this._PricePIP = _data["_PricePIP"];
            this._PriceReference = _data["_PriceReference"];
            this._IsInformative = _data["_IsInformative"];
            this._ReverseChargeForVat = _data["_ReverseChargeForVat"];
        }
    }

    static fromJS(data: any): PriceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PriceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_VAT"] = this._VAT;
        data["_VATPercent"] = this._VATPercent;
        data["_PriceWithVAT"] = this._PriceWithVAT;
        data["_PriceWithoutVAT"] = this._PriceWithoutVAT;
        data["_Currency"] = this._Currency ? this._Currency.toJSON() : <any>undefined;
        data["ShowPricesWithVAT"] = this.showPricesWithVAT;
        data["_PricePIP"] = this._PricePIP;
        data["_PriceReference"] = this._PriceReference;
        data["_IsInformative"] = this._IsInformative;
        data["_ReverseChargeForVat"] = this._ReverseChargeForVat;
        return data; 
    }
}

export interface IPriceInfo {
    _VAT?: number | undefined;
    _VATPercent?: number | undefined;
    _PriceWithVAT?: number | undefined;
    _PriceWithoutVAT?: number | undefined;
    _Currency?: Currency | undefined;
    showPricesWithVAT?: boolean | undefined;
    _PricePIP?: number | undefined;
    _PriceReference?: string | undefined;
    _IsInformative?: boolean | undefined;
    _ReverseChargeForVat?: boolean | undefined;
}

export class OrderLineField implements IOrderLineField {
    _SystemName?: string | undefined;
    _Name?: string | undefined;
    _Length?: number | undefined;

    constructor(data?: IOrderLineField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._SystemName = _data["_SystemName"];
            this._Name = _data["_Name"];
            this._Length = _data["_Length"];
        }
    }

    static fromJS(data: any): OrderLineField {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_SystemName"] = this._SystemName;
        data["_Name"] = this._Name;
        data["_Length"] = this._Length;
        return data; 
    }
}

export interface IOrderLineField {
    _SystemName?: string | undefined;
    _Name?: string | undefined;
    _Length?: number | undefined;
}

export class MetaData implements IMetaData {
    _title?: string | undefined;
    _keywords?: string | undefined;
    _description?: string | undefined;
    _url?: string | undefined;
    _canonical?: string | undefined;

    constructor(data?: IMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._title = _data["_title"];
            this._keywords = _data["_keywords"];
            this._description = _data["_description"];
            this._url = _data["_url"];
            this._canonical = _data["_canonical"];
        }
    }

    static fromJS(data: any): MetaData {
        data = typeof data === 'object' ? data : {};
        let result = new MetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_title"] = this._title;
        data["_keywords"] = this._keywords;
        data["_description"] = this._description;
        data["_url"] = this._url;
        data["_canonical"] = this._canonical;
        return data; 
    }
}

export interface IMetaData {
    _title?: string | undefined;
    _keywords?: string | undefined;
    _description?: string | undefined;
    _url?: string | undefined;
    _canonical?: string | undefined;
}

export class Tax implements ITax {
    _Name?: string | undefined;
    _CalculateVat?: boolean | undefined;
    _Amount?: PriceRaw | undefined;
    _Product?: Product | undefined;

    constructor(data?: ITax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._Name = _data["_Name"];
            this._CalculateVat = _data["_CalculateVat"];
            this._Amount = _data["_Amount"] ? PriceRaw.fromJS(_data["_Amount"]) : <any>undefined;
            this._Product = _data["_Product"] ? Product.fromJS(_data["_Product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Tax {
        data = typeof data === 'object' ? data : {};
        let result = new Tax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_Name"] = this._Name;
        data["_CalculateVat"] = this._CalculateVat;
        data["_Amount"] = this._Amount ? this._Amount.toJSON() : <any>undefined;
        data["_Product"] = this._Product ? this._Product.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITax {
    _Name?: string | undefined;
    _CalculateVat?: boolean | undefined;
    _Amount?: PriceRaw | undefined;
    _Product?: Product | undefined;
}

export class ProductIndexingOptions implements IProductIndexingOptions {
    _NotifyOnChanges?: boolean | undefined;

    constructor(data?: IProductIndexingOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._NotifyOnChanges = _data["_NotifyOnChanges"];
        }
    }

    static fromJS(data: any): ProductIndexingOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ProductIndexingOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_NotifyOnChanges"] = this._NotifyOnChanges;
        return data; 
    }
}

export interface IProductIndexingOptions {
    _NotifyOnChanges?: boolean | undefined;
}

export class VariantGroupProductRelation implements IVariantGroupProductRelation {
    _ID?: string | undefined;
    _ProductID?: string | undefined;
    _VariantGroupID?: string | undefined;
    _Sorting?: number | undefined;
    _PriceDif?: boolean | undefined;
    _VariantGroups?: VariantGroup[] | undefined;
    _LanguageID?: string | undefined;

    constructor(data?: IVariantGroupProductRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._ProductID = _data["_ProductID"];
            this._VariantGroupID = _data["_VariantGroupID"];
            this._Sorting = _data["_Sorting"];
            this._PriceDif = _data["_PriceDif"];
            if (Array.isArray(_data["_VariantGroups"])) {
                this._VariantGroups = [] as any;
                for (let item of _data["_VariantGroups"])
                    this._VariantGroups!.push(VariantGroup.fromJS(item));
            }
            this._LanguageID = _data["_LanguageID"];
        }
    }

    static fromJS(data: any): VariantGroupProductRelation {
        data = typeof data === 'object' ? data : {};
        let result = new VariantGroupProductRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_ProductID"] = this._ProductID;
        data["_VariantGroupID"] = this._VariantGroupID;
        data["_Sorting"] = this._Sorting;
        data["_PriceDif"] = this._PriceDif;
        if (Array.isArray(this._VariantGroups)) {
            data["_VariantGroups"] = [];
            for (let item of this._VariantGroups)
                data["_VariantGroups"].push(item.toJSON());
        }
        data["_LanguageID"] = this._LanguageID;
        return data; 
    }
}

export interface IVariantGroupProductRelation {
    _ID?: string | undefined;
    _ProductID?: string | undefined;
    _VariantGroupID?: string | undefined;
    _Sorting?: number | undefined;
    _PriceDif?: boolean | undefined;
    _VariantGroups?: VariantGroup[] | undefined;
    _LanguageID?: string | undefined;
}

export class VariantGroupProperty implements IVariantGroupProperty {
    iD?: string | undefined;
    groupID?: string | undefined;
    name?: string | undefined;
    systemName?: string | undefined;

    constructor(data?: IVariantGroupProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iD = _data["ID"];
            this.groupID = _data["GroupID"];
            this.name = _data["Name"];
            this.systemName = _data["SystemName"];
        }
    }

    static fromJS(data: any): VariantGroupProperty {
        data = typeof data === 'object' ? data : {};
        let result = new VariantGroupProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ID"] = this.iD;
        data["GroupID"] = this.groupID;
        data["Name"] = this.name;
        data["SystemName"] = this.systemName;
        return data; 
    }
}

export interface IVariantGroupProperty {
    iD?: string | undefined;
    groupID?: string | undefined;
    name?: string | undefined;
    systemName?: string | undefined;
}

export class MetaData2 implements IMetaData2 {
    _title?: string | undefined;
    _keywords?: string | undefined;
    _description?: string | undefined;
    _url?: string | undefined;
    _canonical?: string | undefined;
    _PrimaryPage?: string | undefined;

    constructor(data?: IMetaData2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._title = _data["_title"];
            this._keywords = _data["_keywords"];
            this._description = _data["_description"];
            this._url = _data["_url"];
            this._canonical = _data["_canonical"];
            this._PrimaryPage = _data["_PrimaryPage"];
        }
    }

    static fromJS(data: any): MetaData2 {
        data = typeof data === 'object' ? data : {};
        let result = new MetaData2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_title"] = this._title;
        data["_keywords"] = this._keywords;
        data["_description"] = this._description;
        data["_url"] = this._url;
        data["_canonical"] = this._canonical;
        data["_PrimaryPage"] = this._PrimaryPage;
        return data; 
    }
}

export interface IMetaData2 {
    _title?: string | undefined;
    _keywords?: string | undefined;
    _description?: string | undefined;
    _url?: string | undefined;
    _canonical?: string | undefined;
    _PrimaryPage?: string | undefined;
}

export class ProductGroupFieldValue implements IProductGroupFieldValue {
    _ProductGroupField?: ProductGroupField | undefined;
    _Value?: any | undefined;
    _hasValue?: boolean | undefined;

    constructor(data?: IProductGroupFieldValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ProductGroupField = _data["_ProductGroupField"] ? ProductGroupField.fromJS(_data["_ProductGroupField"]) : <any>undefined;
            this._Value = _data["_Value"];
            this._hasValue = _data["_hasValue"];
        }
    }

    static fromJS(data: any): ProductGroupFieldValue {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroupFieldValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ProductGroupField"] = this._ProductGroupField ? this._ProductGroupField.toJSON() : <any>undefined;
        data["_Value"] = this._Value;
        data["_hasValue"] = this._hasValue;
        return data; 
    }
}

export interface IProductGroupFieldValue {
    _ProductGroupField?: ProductGroupField | undefined;
    _Value?: any | undefined;
    _hasValue?: boolean | undefined;
}

export class UserPermission implements IUserPermission {
    _userPermissionType?: string | undefined;
    _userPermissionTypeID?: string | undefined;
    _userPermissionTypeGUID?: string | undefined;
    _manipulatedRights?: DefinedRight | undefined;
    _currentRights?: DefinedRight | undefined;
    _dataPresence?: UserPermission_dataPresence | undefined;
    _grantedRightsManipulated?: boolean | undefined;
    _userID?: number | undefined;
    _ForceReload?: boolean | undefined;

    constructor(data?: IUserPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._userPermissionType = _data["_userPermissionType"];
            this._userPermissionTypeID = _data["_userPermissionTypeID"];
            this._userPermissionTypeGUID = _data["_userPermissionTypeGUID"];
            this._manipulatedRights = _data["_manipulatedRights"] ? DefinedRight.fromJS(_data["_manipulatedRights"]) : <any>undefined;
            this._currentRights = _data["_currentRights"] ? DefinedRight.fromJS(_data["_currentRights"]) : <any>undefined;
            this._dataPresence = _data["_dataPresence"];
            this._grantedRightsManipulated = _data["_grantedRightsManipulated"];
            this._userID = _data["_userID"];
            this._ForceReload = _data["_ForceReload"];
        }
    }

    static fromJS(data: any): UserPermission {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_userPermissionType"] = this._userPermissionType;
        data["_userPermissionTypeID"] = this._userPermissionTypeID;
        data["_userPermissionTypeGUID"] = this._userPermissionTypeGUID;
        data["_manipulatedRights"] = this._manipulatedRights ? this._manipulatedRights.toJSON() : <any>undefined;
        data["_currentRights"] = this._currentRights ? this._currentRights.toJSON() : <any>undefined;
        data["_dataPresence"] = this._dataPresence;
        data["_grantedRightsManipulated"] = this._grantedRightsManipulated;
        data["_userID"] = this._userID;
        data["_ForceReload"] = this._ForceReload;
        return data; 
    }
}

export interface IUserPermission {
    _userPermissionType?: string | undefined;
    _userPermissionTypeID?: string | undefined;
    _userPermissionTypeGUID?: string | undefined;
    _manipulatedRights?: DefinedRight | undefined;
    _currentRights?: DefinedRight | undefined;
    _dataPresence?: UserPermission_dataPresence | undefined;
    _grantedRightsManipulated?: boolean | undefined;
    _userID?: number | undefined;
    _ForceReload?: boolean | undefined;
}

export class Category implements ICategory {
    _id?: string | undefined;
    _language?: Language | undefined;
    _name?: string | undefined;
    _fields?: Field[] | undefined;
    _isNew?: boolean | undefined;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._id = _data["_id"];
            this._language = _data["_language"] ? Language.fromJS(_data["_language"]) : <any>undefined;
            this._name = _data["_name"];
            if (Array.isArray(_data["_fields"])) {
                this._fields = [] as any;
                for (let item of _data["_fields"])
                    this._fields!.push(Field.fromJS(item));
            }
            this._isNew = _data["_isNew"];
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_id"] = this._id;
        data["_language"] = this._language ? this._language.toJSON() : <any>undefined;
        data["_name"] = this._name;
        if (Array.isArray(this._fields)) {
            data["_fields"] = [];
            for (let item of this._fields)
                data["_fields"].push(item.toJSON());
        }
        data["_isNew"] = this._isNew;
        return data; 
    }
}

export interface ICategory {
    _id?: string | undefined;
    _language?: Language | undefined;
    _name?: string | undefined;
    _fields?: Field[] | undefined;
    _isNew?: boolean | undefined;
}

export class GroupFilterExecutionSettings implements IGroupFilterExecutionSettings {
    _PagedQueries?: GroupFilterExecutionSettings_PagedQueries | undefined;

    constructor(data?: IGroupFilterExecutionSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._PagedQueries = _data["_PagedQueries"];
        }
    }

    static fromJS(data: any): GroupFilterExecutionSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GroupFilterExecutionSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_PagedQueries"] = this._PagedQueries;
        return data; 
    }
}

export interface IGroupFilterExecutionSettings {
    _PagedQueries?: GroupFilterExecutionSettings_PagedQueries | undefined;
}

export class PropertyGroup implements IPropertyGroup {
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _TypeID?: string | undefined;
    _Name?: string | undefined;
    _PropertyFields?: PropertyField[] | undefined;

    constructor(data?: IPropertyGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._LanguageID = _data["_LanguageID"];
            this._TypeID = _data["_TypeID"];
            this._Name = _data["_Name"];
            if (Array.isArray(_data["_PropertyFields"])) {
                this._PropertyFields = [] as any;
                for (let item of _data["_PropertyFields"])
                    this._PropertyFields!.push(PropertyField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyGroup {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_LanguageID"] = this._LanguageID;
        data["_TypeID"] = this._TypeID;
        data["_Name"] = this._Name;
        if (Array.isArray(this._PropertyFields)) {
            data["_PropertyFields"] = [];
            for (let item of this._PropertyFields)
                data["_PropertyFields"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPropertyGroup {
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _TypeID?: string | undefined;
    _Name?: string | undefined;
    _PropertyFields?: PropertyField[] | undefined;
}

export class Currency implements ICurrency {
    _Code?: string | undefined;
    _LanguageID?: string | undefined;
    _Symbol?: string | undefined;
    _Name?: string | undefined;
    _Rate?: number | undefined;
    _IsDefault?: boolean | undefined;
    _CultureInfo?: string | undefined;
    _PayGatewayCode?: number | undefined;
    _RoundingID?: string | undefined;
    _IsReadOnly?: boolean | undefined;
    _Rounding?: Rounding | undefined;
    _SymbolPlace?: number | undefined;
    _positivePattern?: number | undefined;
    _negativePattern?: number | undefined;
    _cachedNumberFormatInfos?: { [key: string]: NumberFormatInfo; } | undefined;

    constructor(data?: ICurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._Code = _data["_Code"];
            this._LanguageID = _data["_LanguageID"];
            this._Symbol = _data["_Symbol"];
            this._Name = _data["_Name"];
            this._Rate = _data["_Rate"];
            this._IsDefault = _data["_IsDefault"];
            this._CultureInfo = _data["_CultureInfo"];
            this._PayGatewayCode = _data["_PayGatewayCode"];
            this._RoundingID = _data["_RoundingID"];
            this._IsReadOnly = _data["_IsReadOnly"];
            this._Rounding = _data["_Rounding"] ? Rounding.fromJS(_data["_Rounding"]) : <any>undefined;
            this._SymbolPlace = _data["_SymbolPlace"];
            this._positivePattern = _data["_positivePattern"];
            this._negativePattern = _data["_negativePattern"];
            if (_data["_cachedNumberFormatInfos"]) {
                this._cachedNumberFormatInfos = {} as any;
                for (let key in _data["_cachedNumberFormatInfos"]) {
                    if (_data["_cachedNumberFormatInfos"].hasOwnProperty(key))
                        this._cachedNumberFormatInfos![key] = _data["_cachedNumberFormatInfos"][key] ? NumberFormatInfo.fromJS(_data["_cachedNumberFormatInfos"][key]) : new NumberFormatInfo();
                }
            }
        }
    }

    static fromJS(data: any): Currency {
        data = typeof data === 'object' ? data : {};
        let result = new Currency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_Code"] = this._Code;
        data["_LanguageID"] = this._LanguageID;
        data["_Symbol"] = this._Symbol;
        data["_Name"] = this._Name;
        data["_Rate"] = this._Rate;
        data["_IsDefault"] = this._IsDefault;
        data["_CultureInfo"] = this._CultureInfo;
        data["_PayGatewayCode"] = this._PayGatewayCode;
        data["_RoundingID"] = this._RoundingID;
        data["_IsReadOnly"] = this._IsReadOnly;
        data["_Rounding"] = this._Rounding ? this._Rounding.toJSON() : <any>undefined;
        data["_SymbolPlace"] = this._SymbolPlace;
        data["_positivePattern"] = this._positivePattern;
        data["_negativePattern"] = this._negativePattern;
        if (this._cachedNumberFormatInfos) {
            data["_cachedNumberFormatInfos"] = {};
            for (let key in this._cachedNumberFormatInfos) {
                if (this._cachedNumberFormatInfos.hasOwnProperty(key))
                    data["_cachedNumberFormatInfos"][key] = this._cachedNumberFormatInfos[key] ? this._cachedNumberFormatInfos[key].toJSON() : <any>undefined;
            }
        }
        return data; 
    }
}

export interface ICurrency {
    _Code?: string | undefined;
    _LanguageID?: string | undefined;
    _Symbol?: string | undefined;
    _Name?: string | undefined;
    _Rate?: number | undefined;
    _IsDefault?: boolean | undefined;
    _CultureInfo?: string | undefined;
    _PayGatewayCode?: number | undefined;
    _RoundingID?: string | undefined;
    _IsReadOnly?: boolean | undefined;
    _Rounding?: Rounding | undefined;
    _SymbolPlace?: number | undefined;
    _positivePattern?: number | undefined;
    _negativePattern?: number | undefined;
    _cachedNumberFormatInfos?: { [key: string]: NumberFormatInfo; } | undefined;
}

export class User implements IUser {
    _userName?: string | undefined;
    _password?: string | undefined;
    _passwordRecoveryToken?: string | undefined;
    _passwordRecoveryTokenExpirationTime?: Date | undefined;
    _title?: string | undefined;
    _firstName?: string | undefined;
    _lastName?: string | undefined;
    _middleName?: string | undefined;
    _houseNumber?: string | undefined;
    _name?: string | undefined;
    _email?: string | undefined;
    _address?: string | undefined;
    _address2?: string | undefined;
    _zip?: string | undefined;
    _city?: string | undefined;
    _state?: string | undefined;
    _country?: string | undefined;
    _phone?: string | undefined;
    _phonePrivate?: string | undefined;
    _phoneMobile?: string | undefined;
    _fax?: string | undefined;
    _customerNumber?: string | undefined;
    _currency?: string | undefined;
    _image?: string | undefined;
    _company?: string | undefined;
    _department?: string | undefined;
    _jobTitle?: string | undefined;
    _phoneBusiness?: string | undefined;
    _groups?: string | undefined;
    _groupsObject?: Group2[] | undefined;
    _usersICanSetAsSecondary?: User[] | undefined;
    _usersThatCanSetMeAsSecondary?: User[] | undefined;
    _validFrom?: Date | undefined;
    _validTo?: Date | undefined;
    _active?: boolean | undefined;
    _AllowBackend?: boolean | undefined;
    _FrontendStartPage?: string | undefined;
    _type?: User_type | undefined;
    _typeID?: number | undefined;
    _modules?: string | undefined;
    _modulesObject?: { [key: string]: ModulePermission; } | undefined;
    _configurationID?: number | undefined;
    _configurationObject?: EditorConfiguration | undefined;
    _ApprovalKey?: string | undefined;
    _customFieldValues?: CustomFieldValue[] | undefined;
    _systemFieldValues?: SystemFieldValue[] | undefined;
    _ExternalID?: string | undefined;
    _userSortCollection?: UserSort[] | undefined;
    _shopID?: string | undefined;
    _emailAllowed?: boolean | undefined;
    _disableLivePrices?: boolean | undefined;
    _geoLocationLat?: number | undefined;
    _geoLocationLng?: number | undefined;
    _geoLocationIsCustom?: boolean | undefined;
    _geoLocationHash?: string | undefined;
    _geoLocationImage?: string | undefined;
    _vatRegNumber?: string | undefined;
    _productLists?: CustomerProductList[] | undefined;
    _administratorInGroups?: string | undefined;
    _administratorInGroupsCollection?: Group2[] | undefined;
    _exported?: Date | undefined;
    _itemType?: string | undefined;
    _itemId?: string | undefined;
    _itemLock?: any | undefined;
    _frequentBoughtProductsCache?: string[] | undefined;
    _mostBoughtProductsCache?: string[] | undefined;
    _favoriteProductsByUserIdCache?: string[] | undefined;
    _favoriteProductsByCustomernameCache?: string[] | undefined;
    _auditFields?: AuditUserInfo | undefined;
    _passwordDate?: Date | undefined;
    _pointBalance?: number | undefined;
    _StockLocationID?: number | undefined;
    _addedGroups?: number[] | undefined;
    _removedGroups?: number[] | undefined;
    _id?: number | undefined;
    _tableName?: string | undefined;
    _keyField?: string | undefined;
    _db?: string | undefined;
    connection?: IDbConnection | undefined;
    transaction?: IDbTransaction | undefined;
    recordCommitEvent?: any | undefined;
    recordDeleteEvent?: any | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._userName = _data["_userName"];
            this._password = _data["_password"];
            this._passwordRecoveryToken = _data["_passwordRecoveryToken"];
            this._passwordRecoveryTokenExpirationTime = _data["_passwordRecoveryTokenExpirationTime"] ? new Date(_data["_passwordRecoveryTokenExpirationTime"].toString()) : <any>undefined;
            this._title = _data["_title"];
            this._firstName = _data["_firstName"];
            this._lastName = _data["_lastName"];
            this._middleName = _data["_middleName"];
            this._houseNumber = _data["_houseNumber"];
            this._name = _data["_name"];
            this._email = _data["_email"];
            this._address = _data["_address"];
            this._address2 = _data["_address2"];
            this._zip = _data["_zip"];
            this._city = _data["_city"];
            this._state = _data["_state"];
            this._country = _data["_country"];
            this._phone = _data["_phone"];
            this._phonePrivate = _data["_phonePrivate"];
            this._phoneMobile = _data["_phoneMobile"];
            this._fax = _data["_fax"];
            this._customerNumber = _data["_customerNumber"];
            this._currency = _data["_currency"];
            this._image = _data["_image"];
            this._company = _data["_company"];
            this._department = _data["_department"];
            this._jobTitle = _data["_jobTitle"];
            this._phoneBusiness = _data["_phoneBusiness"];
            this._groups = _data["_groups"];
            if (Array.isArray(_data["_groupsObject"])) {
                this._groupsObject = [] as any;
                for (let item of _data["_groupsObject"])
                    this._groupsObject!.push(Group2.fromJS(item));
            }
            if (Array.isArray(_data["_usersICanSetAsSecondary"])) {
                this._usersICanSetAsSecondary = [] as any;
                for (let item of _data["_usersICanSetAsSecondary"])
                    this._usersICanSetAsSecondary!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["_usersThatCanSetMeAsSecondary"])) {
                this._usersThatCanSetMeAsSecondary = [] as any;
                for (let item of _data["_usersThatCanSetMeAsSecondary"])
                    this._usersThatCanSetMeAsSecondary!.push(User.fromJS(item));
            }
            this._validFrom = _data["_validFrom"] ? new Date(_data["_validFrom"].toString()) : <any>undefined;
            this._validTo = _data["_validTo"] ? new Date(_data["_validTo"].toString()) : <any>undefined;
            this._active = _data["_active"];
            this._AllowBackend = _data["_AllowBackend"];
            this._FrontendStartPage = _data["_FrontendStartPage"];
            this._type = _data["_type"];
            this._typeID = _data["_typeID"];
            this._modules = _data["_modules"];
            if (_data["_modulesObject"]) {
                this._modulesObject = {} as any;
                for (let key in _data["_modulesObject"]) {
                    if (_data["_modulesObject"].hasOwnProperty(key))
                        this._modulesObject![key] = _data["_modulesObject"][key] ? ModulePermission.fromJS(_data["_modulesObject"][key]) : new ModulePermission();
                }
            }
            this._configurationID = _data["_configurationID"];
            this._configurationObject = _data["_configurationObject"] ? EditorConfiguration.fromJS(_data["_configurationObject"]) : <any>undefined;
            this._ApprovalKey = _data["_ApprovalKey"];
            if (Array.isArray(_data["_customFieldValues"])) {
                this._customFieldValues = [] as any;
                for (let item of _data["_customFieldValues"])
                    this._customFieldValues!.push(CustomFieldValue.fromJS(item));
            }
            if (Array.isArray(_data["_systemFieldValues"])) {
                this._systemFieldValues = [] as any;
                for (let item of _data["_systemFieldValues"])
                    this._systemFieldValues!.push(SystemFieldValue.fromJS(item));
            }
            this._ExternalID = _data["_ExternalID"];
            if (Array.isArray(_data["_userSortCollection"])) {
                this._userSortCollection = [] as any;
                for (let item of _data["_userSortCollection"])
                    this._userSortCollection!.push(UserSort.fromJS(item));
            }
            this._shopID = _data["_shopID"];
            this._emailAllowed = _data["_emailAllowed"];
            this._disableLivePrices = _data["_disableLivePrices"];
            this._geoLocationLat = _data["_geoLocationLat"];
            this._geoLocationLng = _data["_geoLocationLng"];
            this._geoLocationIsCustom = _data["_geoLocationIsCustom"];
            this._geoLocationHash = _data["_geoLocationHash"];
            this._geoLocationImage = _data["_geoLocationImage"];
            this._vatRegNumber = _data["_vatRegNumber"];
            if (Array.isArray(_data["_productLists"])) {
                this._productLists = [] as any;
                for (let item of _data["_productLists"])
                    this._productLists!.push(CustomerProductList.fromJS(item));
            }
            this._administratorInGroups = _data["_administratorInGroups"];
            if (Array.isArray(_data["_administratorInGroupsCollection"])) {
                this._administratorInGroupsCollection = [] as any;
                for (let item of _data["_administratorInGroupsCollection"])
                    this._administratorInGroupsCollection!.push(Group2.fromJS(item));
            }
            this._exported = _data["_exported"] ? new Date(_data["_exported"].toString()) : <any>undefined;
            this._itemType = _data["_itemType"];
            this._itemId = _data["_itemId"];
            this._itemLock = _data["_itemLock"];
            if (Array.isArray(_data["_frequentBoughtProductsCache"])) {
                this._frequentBoughtProductsCache = [] as any;
                for (let item of _data["_frequentBoughtProductsCache"])
                    this._frequentBoughtProductsCache!.push(item);
            }
            if (Array.isArray(_data["_mostBoughtProductsCache"])) {
                this._mostBoughtProductsCache = [] as any;
                for (let item of _data["_mostBoughtProductsCache"])
                    this._mostBoughtProductsCache!.push(item);
            }
            if (Array.isArray(_data["_favoriteProductsByUserIdCache"])) {
                this._favoriteProductsByUserIdCache = [] as any;
                for (let item of _data["_favoriteProductsByUserIdCache"])
                    this._favoriteProductsByUserIdCache!.push(item);
            }
            if (Array.isArray(_data["_favoriteProductsByCustomernameCache"])) {
                this._favoriteProductsByCustomernameCache = [] as any;
                for (let item of _data["_favoriteProductsByCustomernameCache"])
                    this._favoriteProductsByCustomernameCache!.push(item);
            }
            this._auditFields = _data["_auditFields"] ? AuditUserInfo.fromJS(_data["_auditFields"]) : <any>undefined;
            this._passwordDate = _data["_passwordDate"] ? new Date(_data["_passwordDate"].toString()) : <any>undefined;
            this._pointBalance = _data["_pointBalance"];
            this._StockLocationID = _data["_StockLocationID"];
            if (Array.isArray(_data["_addedGroups"])) {
                this._addedGroups = [] as any;
                for (let item of _data["_addedGroups"])
                    this._addedGroups!.push(item);
            }
            if (Array.isArray(_data["_removedGroups"])) {
                this._removedGroups = [] as any;
                for (let item of _data["_removedGroups"])
                    this._removedGroups!.push(item);
            }
            this._id = _data["_id"];
            this._tableName = _data["_tableName"];
            this._keyField = _data["_keyField"];
            this._db = _data["_db"];
            this.connection = _data["Connection"] ? IDbConnection.fromJS(_data["Connection"]) : <any>undefined;
            this.transaction = _data["Transaction"] ? IDbTransaction.fromJS(_data["Transaction"]) : <any>undefined;
            this.recordCommitEvent = _data["RecordCommitEvent"];
            this.recordDeleteEvent = _data["RecordDeleteEvent"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_userName"] = this._userName;
        data["_password"] = this._password;
        data["_passwordRecoveryToken"] = this._passwordRecoveryToken;
        data["_passwordRecoveryTokenExpirationTime"] = this._passwordRecoveryTokenExpirationTime ? this._passwordRecoveryTokenExpirationTime.toISOString() : <any>undefined;
        data["_title"] = this._title;
        data["_firstName"] = this._firstName;
        data["_lastName"] = this._lastName;
        data["_middleName"] = this._middleName;
        data["_houseNumber"] = this._houseNumber;
        data["_name"] = this._name;
        data["_email"] = this._email;
        data["_address"] = this._address;
        data["_address2"] = this._address2;
        data["_zip"] = this._zip;
        data["_city"] = this._city;
        data["_state"] = this._state;
        data["_country"] = this._country;
        data["_phone"] = this._phone;
        data["_phonePrivate"] = this._phonePrivate;
        data["_phoneMobile"] = this._phoneMobile;
        data["_fax"] = this._fax;
        data["_customerNumber"] = this._customerNumber;
        data["_currency"] = this._currency;
        data["_image"] = this._image;
        data["_company"] = this._company;
        data["_department"] = this._department;
        data["_jobTitle"] = this._jobTitle;
        data["_phoneBusiness"] = this._phoneBusiness;
        data["_groups"] = this._groups;
        if (Array.isArray(this._groupsObject)) {
            data["_groupsObject"] = [];
            for (let item of this._groupsObject)
                data["_groupsObject"].push(item.toJSON());
        }
        if (Array.isArray(this._usersICanSetAsSecondary)) {
            data["_usersICanSetAsSecondary"] = [];
            for (let item of this._usersICanSetAsSecondary)
                data["_usersICanSetAsSecondary"].push(item.toJSON());
        }
        if (Array.isArray(this._usersThatCanSetMeAsSecondary)) {
            data["_usersThatCanSetMeAsSecondary"] = [];
            for (let item of this._usersThatCanSetMeAsSecondary)
                data["_usersThatCanSetMeAsSecondary"].push(item.toJSON());
        }
        data["_validFrom"] = this._validFrom ? this._validFrom.toISOString() : <any>undefined;
        data["_validTo"] = this._validTo ? this._validTo.toISOString() : <any>undefined;
        data["_active"] = this._active;
        data["_AllowBackend"] = this._AllowBackend;
        data["_FrontendStartPage"] = this._FrontendStartPage;
        data["_type"] = this._type;
        data["_typeID"] = this._typeID;
        data["_modules"] = this._modules;
        if (this._modulesObject) {
            data["_modulesObject"] = {};
            for (let key in this._modulesObject) {
                if (this._modulesObject.hasOwnProperty(key))
                    data["_modulesObject"][key] = this._modulesObject[key] ? this._modulesObject[key].toJSON() : <any>undefined;
            }
        }
        data["_configurationID"] = this._configurationID;
        data["_configurationObject"] = this._configurationObject ? this._configurationObject.toJSON() : <any>undefined;
        data["_ApprovalKey"] = this._ApprovalKey;
        if (Array.isArray(this._customFieldValues)) {
            data["_customFieldValues"] = [];
            for (let item of this._customFieldValues)
                data["_customFieldValues"].push(item.toJSON());
        }
        if (Array.isArray(this._systemFieldValues)) {
            data["_systemFieldValues"] = [];
            for (let item of this._systemFieldValues)
                data["_systemFieldValues"].push(item.toJSON());
        }
        data["_ExternalID"] = this._ExternalID;
        if (Array.isArray(this._userSortCollection)) {
            data["_userSortCollection"] = [];
            for (let item of this._userSortCollection)
                data["_userSortCollection"].push(item.toJSON());
        }
        data["_shopID"] = this._shopID;
        data["_emailAllowed"] = this._emailAllowed;
        data["_disableLivePrices"] = this._disableLivePrices;
        data["_geoLocationLat"] = this._geoLocationLat;
        data["_geoLocationLng"] = this._geoLocationLng;
        data["_geoLocationIsCustom"] = this._geoLocationIsCustom;
        data["_geoLocationHash"] = this._geoLocationHash;
        data["_geoLocationImage"] = this._geoLocationImage;
        data["_vatRegNumber"] = this._vatRegNumber;
        if (Array.isArray(this._productLists)) {
            data["_productLists"] = [];
            for (let item of this._productLists)
                data["_productLists"].push(item.toJSON());
        }
        data["_administratorInGroups"] = this._administratorInGroups;
        if (Array.isArray(this._administratorInGroupsCollection)) {
            data["_administratorInGroupsCollection"] = [];
            for (let item of this._administratorInGroupsCollection)
                data["_administratorInGroupsCollection"].push(item.toJSON());
        }
        data["_exported"] = this._exported ? this._exported.toISOString() : <any>undefined;
        data["_itemType"] = this._itemType;
        data["_itemId"] = this._itemId;
        data["_itemLock"] = this._itemLock;
        if (Array.isArray(this._frequentBoughtProductsCache)) {
            data["_frequentBoughtProductsCache"] = [];
            for (let item of this._frequentBoughtProductsCache)
                data["_frequentBoughtProductsCache"].push(item);
        }
        if (Array.isArray(this._mostBoughtProductsCache)) {
            data["_mostBoughtProductsCache"] = [];
            for (let item of this._mostBoughtProductsCache)
                data["_mostBoughtProductsCache"].push(item);
        }
        if (Array.isArray(this._favoriteProductsByUserIdCache)) {
            data["_favoriteProductsByUserIdCache"] = [];
            for (let item of this._favoriteProductsByUserIdCache)
                data["_favoriteProductsByUserIdCache"].push(item);
        }
        if (Array.isArray(this._favoriteProductsByCustomernameCache)) {
            data["_favoriteProductsByCustomernameCache"] = [];
            for (let item of this._favoriteProductsByCustomernameCache)
                data["_favoriteProductsByCustomernameCache"].push(item);
        }
        data["_auditFields"] = this._auditFields ? this._auditFields.toJSON() : <any>undefined;
        data["_passwordDate"] = this._passwordDate ? this._passwordDate.toISOString() : <any>undefined;
        data["_pointBalance"] = this._pointBalance;
        data["_StockLocationID"] = this._StockLocationID;
        if (Array.isArray(this._addedGroups)) {
            data["_addedGroups"] = [];
            for (let item of this._addedGroups)
                data["_addedGroups"].push(item);
        }
        if (Array.isArray(this._removedGroups)) {
            data["_removedGroups"] = [];
            for (let item of this._removedGroups)
                data["_removedGroups"].push(item);
        }
        data["_id"] = this._id;
        data["_tableName"] = this._tableName;
        data["_keyField"] = this._keyField;
        data["_db"] = this._db;
        data["Connection"] = this.connection ? this.connection.toJSON() : <any>undefined;
        data["Transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        data["RecordCommitEvent"] = this.recordCommitEvent;
        data["RecordDeleteEvent"] = this.recordDeleteEvent;
        return data; 
    }
}

export interface IUser {
    _userName?: string | undefined;
    _password?: string | undefined;
    _passwordRecoveryToken?: string | undefined;
    _passwordRecoveryTokenExpirationTime?: Date | undefined;
    _title?: string | undefined;
    _firstName?: string | undefined;
    _lastName?: string | undefined;
    _middleName?: string | undefined;
    _houseNumber?: string | undefined;
    _name?: string | undefined;
    _email?: string | undefined;
    _address?: string | undefined;
    _address2?: string | undefined;
    _zip?: string | undefined;
    _city?: string | undefined;
    _state?: string | undefined;
    _country?: string | undefined;
    _phone?: string | undefined;
    _phonePrivate?: string | undefined;
    _phoneMobile?: string | undefined;
    _fax?: string | undefined;
    _customerNumber?: string | undefined;
    _currency?: string | undefined;
    _image?: string | undefined;
    _company?: string | undefined;
    _department?: string | undefined;
    _jobTitle?: string | undefined;
    _phoneBusiness?: string | undefined;
    _groups?: string | undefined;
    _groupsObject?: Group2[] | undefined;
    _usersICanSetAsSecondary?: User[] | undefined;
    _usersThatCanSetMeAsSecondary?: User[] | undefined;
    _validFrom?: Date | undefined;
    _validTo?: Date | undefined;
    _active?: boolean | undefined;
    _AllowBackend?: boolean | undefined;
    _FrontendStartPage?: string | undefined;
    _type?: User_type | undefined;
    _typeID?: number | undefined;
    _modules?: string | undefined;
    _modulesObject?: { [key: string]: ModulePermission; } | undefined;
    _configurationID?: number | undefined;
    _configurationObject?: EditorConfiguration | undefined;
    _ApprovalKey?: string | undefined;
    _customFieldValues?: CustomFieldValue[] | undefined;
    _systemFieldValues?: SystemFieldValue[] | undefined;
    _ExternalID?: string | undefined;
    _userSortCollection?: UserSort[] | undefined;
    _shopID?: string | undefined;
    _emailAllowed?: boolean | undefined;
    _disableLivePrices?: boolean | undefined;
    _geoLocationLat?: number | undefined;
    _geoLocationLng?: number | undefined;
    _geoLocationIsCustom?: boolean | undefined;
    _geoLocationHash?: string | undefined;
    _geoLocationImage?: string | undefined;
    _vatRegNumber?: string | undefined;
    _productLists?: CustomerProductList[] | undefined;
    _administratorInGroups?: string | undefined;
    _administratorInGroupsCollection?: Group2[] | undefined;
    _exported?: Date | undefined;
    _itemType?: string | undefined;
    _itemId?: string | undefined;
    _itemLock?: any | undefined;
    _frequentBoughtProductsCache?: string[] | undefined;
    _mostBoughtProductsCache?: string[] | undefined;
    _favoriteProductsByUserIdCache?: string[] | undefined;
    _favoriteProductsByCustomernameCache?: string[] | undefined;
    _auditFields?: AuditUserInfo | undefined;
    _passwordDate?: Date | undefined;
    _pointBalance?: number | undefined;
    _StockLocationID?: number | undefined;
    _addedGroups?: number[] | undefined;
    _removedGroups?: number[] | undefined;
    _id?: number | undefined;
    _tableName?: string | undefined;
    _keyField?: string | undefined;
    _db?: string | undefined;
    connection?: IDbConnection | undefined;
    transaction?: IDbTransaction | undefined;
    recordCommitEvent?: any | undefined;
    recordDeleteEvent?: any | undefined;
}

export class Country implements ICountry {
    _Code2?: string | undefined;
    _Code3?: string | undefined;
    _RegionCode?: string | undefined;
    _CurrencyCode?: string | undefined;
    _Number?: number | undefined;
    _CultureInfo?: string | undefined;
    _Vat?: number | undefined;
    _IsReadOnly?: boolean | undefined;
    _CountryTexts?: CountryText[] | undefined;
    _CountryText?: CountryText | undefined;
    _Regions?: Country[] | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._Code2 = _data["_Code2"];
            this._Code3 = _data["_Code3"];
            this._RegionCode = _data["_RegionCode"];
            this._CurrencyCode = _data["_CurrencyCode"];
            this._Number = _data["_Number"];
            this._CultureInfo = _data["_CultureInfo"];
            this._Vat = _data["_Vat"];
            this._IsReadOnly = _data["_IsReadOnly"];
            if (Array.isArray(_data["_CountryTexts"])) {
                this._CountryTexts = [] as any;
                for (let item of _data["_CountryTexts"])
                    this._CountryTexts!.push(CountryText.fromJS(item));
            }
            this._CountryText = _data["_CountryText"] ? CountryText.fromJS(_data["_CountryText"]) : <any>undefined;
            if (Array.isArray(_data["_Regions"])) {
                this._Regions = [] as any;
                for (let item of _data["_Regions"])
                    this._Regions!.push(Country.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_Code2"] = this._Code2;
        data["_Code3"] = this._Code3;
        data["_RegionCode"] = this._RegionCode;
        data["_CurrencyCode"] = this._CurrencyCode;
        data["_Number"] = this._Number;
        data["_CultureInfo"] = this._CultureInfo;
        data["_Vat"] = this._Vat;
        data["_IsReadOnly"] = this._IsReadOnly;
        if (Array.isArray(this._CountryTexts)) {
            data["_CountryTexts"] = [];
            for (let item of this._CountryTexts)
                data["_CountryTexts"].push(item.toJSON());
        }
        data["_CountryText"] = this._CountryText ? this._CountryText.toJSON() : <any>undefined;
        if (Array.isArray(this._Regions)) {
            data["_Regions"] = [];
            for (let item of this._Regions)
                data["_Regions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICountry {
    _Code2?: string | undefined;
    _Code3?: string | undefined;
    _RegionCode?: string | undefined;
    _CurrencyCode?: string | undefined;
    _Number?: number | undefined;
    _CultureInfo?: string | undefined;
    _Vat?: number | undefined;
    _IsReadOnly?: boolean | undefined;
    _CountryTexts?: CountryText[] | undefined;
    _CountryText?: CountryText | undefined;
    _Regions?: Country[] | undefined;
}

export class Group2 implements IGroup2 {
    _parentID?: number | undefined;
    _parent?: Group2 | undefined;
    _users?: User[] | undefined;
    _usersCount?: number | undefined;
    _subgroups?: Group2[] | undefined;
    _name?: string | undefined;
    _customerNumber?: string | undefined;
    _jobTitle?: string | undefined;
    _companyName?: string | undefined;
    _address?: string | undefined;
    _address2?: string | undefined;
    _zipCode?: string | undefined;
    _city?: string | undefined;
    _state?: string | undefined;
    _country?: string | undefined;
    _telephone?: string | undefined;
    _telephoneHome?: string | undefined;
    _teleFax?: string | undefined;
    _cellular?: string | undefined;
    _validFrom?: Date | undefined;
    _validTo?: Date | undefined;
    _configurationID?: number | undefined;
    _modules?: string | undefined;
    _AllowBackend?: boolean | undefined;
    _geoLocationLat?: number | undefined;
    _geoLocationLng?: number | undefined;
    _geoLocationIsCustom?: boolean | undefined;
    _geoLocationHash?: string | undefined;
    _geoLocationImage?: string | undefined;
    _addedUsers?: number[] | undefined;
    _removedUsers?: number[] | undefined;
    _needsToMergeUsers?: boolean | undefined;
    _settingsObject?: Properties | undefined;
    _configurationObject?: EditorConfiguration | undefined;
    _modulesObject?: { [key: string]: ModulePermission; } | undefined;
    _FrontendStartPage?: string | undefined;
    _type?: number | undefined;
    isParentSet?: boolean | undefined;
    _emailAllowed?: boolean | undefined;
    _administrators?: User[] | undefined;
    _addedAdministrators?: number[] | undefined;
    _removedAdministrators?: number[] | undefined;
    _relatedSmartSearchID?: string | undefined;
    _smartSearchCacheLastRecalculation?: Date | undefined;
    _itemType?: string | undefined;
    _itemId?: string | undefined;
    _itemLock?: any | undefined;
    _customFieldValues?: CustomFieldValue[] | undefined;
    _UserDefaultItemType?: string | undefined;
    _id?: number | undefined;
    _tableName?: string | undefined;
    _keyField?: string | undefined;
    _db?: string | undefined;
    connection?: IDbConnection | undefined;
    transaction?: IDbTransaction | undefined;
    recordCommitEvent?: any | undefined;
    recordDeleteEvent?: any | undefined;

    constructor(data?: IGroup2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._parentID = _data["_parentID"];
            this._parent = _data["_parent"] ? Group2.fromJS(_data["_parent"]) : <any>undefined;
            if (Array.isArray(_data["_users"])) {
                this._users = [] as any;
                for (let item of _data["_users"])
                    this._users!.push(User.fromJS(item));
            }
            this._usersCount = _data["_usersCount"];
            if (Array.isArray(_data["_subgroups"])) {
                this._subgroups = [] as any;
                for (let item of _data["_subgroups"])
                    this._subgroups!.push(Group2.fromJS(item));
            }
            this._name = _data["_name"];
            this._customerNumber = _data["_customerNumber"];
            this._jobTitle = _data["_jobTitle"];
            this._companyName = _data["_companyName"];
            this._address = _data["_address"];
            this._address2 = _data["_address2"];
            this._zipCode = _data["_zipCode"];
            this._city = _data["_city"];
            this._state = _data["_state"];
            this._country = _data["_country"];
            this._telephone = _data["_telephone"];
            this._telephoneHome = _data["_telephoneHome"];
            this._teleFax = _data["_teleFax"];
            this._cellular = _data["_cellular"];
            this._validFrom = _data["_validFrom"] ? new Date(_data["_validFrom"].toString()) : <any>undefined;
            this._validTo = _data["_validTo"] ? new Date(_data["_validTo"].toString()) : <any>undefined;
            this._configurationID = _data["_configurationID"];
            this._modules = _data["_modules"];
            this._AllowBackend = _data["_AllowBackend"];
            this._geoLocationLat = _data["_geoLocationLat"];
            this._geoLocationLng = _data["_geoLocationLng"];
            this._geoLocationIsCustom = _data["_geoLocationIsCustom"];
            this._geoLocationHash = _data["_geoLocationHash"];
            this._geoLocationImage = _data["_geoLocationImage"];
            if (Array.isArray(_data["_addedUsers"])) {
                this._addedUsers = [] as any;
                for (let item of _data["_addedUsers"])
                    this._addedUsers!.push(item);
            }
            if (Array.isArray(_data["_removedUsers"])) {
                this._removedUsers = [] as any;
                for (let item of _data["_removedUsers"])
                    this._removedUsers!.push(item);
            }
            this._needsToMergeUsers = _data["_needsToMergeUsers"];
            this._settingsObject = _data["_settingsObject"] ? Properties.fromJS(_data["_settingsObject"]) : <any>undefined;
            this._configurationObject = _data["_configurationObject"] ? EditorConfiguration.fromJS(_data["_configurationObject"]) : <any>undefined;
            if (_data["_modulesObject"]) {
                this._modulesObject = {} as any;
                for (let key in _data["_modulesObject"]) {
                    if (_data["_modulesObject"].hasOwnProperty(key))
                        this._modulesObject![key] = _data["_modulesObject"][key] ? ModulePermission.fromJS(_data["_modulesObject"][key]) : new ModulePermission();
                }
            }
            this._FrontendStartPage = _data["_FrontendStartPage"];
            this._type = _data["_type"];
            this.isParentSet = _data["IsParentSet"];
            this._emailAllowed = _data["_emailAllowed"];
            if (Array.isArray(_data["_administrators"])) {
                this._administrators = [] as any;
                for (let item of _data["_administrators"])
                    this._administrators!.push(User.fromJS(item));
            }
            if (Array.isArray(_data["_addedAdministrators"])) {
                this._addedAdministrators = [] as any;
                for (let item of _data["_addedAdministrators"])
                    this._addedAdministrators!.push(item);
            }
            if (Array.isArray(_data["_removedAdministrators"])) {
                this._removedAdministrators = [] as any;
                for (let item of _data["_removedAdministrators"])
                    this._removedAdministrators!.push(item);
            }
            this._relatedSmartSearchID = _data["_relatedSmartSearchID"];
            this._smartSearchCacheLastRecalculation = _data["_smartSearchCacheLastRecalculation"] ? new Date(_data["_smartSearchCacheLastRecalculation"].toString()) : <any>undefined;
            this._itemType = _data["_itemType"];
            this._itemId = _data["_itemId"];
            this._itemLock = _data["_itemLock"];
            if (Array.isArray(_data["_customFieldValues"])) {
                this._customFieldValues = [] as any;
                for (let item of _data["_customFieldValues"])
                    this._customFieldValues!.push(CustomFieldValue.fromJS(item));
            }
            this._UserDefaultItemType = _data["_UserDefaultItemType"];
            this._id = _data["_id"];
            this._tableName = _data["_tableName"];
            this._keyField = _data["_keyField"];
            this._db = _data["_db"];
            this.connection = _data["Connection"] ? IDbConnection.fromJS(_data["Connection"]) : <any>undefined;
            this.transaction = _data["Transaction"] ? IDbTransaction.fromJS(_data["Transaction"]) : <any>undefined;
            this.recordCommitEvent = _data["RecordCommitEvent"];
            this.recordDeleteEvent = _data["RecordDeleteEvent"];
        }
    }

    static fromJS(data: any): Group2 {
        data = typeof data === 'object' ? data : {};
        let result = new Group2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_parentID"] = this._parentID;
        data["_parent"] = this._parent ? this._parent.toJSON() : <any>undefined;
        if (Array.isArray(this._users)) {
            data["_users"] = [];
            for (let item of this._users)
                data["_users"].push(item.toJSON());
        }
        data["_usersCount"] = this._usersCount;
        if (Array.isArray(this._subgroups)) {
            data["_subgroups"] = [];
            for (let item of this._subgroups)
                data["_subgroups"].push(item.toJSON());
        }
        data["_name"] = this._name;
        data["_customerNumber"] = this._customerNumber;
        data["_jobTitle"] = this._jobTitle;
        data["_companyName"] = this._companyName;
        data["_address"] = this._address;
        data["_address2"] = this._address2;
        data["_zipCode"] = this._zipCode;
        data["_city"] = this._city;
        data["_state"] = this._state;
        data["_country"] = this._country;
        data["_telephone"] = this._telephone;
        data["_telephoneHome"] = this._telephoneHome;
        data["_teleFax"] = this._teleFax;
        data["_cellular"] = this._cellular;
        data["_validFrom"] = this._validFrom ? this._validFrom.toISOString() : <any>undefined;
        data["_validTo"] = this._validTo ? this._validTo.toISOString() : <any>undefined;
        data["_configurationID"] = this._configurationID;
        data["_modules"] = this._modules;
        data["_AllowBackend"] = this._AllowBackend;
        data["_geoLocationLat"] = this._geoLocationLat;
        data["_geoLocationLng"] = this._geoLocationLng;
        data["_geoLocationIsCustom"] = this._geoLocationIsCustom;
        data["_geoLocationHash"] = this._geoLocationHash;
        data["_geoLocationImage"] = this._geoLocationImage;
        if (Array.isArray(this._addedUsers)) {
            data["_addedUsers"] = [];
            for (let item of this._addedUsers)
                data["_addedUsers"].push(item);
        }
        if (Array.isArray(this._removedUsers)) {
            data["_removedUsers"] = [];
            for (let item of this._removedUsers)
                data["_removedUsers"].push(item);
        }
        data["_needsToMergeUsers"] = this._needsToMergeUsers;
        data["_settingsObject"] = this._settingsObject ? this._settingsObject.toJSON() : <any>undefined;
        data["_configurationObject"] = this._configurationObject ? this._configurationObject.toJSON() : <any>undefined;
        if (this._modulesObject) {
            data["_modulesObject"] = {};
            for (let key in this._modulesObject) {
                if (this._modulesObject.hasOwnProperty(key))
                    data["_modulesObject"][key] = this._modulesObject[key] ? this._modulesObject[key].toJSON() : <any>undefined;
            }
        }
        data["_FrontendStartPage"] = this._FrontendStartPage;
        data["_type"] = this._type;
        data["IsParentSet"] = this.isParentSet;
        data["_emailAllowed"] = this._emailAllowed;
        if (Array.isArray(this._administrators)) {
            data["_administrators"] = [];
            for (let item of this._administrators)
                data["_administrators"].push(item.toJSON());
        }
        if (Array.isArray(this._addedAdministrators)) {
            data["_addedAdministrators"] = [];
            for (let item of this._addedAdministrators)
                data["_addedAdministrators"].push(item);
        }
        if (Array.isArray(this._removedAdministrators)) {
            data["_removedAdministrators"] = [];
            for (let item of this._removedAdministrators)
                data["_removedAdministrators"].push(item);
        }
        data["_relatedSmartSearchID"] = this._relatedSmartSearchID;
        data["_smartSearchCacheLastRecalculation"] = this._smartSearchCacheLastRecalculation ? this._smartSearchCacheLastRecalculation.toISOString() : <any>undefined;
        data["_itemType"] = this._itemType;
        data["_itemId"] = this._itemId;
        data["_itemLock"] = this._itemLock;
        if (Array.isArray(this._customFieldValues)) {
            data["_customFieldValues"] = [];
            for (let item of this._customFieldValues)
                data["_customFieldValues"].push(item.toJSON());
        }
        data["_UserDefaultItemType"] = this._UserDefaultItemType;
        data["_id"] = this._id;
        data["_tableName"] = this._tableName;
        data["_keyField"] = this._keyField;
        data["_db"] = this._db;
        data["Connection"] = this.connection ? this.connection.toJSON() : <any>undefined;
        data["Transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        data["RecordCommitEvent"] = this.recordCommitEvent;
        data["RecordDeleteEvent"] = this.recordDeleteEvent;
        return data; 
    }
}

export interface IGroup2 {
    _parentID?: number | undefined;
    _parent?: Group2 | undefined;
    _users?: User[] | undefined;
    _usersCount?: number | undefined;
    _subgroups?: Group2[] | undefined;
    _name?: string | undefined;
    _customerNumber?: string | undefined;
    _jobTitle?: string | undefined;
    _companyName?: string | undefined;
    _address?: string | undefined;
    _address2?: string | undefined;
    _zipCode?: string | undefined;
    _city?: string | undefined;
    _state?: string | undefined;
    _country?: string | undefined;
    _telephone?: string | undefined;
    _telephoneHome?: string | undefined;
    _teleFax?: string | undefined;
    _cellular?: string | undefined;
    _validFrom?: Date | undefined;
    _validTo?: Date | undefined;
    _configurationID?: number | undefined;
    _modules?: string | undefined;
    _AllowBackend?: boolean | undefined;
    _geoLocationLat?: number | undefined;
    _geoLocationLng?: number | undefined;
    _geoLocationIsCustom?: boolean | undefined;
    _geoLocationHash?: string | undefined;
    _geoLocationImage?: string | undefined;
    _addedUsers?: number[] | undefined;
    _removedUsers?: number[] | undefined;
    _needsToMergeUsers?: boolean | undefined;
    _settingsObject?: Properties | undefined;
    _configurationObject?: EditorConfiguration | undefined;
    _modulesObject?: { [key: string]: ModulePermission; } | undefined;
    _FrontendStartPage?: string | undefined;
    _type?: number | undefined;
    isParentSet?: boolean | undefined;
    _emailAllowed?: boolean | undefined;
    _administrators?: User[] | undefined;
    _addedAdministrators?: number[] | undefined;
    _removedAdministrators?: number[] | undefined;
    _relatedSmartSearchID?: string | undefined;
    _smartSearchCacheLastRecalculation?: Date | undefined;
    _itemType?: string | undefined;
    _itemId?: string | undefined;
    _itemLock?: any | undefined;
    _customFieldValues?: CustomFieldValue[] | undefined;
    _UserDefaultItemType?: string | undefined;
    _id?: number | undefined;
    _tableName?: string | undefined;
    _keyField?: string | undefined;
    _db?: string | undefined;
    connection?: IDbConnection | undefined;
    transaction?: IDbTransaction | undefined;
    recordCommitEvent?: any | undefined;
    recordDeleteEvent?: any | undefined;
}

export class Language implements ILanguage {
    _LanguageID?: string | undefined;
    _Code2?: string | undefined;
    _Name?: string | undefined;
    _NativeName?: string | undefined;
    _IsDefault?: boolean | undefined;
    _IsReadOnly?: boolean | undefined;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._LanguageID = _data["_LanguageID"];
            this._Code2 = _data["_Code2"];
            this._Name = _data["_Name"];
            this._NativeName = _data["_NativeName"];
            this._IsDefault = _data["_IsDefault"];
            this._IsReadOnly = _data["_IsReadOnly"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_LanguageID"] = this._LanguageID;
        data["_Code2"] = this._Code2;
        data["_Name"] = this._Name;
        data["_NativeName"] = this._NativeName;
        data["_IsDefault"] = this._IsDefault;
        data["_IsReadOnly"] = this._IsReadOnly;
        return data; 
    }
}

export interface ILanguage {
    _LanguageID?: string | undefined;
    _Code2?: string | undefined;
    _Name?: string | undefined;
    _NativeName?: string | undefined;
    _IsDefault?: boolean | undefined;
    _IsReadOnly?: boolean | undefined;
}

export class StockStatus implements IStockStatus {
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _GroupID?: string | undefined;
    _Text?: string | undefined;
    _Icon?: string | undefined;
    _Rate?: number | undefined;
    _Definition?: string | undefined;
    _ExpectedDeliveryValue?: string | undefined;
    _ExpectedDeliveryText?: string | undefined;
    _IsReadOnly?: boolean | undefined;
    _StockStatusLineID?: string | undefined;
    _StockStatusLanguageValueID?: string | undefined;

    constructor(data?: IStockStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._LanguageID = _data["_LanguageID"];
            this._GroupID = _data["_GroupID"];
            this._Text = _data["_Text"];
            this._Icon = _data["_Icon"];
            this._Rate = _data["_Rate"];
            this._Definition = _data["_Definition"];
            this._ExpectedDeliveryValue = _data["_ExpectedDeliveryValue"];
            this._ExpectedDeliveryText = _data["_ExpectedDeliveryText"];
            this._IsReadOnly = _data["_IsReadOnly"];
            this._StockStatusLineID = _data["_StockStatusLineID"];
            this._StockStatusLanguageValueID = _data["_StockStatusLanguageValueID"];
        }
    }

    static fromJS(data: any): StockStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StockStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_LanguageID"] = this._LanguageID;
        data["_GroupID"] = this._GroupID;
        data["_Text"] = this._Text;
        data["_Icon"] = this._Icon;
        data["_Rate"] = this._Rate;
        data["_Definition"] = this._Definition;
        data["_ExpectedDeliveryValue"] = this._ExpectedDeliveryValue;
        data["_ExpectedDeliveryText"] = this._ExpectedDeliveryText;
        data["_IsReadOnly"] = this._IsReadOnly;
        data["_StockStatusLineID"] = this._StockStatusLineID;
        data["_StockStatusLanguageValueID"] = this._StockStatusLanguageValueID;
        return data; 
    }
}

export interface IStockStatus {
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _GroupID?: string | undefined;
    _Text?: string | undefined;
    _Icon?: string | undefined;
    _Rate?: number | undefined;
    _Definition?: string | undefined;
    _ExpectedDeliveryValue?: string | undefined;
    _ExpectedDeliveryText?: string | undefined;
    _IsReadOnly?: boolean | undefined;
    _StockStatusLineID?: string | undefined;
    _StockStatusLanguageValueID?: string | undefined;
}

export class VatGroupCountryRelation implements IVatGroupCountryRelation {
    _GroupID?: string | undefined;
    _CountryID?: string | undefined;
    _LanguageID?: string | undefined;
    _VatValue?: number | undefined;
    _ReverseChargeForVat?: boolean | undefined;

    constructor(data?: IVatGroupCountryRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._GroupID = _data["_GroupID"];
            this._CountryID = _data["_CountryID"];
            this._LanguageID = _data["_LanguageID"];
            this._VatValue = _data["_VatValue"];
            this._ReverseChargeForVat = _data["_ReverseChargeForVat"];
        }
    }

    static fromJS(data: any): VatGroupCountryRelation {
        data = typeof data === 'object' ? data : {};
        let result = new VatGroupCountryRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_GroupID"] = this._GroupID;
        data["_CountryID"] = this._CountryID;
        data["_LanguageID"] = this._LanguageID;
        data["_VatValue"] = this._VatValue;
        data["_ReverseChargeForVat"] = this._ReverseChargeForVat;
        return data; 
    }
}

export interface IVatGroupCountryRelation {
    _GroupID?: string | undefined;
    _CountryID?: string | undefined;
    _LanguageID?: string | undefined;
    _VatValue?: number | undefined;
    _ReverseChargeForVat?: boolean | undefined;
}

export class IDbConnection implements IIDbConnection {
    connectionString?: string | undefined;
    readonly connectionTimeout?: number | undefined;
    readonly database?: string | undefined;
    readonly state?: IDbConnectionState | undefined;

    constructor(data?: IIDbConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data["ConnectionString"];
            (<any>this).connectionTimeout = _data["ConnectionTimeout"];
            (<any>this).database = _data["Database"];
            (<any>this).state = _data["State"];
        }
    }

    static fromJS(data: any): IDbConnection {
        data = typeof data === 'object' ? data : {};
        let result = new IDbConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConnectionString"] = this.connectionString;
        data["ConnectionTimeout"] = this.connectionTimeout;
        data["Database"] = this.database;
        data["State"] = this.state;
        return data; 
    }
}

export interface IIDbConnection {
    connectionString?: string | undefined;
    connectionTimeout?: number | undefined;
    database?: string | undefined;
    state?: IDbConnectionState | undefined;
}

export class IDbTransaction implements IIDbTransaction {
    readonly connection?: IDbConnection | undefined;
    readonly isolationLevel?: IDbTransactionIsolationLevel | undefined;

    constructor(data?: IIDbTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).connection = _data["Connection"] ? IDbConnection.fromJS(_data["Connection"]) : <any>undefined;
            (<any>this).isolationLevel = _data["IsolationLevel"];
        }
    }

    static fromJS(data: any): IDbTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new IDbTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Connection"] = this.connection ? this.connection.toJSON() : <any>undefined;
        data["IsolationLevel"] = this.isolationLevel;
        return data; 
    }
}

export interface IIDbTransaction {
    connection?: IDbConnection | undefined;
    isolationLevel?: IDbTransactionIsolationLevel | undefined;
}

export class ProductField implements IProductField {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _SystemName?: string | undefined;
    _TemplateName?: string | undefined;
    _TypeID?: number | undefined;
    _TypeName?: string | undefined;
    _Locked?: boolean | undefined;
    _Sort?: number | undefined;
    _IsReadOnly?: boolean | undefined;
    _Types?: FieldType[] | undefined;
    _ListPresentationType?: ProductField_ListPresentationType | undefined;

    constructor(data?: IProductField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._Name = _data["_Name"];
            this._SystemName = _data["_SystemName"];
            this._TemplateName = _data["_TemplateName"];
            this._TypeID = _data["_TypeID"];
            this._TypeName = _data["_TypeName"];
            this._Locked = _data["_Locked"];
            this._Sort = _data["_Sort"];
            this._IsReadOnly = _data["_IsReadOnly"];
            if (Array.isArray(_data["_Types"])) {
                this._Types = [] as any;
                for (let item of _data["_Types"])
                    this._Types!.push(FieldType.fromJS(item));
            }
            this._ListPresentationType = _data["_ListPresentationType"];
        }
    }

    static fromJS(data: any): ProductField {
        data = typeof data === 'object' ? data : {};
        let result = new ProductField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_Name"] = this._Name;
        data["_SystemName"] = this._SystemName;
        data["_TemplateName"] = this._TemplateName;
        data["_TypeID"] = this._TypeID;
        data["_TypeName"] = this._TypeName;
        data["_Locked"] = this._Locked;
        data["_Sort"] = this._Sort;
        data["_IsReadOnly"] = this._IsReadOnly;
        if (Array.isArray(this._Types)) {
            data["_Types"] = [];
            for (let item of this._Types)
                data["_Types"].push(item.toJSON());
        }
        data["_ListPresentationType"] = this._ListPresentationType;
        return data; 
    }
}

export interface IProductField {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _SystemName?: string | undefined;
    _TemplateName?: string | undefined;
    _TypeID?: number | undefined;
    _TypeName?: string | undefined;
    _Locked?: boolean | undefined;
    _Sort?: number | undefined;
    _IsReadOnly?: boolean | undefined;
    _Types?: FieldType[] | undefined;
    _ListPresentationType?: ProductField_ListPresentationType | undefined;
}

export class PriceRaw implements IPriceRaw {
    _price?: number | undefined;
    _currency?: Currency | undefined;

    constructor(data?: IPriceRaw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._price = _data["_price"];
            this._currency = _data["_currency"] ? Currency.fromJS(_data["_currency"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PriceRaw {
        data = typeof data === 'object' ? data : {};
        let result = new PriceRaw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_price"] = this._price;
        data["_currency"] = this._currency ? this._currency.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPriceRaw {
    _price?: number | undefined;
    _currency?: Currency | undefined;
}

export class ProductGroupField implements IProductGroupField {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _SystemName?: string | undefined;
    _TemplateName?: string | undefined;
    _TypeID?: number | undefined;
    _TypeName?: string | undefined;
    _Locked?: boolean | undefined;
    _Sort?: number | undefined;
    _IsReadOnly?: boolean | undefined;
    _Required?: boolean | undefined;
    _Types?: FieldType[] | undefined;
    _ListPresentationType?: ProductGroupField_ListPresentationType | undefined;

    constructor(data?: IProductGroupField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._Name = _data["_Name"];
            this._SystemName = _data["_SystemName"];
            this._TemplateName = _data["_TemplateName"];
            this._TypeID = _data["_TypeID"];
            this._TypeName = _data["_TypeName"];
            this._Locked = _data["_Locked"];
            this._Sort = _data["_Sort"];
            this._IsReadOnly = _data["_IsReadOnly"];
            this._Required = _data["_Required"];
            if (Array.isArray(_data["_Types"])) {
                this._Types = [] as any;
                for (let item of _data["_Types"])
                    this._Types!.push(FieldType.fromJS(item));
            }
            this._ListPresentationType = _data["_ListPresentationType"];
        }
    }

    static fromJS(data: any): ProductGroupField {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroupField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_Name"] = this._Name;
        data["_SystemName"] = this._SystemName;
        data["_TemplateName"] = this._TemplateName;
        data["_TypeID"] = this._TypeID;
        data["_TypeName"] = this._TypeName;
        data["_Locked"] = this._Locked;
        data["_Sort"] = this._Sort;
        data["_IsReadOnly"] = this._IsReadOnly;
        data["_Required"] = this._Required;
        if (Array.isArray(this._Types)) {
            data["_Types"] = [];
            for (let item of this._Types)
                data["_Types"].push(item.toJSON());
        }
        data["_ListPresentationType"] = this._ListPresentationType;
        return data; 
    }
}

export interface IProductGroupField {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _SystemName?: string | undefined;
    _TemplateName?: string | undefined;
    _TypeID?: number | undefined;
    _TypeName?: string | undefined;
    _Locked?: boolean | undefined;
    _Sort?: number | undefined;
    _IsReadOnly?: boolean | undefined;
    _Required?: boolean | undefined;
    _Types?: FieldType[] | undefined;
    _ListPresentationType?: ProductGroupField_ListPresentationType | undefined;
}

export class DefinedRight implements IDefinedRight {
    _UserID?: number | undefined;
    _Permissions?: number | undefined;
    _UserName?: string | undefined;
    _IsGroup?: boolean | undefined;

    constructor(data?: IDefinedRight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._UserID = _data["_UserID"];
            this._Permissions = _data["_Permissions"];
            this._UserName = _data["_UserName"];
            this._IsGroup = _data["_IsGroup"];
        }
    }

    static fromJS(data: any): DefinedRight {
        data = typeof data === 'object' ? data : {};
        let result = new DefinedRight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_UserID"] = this._UserID;
        data["_Permissions"] = this._Permissions;
        data["_UserName"] = this._UserName;
        data["_IsGroup"] = this._IsGroup;
        return data; 
    }
}

export interface IDefinedRight {
    _UserID?: number | undefined;
    _Permissions?: number | undefined;
    _UserName?: string | undefined;
    _IsGroup?: boolean | undefined;
}

export class Field implements IField {
    _id?: string | undefined;
    _category?: Category | undefined;
    _label?: string | undefined;
    _type?: string | undefined;
    _templateTag?: string | undefined;
    _defaultValue?: string | undefined;
    _presentationType?: Field_presentationType | undefined;
    _options?: FieldOption[] | undefined;
    _sortOrder?: number | undefined;

    constructor(data?: IField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._id = _data["_id"];
            this._category = _data["_category"] ? Category.fromJS(_data["_category"]) : <any>undefined;
            this._label = _data["_label"];
            this._type = _data["_type"];
            this._templateTag = _data["_templateTag"];
            this._defaultValue = _data["_defaultValue"];
            this._presentationType = _data["_presentationType"];
            if (Array.isArray(_data["_options"])) {
                this._options = [] as any;
                for (let item of _data["_options"])
                    this._options!.push(FieldOption.fromJS(item));
            }
            this._sortOrder = _data["_sortOrder"];
        }
    }

    static fromJS(data: any): Field {
        data = typeof data === 'object' ? data : {};
        let result = new Field();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_id"] = this._id;
        data["_category"] = this._category ? this._category.toJSON() : <any>undefined;
        data["_label"] = this._label;
        data["_type"] = this._type;
        data["_templateTag"] = this._templateTag;
        data["_defaultValue"] = this._defaultValue;
        data["_presentationType"] = this._presentationType;
        if (Array.isArray(this._options)) {
            data["_options"] = [];
            for (let item of this._options)
                data["_options"].push(item.toJSON());
        }
        data["_sortOrder"] = this._sortOrder;
        return data; 
    }
}

export interface IField {
    _id?: string | undefined;
    _category?: Category | undefined;
    _label?: string | undefined;
    _type?: string | undefined;
    _templateTag?: string | undefined;
    _defaultValue?: string | undefined;
    _presentationType?: Field_presentationType | undefined;
    _options?: FieldOption[] | undefined;
    _sortOrder?: number | undefined;
}

export class PropertyField implements IPropertyField {
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _GroupID?: string | undefined;
    _Label?: string | undefined;
    _InputType?: string | undefined;
    _PropertyFieldOptions?: PropertyFieldOption[] | undefined;
    _PropertyProductValue?: PropertyProductValue | undefined;

    constructor(data?: IPropertyField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._LanguageID = _data["_LanguageID"];
            this._GroupID = _data["_GroupID"];
            this._Label = _data["_Label"];
            this._InputType = _data["_InputType"];
            if (Array.isArray(_data["_PropertyFieldOptions"])) {
                this._PropertyFieldOptions = [] as any;
                for (let item of _data["_PropertyFieldOptions"])
                    this._PropertyFieldOptions!.push(PropertyFieldOption.fromJS(item));
            }
            this._PropertyProductValue = _data["_PropertyProductValue"] ? PropertyProductValue.fromJS(_data["_PropertyProductValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyField {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_LanguageID"] = this._LanguageID;
        data["_GroupID"] = this._GroupID;
        data["_Label"] = this._Label;
        data["_InputType"] = this._InputType;
        if (Array.isArray(this._PropertyFieldOptions)) {
            data["_PropertyFieldOptions"] = [];
            for (let item of this._PropertyFieldOptions)
                data["_PropertyFieldOptions"].push(item.toJSON());
        }
        data["_PropertyProductValue"] = this._PropertyProductValue ? this._PropertyProductValue.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPropertyField {
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _GroupID?: string | undefined;
    _Label?: string | undefined;
    _InputType?: string | undefined;
    _PropertyFieldOptions?: PropertyFieldOption[] | undefined;
    _PropertyProductValue?: PropertyProductValue | undefined;
}

export class Rounding implements IRounding {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _ModIntegerPart?: number | undefined;
    _ModDecimalPart?: number | undefined;
    _ModIntegerCorrection?: number | undefined;
    _ModDecimalCorrection?: number | undefined;
    _Method?: number | undefined;
    _Decimals?: number | undefined;

    constructor(data?: IRounding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._Name = _data["_Name"];
            this._ModIntegerPart = _data["_ModIntegerPart"];
            this._ModDecimalPart = _data["_ModDecimalPart"];
            this._ModIntegerCorrection = _data["_ModIntegerCorrection"];
            this._ModDecimalCorrection = _data["_ModDecimalCorrection"];
            this._Method = _data["_Method"];
            this._Decimals = _data["_Decimals"];
        }
    }

    static fromJS(data: any): Rounding {
        data = typeof data === 'object' ? data : {};
        let result = new Rounding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_Name"] = this._Name;
        data["_ModIntegerPart"] = this._ModIntegerPart;
        data["_ModDecimalPart"] = this._ModDecimalPart;
        data["_ModIntegerCorrection"] = this._ModIntegerCorrection;
        data["_ModDecimalCorrection"] = this._ModDecimalCorrection;
        data["_Method"] = this._Method;
        data["_Decimals"] = this._Decimals;
        return data; 
    }
}

export interface IRounding {
    _ID?: string | undefined;
    _Name?: string | undefined;
    _ModIntegerPart?: number | undefined;
    _ModDecimalPart?: number | undefined;
    _ModIntegerCorrection?: number | undefined;
    _ModDecimalCorrection?: number | undefined;
    _Method?: number | undefined;
    _Decimals?: number | undefined;
}

export class NumberFormatInfo implements INumberFormatInfo {
    numberGroupSizes?: number[] | undefined;
    currencyGroupSizes?: number[] | undefined;
    percentGroupSizes?: number[] | undefined;
    positiveSign?: string | undefined;
    negativeSign?: string | undefined;
    numberDecimalSeparator?: string | undefined;
    numberGroupSeparator?: string | undefined;
    currencyGroupSeparator?: string | undefined;
    currencyDecimalSeparator?: string | undefined;
    currencySymbol?: string | undefined;
    ansiCurrencySymbol?: string | undefined;
    nanSymbol?: string | undefined;
    positiveInfinitySymbol?: string | undefined;
    negativeInfinitySymbol?: string | undefined;
    percentDecimalSeparator?: string | undefined;
    percentGroupSeparator?: string | undefined;
    percentSymbol?: string | undefined;
    perMilleSymbol?: string | undefined;
    nativeDigits?: string[] | undefined;
    m_dataItem?: number | undefined;
    numberDecimalDigits?: number | undefined;
    currencyDecimalDigits?: number | undefined;
    currencyPositivePattern?: number | undefined;
    currencyNegativePattern?: number | undefined;
    numberNegativePattern?: number | undefined;
    percentPositivePattern?: number | undefined;
    percentNegativePattern?: number | undefined;
    percentDecimalDigits?: number | undefined;
    digitSubstitution?: number | undefined;
    isReadOnly?: boolean | undefined;
    m_useUserOverride?: boolean | undefined;
    m_isInvariant?: boolean | undefined;
    validForParseAsNumber?: boolean | undefined;
    validForParseAsCurrency?: boolean | undefined;

    constructor(data?: INumberFormatInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["numberGroupSizes"])) {
                this.numberGroupSizes = [] as any;
                for (let item of _data["numberGroupSizes"])
                    this.numberGroupSizes!.push(item);
            }
            if (Array.isArray(_data["currencyGroupSizes"])) {
                this.currencyGroupSizes = [] as any;
                for (let item of _data["currencyGroupSizes"])
                    this.currencyGroupSizes!.push(item);
            }
            if (Array.isArray(_data["percentGroupSizes"])) {
                this.percentGroupSizes = [] as any;
                for (let item of _data["percentGroupSizes"])
                    this.percentGroupSizes!.push(item);
            }
            this.positiveSign = _data["positiveSign"];
            this.negativeSign = _data["negativeSign"];
            this.numberDecimalSeparator = _data["numberDecimalSeparator"];
            this.numberGroupSeparator = _data["numberGroupSeparator"];
            this.currencyGroupSeparator = _data["currencyGroupSeparator"];
            this.currencyDecimalSeparator = _data["currencyDecimalSeparator"];
            this.currencySymbol = _data["currencySymbol"];
            this.ansiCurrencySymbol = _data["ansiCurrencySymbol"];
            this.nanSymbol = _data["nanSymbol"];
            this.positiveInfinitySymbol = _data["positiveInfinitySymbol"];
            this.negativeInfinitySymbol = _data["negativeInfinitySymbol"];
            this.percentDecimalSeparator = _data["percentDecimalSeparator"];
            this.percentGroupSeparator = _data["percentGroupSeparator"];
            this.percentSymbol = _data["percentSymbol"];
            this.perMilleSymbol = _data["perMilleSymbol"];
            if (Array.isArray(_data["nativeDigits"])) {
                this.nativeDigits = [] as any;
                for (let item of _data["nativeDigits"])
                    this.nativeDigits!.push(item);
            }
            this.m_dataItem = _data["m_dataItem"];
            this.numberDecimalDigits = _data["numberDecimalDigits"];
            this.currencyDecimalDigits = _data["currencyDecimalDigits"];
            this.currencyPositivePattern = _data["currencyPositivePattern"];
            this.currencyNegativePattern = _data["currencyNegativePattern"];
            this.numberNegativePattern = _data["numberNegativePattern"];
            this.percentPositivePattern = _data["percentPositivePattern"];
            this.percentNegativePattern = _data["percentNegativePattern"];
            this.percentDecimalDigits = _data["percentDecimalDigits"];
            this.digitSubstitution = _data["digitSubstitution"];
            this.isReadOnly = _data["isReadOnly"];
            this.m_useUserOverride = _data["m_useUserOverride"];
            this.m_isInvariant = _data["m_isInvariant"];
            this.validForParseAsNumber = _data["validForParseAsNumber"];
            this.validForParseAsCurrency = _data["validForParseAsCurrency"];
        }
    }

    static fromJS(data: any): NumberFormatInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NumberFormatInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.numberGroupSizes)) {
            data["numberGroupSizes"] = [];
            for (let item of this.numberGroupSizes)
                data["numberGroupSizes"].push(item);
        }
        if (Array.isArray(this.currencyGroupSizes)) {
            data["currencyGroupSizes"] = [];
            for (let item of this.currencyGroupSizes)
                data["currencyGroupSizes"].push(item);
        }
        if (Array.isArray(this.percentGroupSizes)) {
            data["percentGroupSizes"] = [];
            for (let item of this.percentGroupSizes)
                data["percentGroupSizes"].push(item);
        }
        data["positiveSign"] = this.positiveSign;
        data["negativeSign"] = this.negativeSign;
        data["numberDecimalSeparator"] = this.numberDecimalSeparator;
        data["numberGroupSeparator"] = this.numberGroupSeparator;
        data["currencyGroupSeparator"] = this.currencyGroupSeparator;
        data["currencyDecimalSeparator"] = this.currencyDecimalSeparator;
        data["currencySymbol"] = this.currencySymbol;
        data["ansiCurrencySymbol"] = this.ansiCurrencySymbol;
        data["nanSymbol"] = this.nanSymbol;
        data["positiveInfinitySymbol"] = this.positiveInfinitySymbol;
        data["negativeInfinitySymbol"] = this.negativeInfinitySymbol;
        data["percentDecimalSeparator"] = this.percentDecimalSeparator;
        data["percentGroupSeparator"] = this.percentGroupSeparator;
        data["percentSymbol"] = this.percentSymbol;
        data["perMilleSymbol"] = this.perMilleSymbol;
        if (Array.isArray(this.nativeDigits)) {
            data["nativeDigits"] = [];
            for (let item of this.nativeDigits)
                data["nativeDigits"].push(item);
        }
        data["m_dataItem"] = this.m_dataItem;
        data["numberDecimalDigits"] = this.numberDecimalDigits;
        data["currencyDecimalDigits"] = this.currencyDecimalDigits;
        data["currencyPositivePattern"] = this.currencyPositivePattern;
        data["currencyNegativePattern"] = this.currencyNegativePattern;
        data["numberNegativePattern"] = this.numberNegativePattern;
        data["percentPositivePattern"] = this.percentPositivePattern;
        data["percentNegativePattern"] = this.percentNegativePattern;
        data["percentDecimalDigits"] = this.percentDecimalDigits;
        data["digitSubstitution"] = this.digitSubstitution;
        data["isReadOnly"] = this.isReadOnly;
        data["m_useUserOverride"] = this.m_useUserOverride;
        data["m_isInvariant"] = this.m_isInvariant;
        data["validForParseAsNumber"] = this.validForParseAsNumber;
        data["validForParseAsCurrency"] = this.validForParseAsCurrency;
        return data; 
    }
}

export interface INumberFormatInfo {
    numberGroupSizes?: number[] | undefined;
    currencyGroupSizes?: number[] | undefined;
    percentGroupSizes?: number[] | undefined;
    positiveSign?: string | undefined;
    negativeSign?: string | undefined;
    numberDecimalSeparator?: string | undefined;
    numberGroupSeparator?: string | undefined;
    currencyGroupSeparator?: string | undefined;
    currencyDecimalSeparator?: string | undefined;
    currencySymbol?: string | undefined;
    ansiCurrencySymbol?: string | undefined;
    nanSymbol?: string | undefined;
    positiveInfinitySymbol?: string | undefined;
    negativeInfinitySymbol?: string | undefined;
    percentDecimalSeparator?: string | undefined;
    percentGroupSeparator?: string | undefined;
    percentSymbol?: string | undefined;
    perMilleSymbol?: string | undefined;
    nativeDigits?: string[] | undefined;
    m_dataItem?: number | undefined;
    numberDecimalDigits?: number | undefined;
    currencyDecimalDigits?: number | undefined;
    currencyPositivePattern?: number | undefined;
    currencyNegativePattern?: number | undefined;
    numberNegativePattern?: number | undefined;
    percentPositivePattern?: number | undefined;
    percentNegativePattern?: number | undefined;
    percentDecimalDigits?: number | undefined;
    digitSubstitution?: number | undefined;
    isReadOnly?: boolean | undefined;
    m_useUserOverride?: boolean | undefined;
    m_isInvariant?: boolean | undefined;
    validForParseAsNumber?: boolean | undefined;
    validForParseAsCurrency?: boolean | undefined;
}

export class ModulePermission implements IModulePermission {
    access?: ModulePermissionAccess | undefined;
    create?: ModulePermissionCreate | undefined;
    edit?: ModulePermissionEdit | undefined;
    delete?: ModulePermissionDelete | undefined;
    categories?: number[] | undefined;

    constructor(data?: IModulePermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access = _data["Access"];
            this.create = _data["Create"];
            this.edit = _data["Edit"];
            this.delete = _data["Delete"];
            if (Array.isArray(_data["Categories"])) {
                this.categories = [] as any;
                for (let item of _data["Categories"])
                    this.categories!.push(item);
            }
        }
    }

    static fromJS(data: any): ModulePermission {
        data = typeof data === 'object' ? data : {};
        let result = new ModulePermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Access"] = this.access;
        data["Create"] = this.create;
        data["Edit"] = this.edit;
        data["Delete"] = this.delete;
        if (Array.isArray(this.categories)) {
            data["Categories"] = [];
            for (let item of this.categories)
                data["Categories"].push(item);
        }
        return data; 
    }
}

export interface IModulePermission {
    access?: ModulePermissionAccess | undefined;
    create?: ModulePermissionCreate | undefined;
    edit?: ModulePermissionEdit | undefined;
    delete?: ModulePermissionDelete | undefined;
    categories?: number[] | undefined;
}

export class EditorConfiguration implements IEditorConfiguration {
    id?: number | undefined;
    name?: string | undefined;
    configuration?: Properties | undefined;
    xmlConfiguration?: string | undefined;
    isDefault?: boolean | undefined;
    configurationType?: string | undefined;
    addInProviderName?: string | undefined;

    constructor(data?: IEditorConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.configuration = _data["Configuration"] ? Properties.fromJS(_data["Configuration"]) : <any>undefined;
            this.xmlConfiguration = _data["XmlConfiguration"];
            this.isDefault = _data["IsDefault"];
            this.configurationType = _data["ConfigurationType"];
            this.addInProviderName = _data["AddInProviderName"];
        }
    }

    static fromJS(data: any): EditorConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new EditorConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        data["XmlConfiguration"] = this.xmlConfiguration;
        data["IsDefault"] = this.isDefault;
        data["ConfigurationType"] = this.configurationType;
        data["AddInProviderName"] = this.addInProviderName;
        return data; 
    }
}

export interface IEditorConfiguration {
    id?: number | undefined;
    name?: string | undefined;
    configuration?: Properties | undefined;
    xmlConfiguration?: string | undefined;
    isDefault?: boolean | undefined;
    configurationType?: string | undefined;
    addInProviderName?: string | undefined;
}

export class CustomFieldValue implements ICustomFieldValue {
    customField?: CustomField | undefined;
    value?: any | undefined;

    constructor(data?: ICustomFieldValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customField = _data["CustomField"] ? CustomField.fromJS(_data["CustomField"]) : <any>undefined;
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): CustomFieldValue {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomField"] = this.customField ? this.customField.toJSON() : <any>undefined;
        data["Value"] = this.value;
        return data; 
    }
}

export interface ICustomFieldValue {
    customField?: CustomField | undefined;
    value?: any | undefined;
}

export class SystemFieldValue implements ISystemFieldValue {
    systemField?: SystemField | undefined;
    itemId?: number | undefined;
    value?: any | undefined;

    constructor(data?: ISystemFieldValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemField = _data["SystemField"] ? SystemField.fromJS(_data["SystemField"]) : <any>undefined;
            this.itemId = _data["ItemId"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): SystemFieldValue {
        data = typeof data === 'object' ? data : {};
        let result = new SystemFieldValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SystemField"] = this.systemField ? this.systemField.toJSON() : <any>undefined;
        data["ItemId"] = this.itemId;
        data["Value"] = this.value;
        return data; 
    }
}

export interface ISystemFieldValue {
    systemField?: SystemField | undefined;
    itemId?: number | undefined;
    value?: any | undefined;
}

export class UserSort implements IUserSort {
    groupID?: number | undefined;
    sort?: number | undefined;

    constructor(data?: IUserSort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupID = _data["GroupID"];
            this.sort = _data["Sort"];
        }
    }

    static fromJS(data: any): UserSort {
        data = typeof data === 'object' ? data : {};
        let result = new UserSort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["GroupID"] = this.groupID;
        data["Sort"] = this.sort;
        return data; 
    }
}

export interface IUserSort {
    groupID?: number | undefined;
    sort?: number | undefined;
}

export class CustomerProductList implements ICustomerProductList {
    listID?: number | undefined;
    accessUserID?: number | undefined;
    name?: string | undefined;
    isPublished?: boolean | undefined;
    publishedToDate?: Date | undefined;
    type?: string | undefined;
    isDefault?: boolean | undefined;
    description?: string | undefined;
    publishedId?: string | undefined;
    readonly products?: CustomerProductListProduct[] | undefined;
    iD?: number | undefined;
    readonly isNew?: boolean | undefined;

    constructor(data?: ICustomerProductList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listID = _data["ListID"];
            this.accessUserID = _data["AccessUserID"];
            this.name = _data["Name"];
            this.isPublished = _data["IsPublished"];
            this.publishedToDate = _data["PublishedToDate"] ? new Date(_data["PublishedToDate"].toString()) : <any>undefined;
            this.type = _data["Type"];
            this.isDefault = _data["IsDefault"];
            this.description = _data["Description"];
            this.publishedId = _data["PublishedId"];
            if (Array.isArray(_data["Products"])) {
                (<any>this).products = [] as any;
                for (let item of _data["Products"])
                    (<any>this).products!.push(CustomerProductListProduct.fromJS(item));
            }
            this.iD = _data["ID"];
            (<any>this).isNew = _data["IsNew"];
        }
    }

    static fromJS(data: any): CustomerProductList {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerProductList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ListID"] = this.listID;
        data["AccessUserID"] = this.accessUserID;
        data["Name"] = this.name;
        data["IsPublished"] = this.isPublished;
        data["PublishedToDate"] = this.publishedToDate ? this.publishedToDate.toISOString() : <any>undefined;
        data["Type"] = this.type;
        data["IsDefault"] = this.isDefault;
        data["Description"] = this.description;
        data["PublishedId"] = this.publishedId;
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item.toJSON());
        }
        data["ID"] = this.iD;
        data["IsNew"] = this.isNew;
        return data; 
    }
}

export interface ICustomerProductList {
    listID?: number | undefined;
    accessUserID?: number | undefined;
    name?: string | undefined;
    isPublished?: boolean | undefined;
    publishedToDate?: Date | undefined;
    type?: string | undefined;
    isDefault?: boolean | undefined;
    description?: string | undefined;
    publishedId?: string | undefined;
    products?: CustomerProductListProduct[] | undefined;
    iD?: number | undefined;
    isNew?: boolean | undefined;
}

export class AuditUserInfo implements IAuditUserInfo {
    readonly createdOn?: Date | undefined;
    readonly updatedOn?: Date | undefined;
    readonly createdByUser?: string | undefined;
    readonly updatedByUser?: string | undefined;
    readonly emailPermissionGivenOn?: Date | undefined;
    readonly emailPermissionUpdatedOn?: Date | undefined;
    readonly lastLoginOn?: Date | undefined;

    constructor(data?: IAuditUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : <any>undefined;
            (<any>this).updatedOn = _data["UpdatedOn"] ? new Date(_data["UpdatedOn"].toString()) : <any>undefined;
            (<any>this).createdByUser = _data["CreatedByUser"];
            (<any>this).updatedByUser = _data["UpdatedByUser"];
            (<any>this).emailPermissionGivenOn = _data["EmailPermissionGivenOn"] ? new Date(_data["EmailPermissionGivenOn"].toString()) : <any>undefined;
            (<any>this).emailPermissionUpdatedOn = _data["EmailPermissionUpdatedOn"] ? new Date(_data["EmailPermissionUpdatedOn"].toString()) : <any>undefined;
            (<any>this).lastLoginOn = _data["LastLoginOn"] ? new Date(_data["LastLoginOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditUserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuditUserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["UpdatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["CreatedByUser"] = this.createdByUser;
        data["UpdatedByUser"] = this.updatedByUser;
        data["EmailPermissionGivenOn"] = this.emailPermissionGivenOn ? this.emailPermissionGivenOn.toISOString() : <any>undefined;
        data["EmailPermissionUpdatedOn"] = this.emailPermissionUpdatedOn ? this.emailPermissionUpdatedOn.toISOString() : <any>undefined;
        data["LastLoginOn"] = this.lastLoginOn ? this.lastLoginOn.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IAuditUserInfo {
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    createdByUser?: string | undefined;
    updatedByUser?: string | undefined;
    emailPermissionGivenOn?: Date | undefined;
    emailPermissionUpdatedOn?: Date | undefined;
    lastLoginOn?: Date | undefined;
}

export class CountryText implements ICountryText {
    _Code2?: string | undefined;
    _RegionCode?: string | undefined;
    _LanguageID?: string | undefined;
    _Name?: string | undefined;
    _Countries?: Country[] | undefined;
    _CountryRelations?: CountryRelation[] | undefined;

    constructor(data?: ICountryText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._Code2 = _data["_Code2"];
            this._RegionCode = _data["_RegionCode"];
            this._LanguageID = _data["_LanguageID"];
            this._Name = _data["_Name"];
            if (Array.isArray(_data["_Countries"])) {
                this._Countries = [] as any;
                for (let item of _data["_Countries"])
                    this._Countries!.push(Country.fromJS(item));
            }
            if (Array.isArray(_data["_CountryRelations"])) {
                this._CountryRelations = [] as any;
                for (let item of _data["_CountryRelations"])
                    this._CountryRelations!.push(CountryRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryText {
        data = typeof data === 'object' ? data : {};
        let result = new CountryText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_Code2"] = this._Code2;
        data["_RegionCode"] = this._RegionCode;
        data["_LanguageID"] = this._LanguageID;
        data["_Name"] = this._Name;
        if (Array.isArray(this._Countries)) {
            data["_Countries"] = [];
            for (let item of this._Countries)
                data["_Countries"].push(item.toJSON());
        }
        if (Array.isArray(this._CountryRelations)) {
            data["_CountryRelations"] = [];
            for (let item of this._CountryRelations)
                data["_CountryRelations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICountryText {
    _Code2?: string | undefined;
    _RegionCode?: string | undefined;
    _LanguageID?: string | undefined;
    _Name?: string | undefined;
    _Countries?: Country[] | undefined;
    _CountryRelations?: CountryRelation[] | undefined;
}

export class Properties implements IProperties {
    readonly moduleBeingAttached?: boolean | undefined;
    readonly values?: { [key: string]: any; } | undefined;
    readonly getKeyValueHtmlTable?: string | undefined;

    constructor(data?: IProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).moduleBeingAttached = _data["ModuleBeingAttached"];
            if (_data["Values"]) {
                (<any>this).values = {} as any;
                for (let key in _data["Values"]) {
                    if (_data["Values"].hasOwnProperty(key))
                        (<any>this).values![key] = _data["Values"][key];
                }
            }
            (<any>this).getKeyValueHtmlTable = _data["GetKeyValueHtmlTable"];
        }
    }

    static fromJS(data: any): Properties {
        data = typeof data === 'object' ? data : {};
        let result = new Properties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ModuleBeingAttached"] = this.moduleBeingAttached;
        if (this.values) {
            data["Values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    data["Values"][key] = this.values[key];
            }
        }
        data["GetKeyValueHtmlTable"] = this.getKeyValueHtmlTable;
        return data; 
    }
}

export interface IProperties {
    moduleBeingAttached?: boolean | undefined;
    values?: { [key: string]: any; } | undefined;
    getKeyValueHtmlTable?: string | undefined;
}

export class FieldType implements IFieldType {
    _ID?: number | undefined;
    _Name?: string | undefined;
    _DWName?: string | undefined;
    _OptionName?: string | undefined;
    _Sort?: number | undefined;
    _DB?: string | undefined;
    _DBSQL?: string | undefined;
    _Advanced?: boolean | undefined;

    constructor(data?: IFieldType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._Name = _data["_Name"];
            this._DWName = _data["_DWName"];
            this._OptionName = _data["_OptionName"];
            this._Sort = _data["_Sort"];
            this._DB = _data["_DB"];
            this._DBSQL = _data["_DBSQL"];
            this._Advanced = _data["_Advanced"];
        }
    }

    static fromJS(data: any): FieldType {
        data = typeof data === 'object' ? data : {};
        let result = new FieldType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_Name"] = this._Name;
        data["_DWName"] = this._DWName;
        data["_OptionName"] = this._OptionName;
        data["_Sort"] = this._Sort;
        data["_DB"] = this._DB;
        data["_DBSQL"] = this._DBSQL;
        data["_Advanced"] = this._Advanced;
        return data; 
    }
}

export interface IFieldType {
    _ID?: number | undefined;
    _Name?: string | undefined;
    _DWName?: string | undefined;
    _OptionName?: string | undefined;
    _Sort?: number | undefined;
    _DB?: string | undefined;
    _DBSQL?: string | undefined;
    _Advanced?: boolean | undefined;
}

export class FieldOption implements IFieldOption {
    _cache?: FieldOptionCache | undefined;
    _fieldID?: string | undefined;
    _ID?: string | undefined;
    _Name?: string | undefined;
    _Value?: string | undefined;
    _IsDefault?: boolean | undefined;
    _Sort?: number | undefined;

    constructor(data?: IFieldOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._cache = _data["_cache"] ? FieldOptionCache.fromJS(_data["_cache"]) : <any>undefined;
            this._fieldID = _data["_fieldID"];
            this._ID = _data["_ID"];
            this._Name = _data["_Name"];
            this._Value = _data["_Value"];
            this._IsDefault = _data["_IsDefault"];
            this._Sort = _data["_Sort"];
        }
    }

    static fromJS(data: any): FieldOption {
        data = typeof data === 'object' ? data : {};
        let result = new FieldOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_cache"] = this._cache ? this._cache.toJSON() : <any>undefined;
        data["_fieldID"] = this._fieldID;
        data["_ID"] = this._ID;
        data["_Name"] = this._Name;
        data["_Value"] = this._Value;
        data["_IsDefault"] = this._IsDefault;
        data["_Sort"] = this._Sort;
        return data; 
    }
}

export interface IFieldOption {
    _cache?: FieldOptionCache | undefined;
    _fieldID?: string | undefined;
    _ID?: string | undefined;
    _Name?: string | undefined;
    _Value?: string | undefined;
    _IsDefault?: boolean | undefined;
    _Sort?: number | undefined;
}

export class PropertyFieldOption implements IPropertyFieldOption {
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _FieldID?: string | undefined;
    _Text?: string | undefined;

    constructor(data?: IPropertyFieldOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._ID = _data["_ID"];
            this._LanguageID = _data["_LanguageID"];
            this._FieldID = _data["_FieldID"];
            this._Text = _data["_Text"];
        }
    }

    static fromJS(data: any): PropertyFieldOption {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyFieldOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_ID"] = this._ID;
        data["_LanguageID"] = this._LanguageID;
        data["_FieldID"] = this._FieldID;
        data["_Text"] = this._Text;
        return data; 
    }
}

export interface IPropertyFieldOption {
    _ID?: string | undefined;
    _LanguageID?: string | undefined;
    _FieldID?: string | undefined;
    _Text?: string | undefined;
}

export class CustomField implements ICustomField {
    readonly systemName?: string | undefined;
    readonly tableName?: string | undefined;
    readonly type?: CustomFieldType | undefined;
    name?: string | undefined;
    options?: KeyValuePairOfStringAndObject[] | undefined;
    sort?: number | undefined;
    databaseName?: string | undefined;

    constructor(data?: ICustomField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).systemName = _data["SystemName"];
            (<any>this).tableName = _data["TableName"];
            (<any>this).type = _data["Type"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(KeyValuePairOfStringAndObject.fromJS(item));
            }
            this.sort = _data["Sort"];
            this.databaseName = _data["DatabaseName"];
        }
    }

    static fromJS(data: any): CustomField {
        data = typeof data === 'object' ? data : {};
        let result = new CustomField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SystemName"] = this.systemName;
        data["TableName"] = this.tableName;
        data["Type"] = this.type;
        data["Name"] = this.name;
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item.toJSON());
        }
        data["Sort"] = this.sort;
        data["DatabaseName"] = this.databaseName;
        return data; 
    }
}

export interface ICustomField {
    systemName?: string | undefined;
    tableName?: string | undefined;
    type?: CustomFieldType | undefined;
    name?: string | undefined;
    options?: KeyValuePairOfStringAndObject[] | undefined;
    sort?: number | undefined;
    databaseName?: string | undefined;
}

export class SystemField implements ISystemField {
    readonly systemName?: string | undefined;
    readonly tableName?: string | undefined;
    readonly type?: SystemFieldType | undefined;
    name?: string | undefined;
    options?: KeyValuePairOfStringAndObject[] | undefined;
    readonly isFrontendEditable?: boolean | undefined;

    constructor(data?: ISystemField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).systemName = _data["SystemName"];
            (<any>this).tableName = _data["TableName"];
            (<any>this).type = _data["Type"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(KeyValuePairOfStringAndObject.fromJS(item));
            }
            (<any>this).isFrontendEditable = _data["IsFrontendEditable"];
        }
    }

    static fromJS(data: any): SystemField {
        data = typeof data === 'object' ? data : {};
        let result = new SystemField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SystemName"] = this.systemName;
        data["TableName"] = this.tableName;
        data["Type"] = this.type;
        data["Name"] = this.name;
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item.toJSON());
        }
        data["IsFrontendEditable"] = this.isFrontendEditable;
        return data; 
    }
}

export interface ISystemField {
    systemName?: string | undefined;
    tableName?: string | undefined;
    type?: SystemFieldType | undefined;
    name?: string | undefined;
    options?: KeyValuePairOfStringAndObject[] | undefined;
    isFrontendEditable?: boolean | undefined;
}

export class CustomerProductListProduct implements ICustomerProductListProduct {
    listID?: number | undefined;
    productID?: string | undefined;
    productVariantID?: string | undefined;
    productLanguageID?: string | undefined;
    note?: string | undefined;
    productReferenceUrl?: string | undefined;
    quantity?: number | undefined;
    sortOrder?: number | undefined;
    iD?: number | undefined;
    readonly isNew?: boolean | undefined;

    constructor(data?: ICustomerProductListProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listID = _data["ListID"];
            this.productID = _data["ProductID"];
            this.productVariantID = _data["ProductVariantID"];
            this.productLanguageID = _data["ProductLanguageID"];
            this.note = _data["Note"];
            this.productReferenceUrl = _data["ProductReferenceUrl"];
            this.quantity = _data["Quantity"];
            this.sortOrder = _data["SortOrder"];
            this.iD = _data["ID"];
            (<any>this).isNew = _data["IsNew"];
        }
    }

    static fromJS(data: any): CustomerProductListProduct {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerProductListProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ListID"] = this.listID;
        data["ProductID"] = this.productID;
        data["ProductVariantID"] = this.productVariantID;
        data["ProductLanguageID"] = this.productLanguageID;
        data["Note"] = this.note;
        data["ProductReferenceUrl"] = this.productReferenceUrl;
        data["Quantity"] = this.quantity;
        data["SortOrder"] = this.sortOrder;
        data["ID"] = this.iD;
        data["IsNew"] = this.isNew;
        return data; 
    }
}

export interface ICustomerProductListProduct {
    listID?: number | undefined;
    productID?: string | undefined;
    productVariantID?: string | undefined;
    productLanguageID?: string | undefined;
    note?: string | undefined;
    productReferenceUrl?: string | undefined;
    quantity?: number | undefined;
    sortOrder?: number | undefined;
    iD?: number | undefined;
    isNew?: boolean | undefined;
}

export class CountryRelation implements ICountryRelation {
    _Code2?: string | undefined;
    _RegionCode?: string | undefined;
    _MethodType?: string | undefined;
    _CountryID?: string | undefined;
    _MethodID?: string | undefined;
    _LanguageID?: string | undefined;
    _IsDefault?: boolean | undefined;

    constructor(data?: ICountryRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._Code2 = _data["_Code2"];
            this._RegionCode = _data["_RegionCode"];
            this._MethodType = _data["_MethodType"];
            this._CountryID = _data["_CountryID"];
            this._MethodID = _data["_MethodID"];
            this._LanguageID = _data["_LanguageID"];
            this._IsDefault = _data["_IsDefault"];
        }
    }

    static fromJS(data: any): CountryRelation {
        data = typeof data === 'object' ? data : {};
        let result = new CountryRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_Code2"] = this._Code2;
        data["_RegionCode"] = this._RegionCode;
        data["_MethodType"] = this._MethodType;
        data["_CountryID"] = this._CountryID;
        data["_MethodID"] = this._MethodID;
        data["_LanguageID"] = this._LanguageID;
        data["_IsDefault"] = this._IsDefault;
        return data; 
    }
}

export interface ICountryRelation {
    _Code2?: string | undefined;
    _RegionCode?: string | undefined;
    _MethodType?: string | undefined;
    _CountryID?: string | undefined;
    _MethodID?: string | undefined;
    _LanguageID?: string | undefined;
    _IsDefault?: boolean | undefined;
}

export class FieldOptionCache implements IFieldOptionCache {

    constructor(data?: IFieldOptionCache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FieldOptionCache {
        data = typeof data === 'object' ? data : {};
        let result = new FieldOptionCache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IFieldOptionCache {
}

export class KeyValuePairOfStringAndObject implements IKeyValuePairOfStringAndObject {
    key?: string | undefined;
    value?: any | undefined;

    constructor(data?: IKeyValuePairOfStringAndObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndObject {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IKeyValuePairOfStringAndObject {
    key?: string | undefined;
    value?: any | undefined;
}

export class DataSource implements IDataSource {
    repository?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    provider?: string | undefined;

    constructor(data?: IDataSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repository = _data["Repository"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.provider = _data["Provider"];
        }
    }

    static fromJS(data: any): DataSource {
        data = typeof data === 'object' ? data : {};
        let result = new DataSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Repository"] = this.repository;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["Provider"] = this.provider;
        return data; 
    }
}

export interface IDataSource {
    repository?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    provider?: string | undefined;
}

export class DataModel implements IDataModel {
    fields?: DataField[] | undefined;
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;

    constructor(data?: IDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Fields"])) {
                this.fields = [] as any;
                for (let item of _data["Fields"])
                    this.fields!.push(DataField.fromJS(item));
            }
            this.name = _data["Name"];
            this.systemName = _data["SystemName"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): DataModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["Fields"] = [];
            for (let item of this.fields)
                data["Fields"].push(item.toJSON());
        }
        data["Name"] = this.name;
        data["SystemName"] = this.systemName;
        data["Type"] = this.type;
        return data; 
    }
}

export interface IDataModel {
    fields?: DataField[] | undefined;
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;
}

export class DataField implements IDataField {
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;

    constructor(data?: IDataField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.systemName = _data["SystemName"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): DataField {
        data = typeof data === 'object' ? data : {};
        let result = new DataField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["SystemName"] = this.systemName;
        data["Type"] = this.type;
        return data; 
    }
}

export interface IDataField {
    name?: string | undefined;
    systemName?: string | undefined;
    type?: string | undefined;
}

export class DataParameter implements IDataParameter {
    name?: string | undefined;
    type?: string | undefined;
    default?: any | undefined;

    constructor(data?: IDataParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.default = _data["Default"];
        }
    }

    static fromJS(data: any): DataParameter {
        data = typeof data === 'object' ? data : {};
        let result = new DataParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["Default"] = this.default;
        return data; 
    }
}

export interface IDataParameter {
    name?: string | undefined;
    type?: string | undefined;
    default?: any | undefined;
}

export class ActionStatusViewModel implements IActionStatusViewModel {
    isSuccess?: boolean | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;

    constructor(data?: IActionStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["IsSuccess"];
            this.message = _data["Message"];
            if (Array.isArray(_data["Errors"])) {
                this.errors = [] as any;
                for (let item of _data["Errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): ActionStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActionStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsSuccess"] = this.isSuccess;
        data["Message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }
}

export interface IActionStatusViewModel {
    isSuccess?: boolean | undefined;
    message?: string | undefined;
    errors?: string[] | undefined;
}

export class DWUserViewModel implements IDWUserViewModel {
    shopIdentifier?: string | undefined;
    name?: string | undefined;
    customerNumber?: string | undefined;
    extraInfo?: { [key: string]: any; } | undefined;
    roles?: string[] | undefined;
    token?: string | undefined;
    tokenExpiration?: Date | undefined;
    email?: string | undefined;

    constructor(data?: IDWUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shopIdentifier = _data["ShopIdentifier"];
            this.name = _data["Name"];
            this.customerNumber = _data["CustomerNumber"];
            if (_data["ExtraInfo"]) {
                this.extraInfo = {} as any;
                for (let key in _data["ExtraInfo"]) {
                    if (_data["ExtraInfo"].hasOwnProperty(key))
                        this.extraInfo![key] = _data["ExtraInfo"][key];
                }
            }
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as any;
                for (let item of _data["Roles"])
                    this.roles!.push(item);
            }
            this.token = _data["Token"];
            this.tokenExpiration = _data["TokenExpiration"] ? new Date(_data["TokenExpiration"].toString()) : <any>undefined;
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): DWUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DWUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ShopIdentifier"] = this.shopIdentifier;
        data["Name"] = this.name;
        data["CustomerNumber"] = this.customerNumber;
        if (this.extraInfo) {
            data["ExtraInfo"] = {};
            for (let key in this.extraInfo) {
                if (this.extraInfo.hasOwnProperty(key))
                    data["ExtraInfo"][key] = this.extraInfo[key];
            }
        }
        if (Array.isArray(this.roles)) {
            data["Roles"] = [];
            for (let item of this.roles)
                data["Roles"].push(item);
        }
        data["Token"] = this.token;
        data["TokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : <any>undefined;
        data["Email"] = this.email;
        return data; 
    }
}

export interface IDWUserViewModel {
    shopIdentifier?: string | undefined;
    name?: string | undefined;
    customerNumber?: string | undefined;
    extraInfo?: { [key: string]: any; } | undefined;
    roles?: string[] | undefined;
    token?: string | undefined;
    tokenExpiration?: Date | undefined;
    email?: string | undefined;
}

export class EditCustomerViewModel implements IEditCustomerViewModel {
    userName!: string;
    companyName!: string;
    address!: string;
    address2?: string | undefined;
    zip!: string;
    city!: string;
    phone!: string;
    email!: string;
    dataMagazineEmail!: string;
    invoiceEmail!: string;
    invoiceConfirmationEmail!: string;

    constructor(data?: IEditCustomerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.companyName = _data["CompanyName"];
            this.address = _data["Address"];
            this.address2 = _data["Address2"];
            this.zip = _data["Zip"];
            this.city = _data["City"];
            this.phone = _data["Phone"];
            this.email = _data["Email"];
            this.dataMagazineEmail = _data["DataMagazineEmail"];
            this.invoiceEmail = _data["InvoiceEmail"];
            this.invoiceConfirmationEmail = _data["InvoiceConfirmationEmail"];
        }
    }

    static fromJS(data: any): EditCustomerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditCustomerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["CompanyName"] = this.companyName;
        data["Address"] = this.address;
        data["Address2"] = this.address2;
        data["Zip"] = this.zip;
        data["City"] = this.city;
        data["Phone"] = this.phone;
        data["Email"] = this.email;
        data["DataMagazineEmail"] = this.dataMagazineEmail;
        data["InvoiceEmail"] = this.invoiceEmail;
        data["InvoiceConfirmationEmail"] = this.invoiceConfirmationEmail;
        return data; 
    }
}

export interface IEditCustomerViewModel {
    userName: string;
    companyName: string;
    address: string;
    address2?: string | undefined;
    zip: string;
    city: string;
    phone: string;
    email: string;
    dataMagazineEmail: string;
    invoiceEmail: string;
    invoiceConfirmationEmail: string;
}

export enum Type {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum SortInfoSortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export enum Product_Type {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum Product_PriceType {
    _0 = 0,
    _1 = 1,
    _3 = 3,
}

export enum Discount_Type {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum UserPermission_dataPresence {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum GroupFilterExecutionSettings_PagedQueries {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum User_type {
    _1 = 1,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _15 = 15,
}

export enum IDbConnectionState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
}

export enum IDbTransactionIsolationLevel {
    _16 = 16,
    _256 = 256,
    _4096 = 4096,
    _65536 = 65536,
    _1048576 = 1048576,
    _16777216 = 16777216,
    __1 = -1,
}

export enum ProductField_ListPresentationType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum ProductGroupField_ListPresentationType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum Field_presentationType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum ModulePermissionAccess {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ModulePermissionCreate {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ModulePermissionEdit {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ModulePermissionDelete {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CustomFieldType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export enum SystemFieldType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}